import { createAsyncThunk, createSlice, createSelector, addListener, createAction } from '@reduxjs/toolkit';
import { testUntilSuccess, castsToCurrency, getRequiredAmountOfCastsWithoutBonus, sessionStorageEntry, textToDate, externalFlow, decodeJwtToken, secondsToDays, dateToRelativeString, localStorageEntry, daysBetween } from '@content-technology-partners-ltd/shared-util';
import { CardNumberElement, useStripe, PaymentRequestButtonElement, Elements, CardExpiryElement, CardCvcElement, useElements } from '@stripe/react-stripe-js';
import { getEndpointData, mediaApi, createPayment, useGetMeWalletQuery, EmailValidity, authLoginAction, authSignupAction, authVerifyAction, authResendVerifyCodeAction, authResetPasswordAction, authValidateEmailAction, updateTokens, profileApi, PublisherDataShareScopes, isUserLoggedIn, VideoListingReplayStatus, VideoListingLiveDetailsStatus, publicApi, VideoListingTypes, purchaseApi, hrefContainsId, inventoryApi, MarketingConsentType } from '@content-technology-partners-ltd/shared-data-access';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { ModalHeader, FormikCastValue, FormikQuickCastSelect, ModalButton, CastValue, InputBox, LoadingButton, CastOdometer, NotificationModal, ExternalLink, Modal, ModalContent, ModalActions, Comment, CommentOptions, CommentInput, CastCreditProgress, ReplayIsProcessingModal, LiveEventEndedModal, Image, FormikCheckbox, Checkbox, Ticket, ModalUnsupportedRegion, ModalLoader, Avatar, SocialLoginButton, InternalLink, FormikFormInput, FormikFormPasswordInput, FormikFormApiErrorText, FieldPrompt, FormikFormCodeInput, ModalTextBox, ModalAlert, Colors, SwipeScroll, typography, Radio as Radio$1, Button as Button$1, accountTheme } from '@content-technology-partners-ltd/shared-ui';
import { Padlock, Warning, ChannelPass as ChannelPass$1, RecastR, ThreeCasts, EventCalendar, CastCredit, RecastText, Cross, Flag, Share as Share$1 } from '@content-technology-partners-ltd/shared-icon';
import { useTranslation, Trans } from 'react-i18next';
import { Form, Formik, useField } from 'formik';
import { styled, Stack, Divider as Divider$1, Typography, Button, Box, useTheme, InputLabel, FormControl, FormHelperText, List, Icon, Radio, FormControlLabel, capitalize, useMediaQuery, CircularProgress, RadioGroup, Checkbox as Checkbox$1, ListItem, ListItemButton, ListItemAvatar, Avatar as Avatar$1, ListItemText, Link, ThemeProvider, CssBaseline } from '@mui/material';
import { PaymentLockupGrey, SuccessCasty, ChannelPassEmptyInset } from '@content-technology-partners-ltd/shared-image';
import { z } from 'zod';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { useDebounced, useDateLocale, useRecaptcha } from '@content-technology-partners-ltd/hooks';
import { addSeconds, isAfter, isBefore, isFuture, isToday, format } from 'date-fns';
import { useChannelStateContext, MessageList, Chat, Channel, Window, MessageInput } from 'stream-chat-react';
import { NimblePicker } from 'emoji-mart';
import { StreamChat } from 'stream-chat';
import dayjs from 'dayjs';
import isToday$1 from 'dayjs/plugin/isToday';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import Chart from 'chart.js/auto';
import * as ChartGeo from 'chartjs-chart-geo';
import { BubbleMapController, BubbleMapChart, GeoFeature, ColorScale, ProjectionScale, SizeScale } from 'chartjs-chart-geo';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Bar, Doughnut } from 'react-chartjs-2';
import { Chart as Chart$1, BarElement, CategoryScale, LinearScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Icon$1 from '@mui/material/Icon';
import { FileCopy } from '@mui/icons-material';

var initialState$4 = {
    step: "",
    entry: "",
    minCastCredits: 0,
    defaultCastCredits: 0,
    missingCastCredits: 0,
    paymentType: "",
    currency: "",
    castCredits: 0,
    price: 0,
    isPaymentPending: false,
    isStandalone: true
};

function asyncGeneratorStep$j(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$j(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$j(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$j(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property$q(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$l(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$q(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$b(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$b(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$b(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator$j(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var initTopUpAction = createAsyncThunk("topUp/init", function() {
    var _ref = _async_to_generator$j(function(args, param) {
        var dispatch, balance;
        return _ts_generator$j(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch = param.dispatch;
                    return [
                        4,
                        dispatch(getEndpointData(mediaApi.endpoints.getMeWallet))
                    ];
                case 1:
                    balance = _state.sent().balance;
                    dispatch(addCasts(_object_spread_props$b(_object_spread$l({}, args), {
                        balanceBeforePayment: balance.units
                    })));
                    return [
                        2
                    ];
            }
        });
    });
    return function(args, _) {
        return _ref.apply(this, arguments);
    };
}());
var waitForBalanceIncreaseAction = createAsyncThunk("topUp/waitForBalanceIncrease", function() {
    var _ref = _async_to_generator$j(function(_, param) {
        var dispatch, getState, topUp, _topUp_balanceBeforePayment, balanceBeforePayment;
        return _ts_generator$j(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch = param.dispatch, getState = param.getState;
                    topUp = getState().topUp;
                    balanceBeforePayment = (_topUp_balanceBeforePayment = topUp.balanceBeforePayment) !== null && _topUp_balanceBeforePayment !== void 0 ? _topUp_balanceBeforePayment : 0;
                    return [
                        4,
                        testUntilSuccess(/*#__PURE__*/ _async_to_generator$j(function() {
                            var balance;
                            return _ts_generator$j(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            dispatch(getEndpointData(mediaApi.endpoints.getMeWallet, undefined, {
                                                forceRefetch: true
                                            }))
                                        ];
                                    case 1:
                                        balance = _state.sent().balance;
                                        return [
                                            2,
                                            balance.units > balanceBeforePayment
                                        ];
                                }
                            });
                        }), {
                            initialMsDelay: 1000,
                            msDelay: 5000,
                            msTimeout: 40000
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());

function asyncGeneratorStep$i(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$i(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$i(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$i(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$i(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function processPaymentRequestInStripe(stripe, clientSecret, event) {
    return _processPaymentRequestInStripe.apply(this, arguments);
}
function _processPaymentRequestInStripe() {
    _processPaymentRequestInStripe = _async_to_generator$i(function(stripe, clientSecret, event) {
        var result, secondResult;
        return _ts_generator$i(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        stripe.confirmCardPayment(clientSecret, {
                            payment_method: event.paymentMethod.id
                        }, {
                            handleActions: false
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if (result.error) {
                        throw new Error(result.error.message);
                    }
                    if (!(result.paymentIntent.status === "requires_action")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        stripe.confirmCardPayment(clientSecret)
                    ];
                case 2:
                    secondResult = _state.sent();
                    if (secondResult.error) {
                        throw new Error(secondResult.error.message);
                    }
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _processPaymentRequestInStripe.apply(this, arguments);
}
var paymentRequestAction = createAsyncThunk("topUp/paymentRequest", function() {
    var _ref = _async_to_generator$i(function(param, param1) {
        var event, paymentConfig, stripe, getState, dispatch, _getState, state, paymentCreateConfig, clientSecret, error;
        return _ts_generator$i(this, function(_state) {
            switch(_state.label){
                case 0:
                    event = param.event, paymentConfig = param.paymentConfig, stripe = param.stripe, getState = param1.getState, dispatch = param1.dispatch;
                    _getState = getState(), state = _getState.topUp;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        dispatch(createPayment(+(castsToCurrency(state.price, paymentConfig) * 100).toFixed(0), paymentConfig.paymentCurrency, state.castCredits))
                    ];
                case 2:
                    paymentCreateConfig = _state.sent();
                    clientSecret = paymentCreateConfig.clientSecret;
                    return [
                        4,
                        processPaymentRequestInStripe(stripe, clientSecret, event)
                    ];
                case 3:
                    _state.sent();
                    event.complete("success");
                    dispatch(waitForBalanceIncreaseAction());
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    event.complete("fail");
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var cardPaymentAction = createAsyncThunk("topUp/cardPayment", function() {
    var _ref = _async_to_generator$i(function(param, param1) {
        var stripe, elements, paymentConfig, getState, dispatch, rejectWithValue, card, _getState, state, paymentCreateConfig, clientSecret, stripeResult;
        return _ts_generator$i(this, function(_state) {
            switch(_state.label){
                case 0:
                    stripe = param.stripe, elements = param.elements, paymentConfig = param.paymentConfig, getState = param1.getState, dispatch = param1.dispatch, rejectWithValue = param1.rejectWithValue;
                    card = elements.getElement(CardNumberElement);
                    if (!card) {
                        throw new Error("Card element not found");
                    }
                    _getState = getState(), state = _getState.topUp;
                    return [
                        4,
                        dispatch(createPayment(+(castsToCurrency(state.price, paymentConfig) * 100).toFixed(0), paymentConfig.paymentCurrency, state.castCredits))
                    ];
                case 1:
                    paymentCreateConfig = _state.sent();
                    clientSecret = paymentCreateConfig.clientSecret;
                    if (!clientSecret) {
                        throw new Error("Empty payment client secret");
                    }
                    return [
                        4,
                        stripe.confirmCardPayment(clientSecret, {
                            payment_method: {
                                card: card
                            }
                        })
                    ];
                case 2:
                    stripeResult = _state.sent();
                    if (stripeResult.error) {
                        return [
                            2,
                            rejectWithValue(stripeResult.error)
                        ];
                    }
                    dispatch(waitForBalanceIncreaseAction());
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());

var walletNameToPaymentType = function(walletName) {
    switch(walletName){
        case "googlePay":
            return "google pay";
        case "applePay":
            return "apple pay";
        case "linkPay":
            return "link pay";
        default:
            return "";
    }
};
var isCreditCardPayment = function(state) {
    return state.step === "make-payment" && state.paymentType === "credit card";
};
var topUpSlice = createSlice({
    name: "topUp",
    initialState: initialState$4,
    reducers: {
        addCasts: function(state, action) {
            if (state.step === "") {
                state.step = "select-amount";
                state.entry = action.payload.entry;
                state.minCastCredits = action.payload.minCastCredits;
                state.defaultCastCredits = action.payload.defaultCastCredits;
                state.balanceBeforePayment = action.payload.balanceBeforePayment;
                var _action_payload_missingCastCredits;
                state.missingCastCredits = (_action_payload_missingCastCredits = action.payload.missingCastCredits) !== null && _action_payload_missingCastCredits !== void 0 ? _action_payload_missingCastCredits : 0;
                state.isStandalone = action.payload.isStandalone;
            }
        },
        selectAmount: function(state, action) {
            if (state.step === "select-amount") {
                state.step = "select-payment-method";
                state.price = action.payload.amount;
                state.castCredits = action.payload.casts;
            }
        },
        selectPaymentType: function(state, action) {
            if (state.step === "select-payment-method") {
                state.step = "make-payment";
                state.paymentType = action.payload;
            }
        },
        makePayment: function(state) {
            // TODO(mk): do payment stuff
            if (state.step === "make-payment") {
                state.step = "wallet-updated";
            }
        },
        complete: function(state) {
            if (state.step === "wallet-updated") {
                return initialState$4;
            }
            return state;
        },
        back: function(state) {
            if (state.step === "select-payment-method") {
                state.step = "select-amount";
            } else if (state.step === "make-payment") {
                state.step = "select-payment-method";
                state.paymentError = undefined;
                state.paymentType = "";
            }
        },
        exit: function() {
            return initialState$4;
        }
    },
    extraReducers: function(builder) {
        return builder.addCase(paymentRequestAction.pending, function(state, action) {
            if (state.step === "select-payment-method") {
                state.isPaymentPending = true;
                state.paymentType = walletNameToPaymentType(action.meta.arg.event.walletName);
            }
        }).addCase(paymentRequestAction.rejected, function(state, action) {
            if (state.step === "select-payment-method") {
                state.isPaymentPending = false;
                state.paymentError = action.error.message;
            }
        }).addCase(cardPaymentAction.pending, function(state) {
            if (isCreditCardPayment(state)) {
                state.isPaymentPending = true;
            }
        }).addCase(cardPaymentAction.rejected, function(state, action) {
            if (!isCreditCardPayment(state)) return;
            if (action.payload) {
                var payload = action.payload;
                state.isPaymentPending = false;
                state.paymentError = "Oh no - there seems to have been a problem processing your payment. Please try again and if this persists please drop us an email on helpme@recast.tv";
                if (payload.type === "card_error" || payload.type === "validation_error") {
                    state.paymentError = payload.message;
                }
            } else {
                state.isPaymentPending = false;
                state.paymentError = action.error.message;
            }
        }).addCase(waitForBalanceIncreaseAction.fulfilled, function(state) {
            state.isPaymentPending = false;
            state.step = "wallet-updated";
        }).addCase(waitForBalanceIncreaseAction.rejected, function(state) {
            state.isPaymentPending = false;
            state.step = "payment-timed-out";
        });
    }
});
var _topUpSlice_actions = topUpSlice.actions;
var addCasts = _topUpSlice_actions.addCasts, selectAmount = _topUpSlice_actions.selectAmount, selectPaymentType = _topUpSlice_actions.selectPaymentType; _topUpSlice_actions.makePayment; var exit$5 = _topUpSlice_actions.exit, back = _topUpSlice_actions.back, complete = _topUpSlice_actions.complete;
topUpSlice.reducer;
topUpSlice.reducer;

var getTitleAndSubtitle = function(step, t) {
    switch(step){
        case "select-amount":
            return {
                title: t("components.topUp.header.buyCastCredits", "Buy Cast Credits"),
                subtitle: t("components.topUp.header.enterAmount", "Enter the amount you would like to buy")
            };
        case "select-payment-method":
        case "make-payment":
            return {
                title: t("components.topUp.header.buyCastCredits", "Buy Cast Credits"),
                subtitle: t("components.topUp.header.youAreAboutToBuy", "You are about to buy")
            };
        case "wallet-updated":
            return {
                title: t("components.topUp.header.done", "Done"),
                subtitle: t("components.topUp.header.weveNowAddedYourCastCredits", "Your wallet balance has now been updated.")
            };
    }
};
var TopUpHeader = function(param) {
    var step = param.step;
    var t = useTranslation().t;
    var _getTitleAndSubtitle = getTitleAndSubtitle(step, t), title = _getTitleAndSubtitle.title, subtitle = _getTitleAndSubtitle.subtitle;
    return /*#__PURE__*/ jsx(ModalHeader, {
        icon: /*#__PURE__*/ jsx(Padlock, {
            fontSize: 64,
            color: "#1E211D"
        }),
        titleProps: {
            sx: {
                fontSize: "18px"
            }
        },
        title: title,
        subtitle: subtitle
    });
};

var StyledForm = styled(Form)({
    width: "100%"
});
var getInitialValues = function(state, paymentConfig) {
    return {
        casts: state.castCredits || Math.max(state.defaultCastCredits, state.entry === "low casts" ? getRequiredAmountOfCastsWithoutBonus(state.missingCastCredits, paymentConfig) : 0)
    };
};
function getTopUpValidationSchema(t, minCasts) {
    var validationSchema = z.object({
        casts: z.number().min(minCasts, t("components.topUp.errors.minCasts", "Minimum {{min}} Cast Credits", {
            min: minCasts
        }))
    });
    return toFormikValidationSchema(validationSchema);
}
function TopUpSelectAmount(param) {
    var state = param.state, paymentConfig = param.paymentConfig, dispatch = param.dispatch, onTrack = param.onTrack;
    var t = useTranslation().t;
    var validationSchema = getTopUpValidationSchema(t, state.minCastCredits);
    return /*#__PURE__*/ jsx(Formik, {
        initialValues: getInitialValues(state, paymentConfig),
        initialTouched: {
            casts: true
        },
        onSubmit: function(param) {
            var casts = param.casts;
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "top-up",
                action: "click",
                label: "select-amount-top-up-now"
            }));
            return dispatch(selectAmount({
                casts: casts,
                amount: casts
            }));
        },
        validationSchema: validationSchema,
        children: /*#__PURE__*/ jsx(StyledForm, {
            children: /*#__PURE__*/ jsxs(Stack, {
                alignItems: "center",
                gap: "12px",
                width: "100%",
                children: [
                    /*#__PURE__*/ jsx(FormikCastValue, {
                        name: "casts",
                        paymentConfig: paymentConfig,
                        delta: 100
                    }),
                    /*#__PURE__*/ jsx(Divider$1, {
                        sx: {
                            width: "100%",
                            marginTop: "5px"
                        }
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "body2",
                        children: t("components.topUp.selectAmount.orChooseAmount", "Or choose amount")
                    }),
                    /*#__PURE__*/ jsx(FormikQuickCastSelect, {
                        name: "casts",
                        paymentConfig: paymentConfig,
                        sx: {
                            width: "100%"
                        },
                        limit: 3
                    }),
                    /*#__PURE__*/ jsx(Button, {
                        fullWidth: true,
                        type: "submit",
                        children: t("components.topUp.selectAmount.topUpNow", "Top up now!")
                    }),
                    /*#__PURE__*/ jsx(PaymentLockupGrey, {})
                ]
            })
        })
    });
}

function TopUpBottomAction(param) {
    var state = param.state, dispatch = param.dispatch;
    var t = useTranslation().t;
    switch(state.step){
        case "select-amount":
            return /*#__PURE__*/ jsx(ModalButton, {
                onClick: function() {
                    return dispatch(exit$5());
                },
                children: t("components.topUp.bottomAction.notNow", "Not now")
            });
        case "select-payment-method":
        case "make-payment":
            return /*#__PURE__*/ jsx(ModalButton, {
                onClick: function() {
                    return dispatch(back());
                },
                children: t("components.topUp.bottomAction.back", "Back")
            });
        case "wallet-updated":
            return /*#__PURE__*/ jsx(ModalButton, {
                onClick: function() {
                    return dispatch(complete());
                },
                children: state.isStandalone ? t("components.topUp.bottomAction.close", "Close") : t("components.topUp.bottomAction.continue", "Continue")
            });
        default:
            return null;
    }
}

function _array_like_to_array$g(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$e(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep$h(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$h(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$h(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$h(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit$e(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$e() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$e(arr, i) {
    return _array_with_holes$e(arr) || _iterable_to_array_limit$e(arr, i) || _unsupported_iterable_to_array$g(arr, i) || _non_iterable_rest$e();
}
function _unsupported_iterable_to_array$g(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$g(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$g(o, minLen);
}
function _ts_generator$h(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var PaymentRequestButton = function(param) {
    var state = param.state, dispatch = param.dispatch, paymentConfig = param.paymentConfig, onTrack = param.onTrack;
    var stripe = useStripe();
    var castCredits = state.castCredits;
    var _useState = _sliced_to_array$e(useState(), 2), paymentRequest = _useState[0], setPaymentRequest = _useState[1];
    var isLoading = useRef(false);
    useEffect(function() {
        if (stripe && paymentRequest) {
            var paymentHandler = function() {
                var _ref = _async_to_generator$h(function(event) {
                    return _ts_generator$h(this, function(_state) {
                        return [
                            2,
                            dispatch(paymentRequestAction({
                                event: event,
                                paymentConfig: paymentConfig,
                                stripe: stripe
                            }))
                        ];
                    });
                });
                return function paymentHandler(event) {
                    return _ref.apply(this, arguments);
                };
            }();
            paymentRequest.on("paymentmethod", paymentHandler);
            return function() {
                paymentRequest.off("paymentmethod", paymentHandler);
            };
        }
        return;
    }, [
        dispatch,
        paymentConfig,
        paymentRequest,
        stripe
    ]);
    useEffect(function() {
        if (!isLoading.current && stripe) {
            isLoading.current = true;
            var paymentRequest = stripe.paymentRequest({
                country: "GB",
                currency: paymentConfig.paymentCurrency.toLocaleLowerCase(),
                total: {
                    label: "Total",
                    amount: +(castsToCurrency(castCredits, paymentConfig) * 100).toFixed(0)
                },
                requestPayerName: true,
                requestPayerEmail: true
            });
            paymentRequest.canMakePayment().then(function(result) {
                if (result) {
                    setPaymentRequest(paymentRequest);
                }
            }).finally(function() {
                isLoading.current = false;
            });
        }
    }, [
        castCredits,
        paymentConfig,
        stripe
    ]);
    if (!(stripe && paymentRequest)) {
        return null;
    }
    return /*#__PURE__*/ jsx(Box, {
        sx: {
            boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 1px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
            borderRadius: "4px"
        },
        children: /*#__PURE__*/ jsx(PaymentRequestButtonElement, {
            options: {
                paymentRequest: paymentRequest,
                style: {
                    paymentRequestButton: {
                        theme: "light"
                    }
                }
            },
            onClick: function() {
                void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                    category: "top-up",
                    action: "click",
                    label: "select-payment-method-payment-request-stripe"
                }));
            }
        })
    });
};

function TopUpPaymentMethod(param) {
    var paymentConfig = param.paymentConfig, state = param.state, dispatch = param.dispatch, onTrack = param.onTrack;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Stack, {
        alignItems: "center",
        gap: "12px",
        height: "100%",
        children: [
            /*#__PURE__*/ jsx(CastValue, {
                value: state.castCredits,
                paymentConfig: paymentConfig,
                uneditable: true
            }),
            /*#__PURE__*/ jsx(Divider$1, {
                sx: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                children: t("components.topUp.paymentMethod.choosePaymentMethod", "Choose payment method")
            }),
            /*#__PURE__*/ jsxs(Stack, {
                gap: "8px",
                width: "100%",
                flexGrow: 1,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ jsx(Button, {
                        fullWidth: true,
                        onClick: function() {
                            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                category: "top-up",
                                action: "click",
                                label: "select-payment-method-credit-card"
                            }));
                            return dispatch(selectPaymentType("credit card"));
                        },
                        children: t("components.topUp.paymentMethod.creditCard", "Credit card")
                    }),
                    /*#__PURE__*/ jsx(PaymentRequestButton, {
                        state: state,
                        paymentConfig: paymentConfig,
                        dispatch: dispatch
                    })
                ]
            }),
            /*#__PURE__*/ jsx(PaymentLockupGrey, {})
        ]
    });
}

function _array_like_to_array$f(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$d(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$d(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$d() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$d(arr, i) {
    return _array_with_holes$d(arr) || _iterable_to_array_limit$d(arr, i) || _unsupported_iterable_to_array$f(arr, i) || _non_iterable_rest$d();
}
function _unsupported_iterable_to_array$f(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$f(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$f(o, minLen);
}
var StripeProvider = function(param) {
    var children = param.children, publishableKey = param.publishableKey;
    var _useState = _sliced_to_array$d(useState(null), 2), stripe = _useState[0], setStripe = _useState[1];
    var isLoading = useRef(false);
    useEffect(function() {
        if (!isLoading.current && publishableKey) {
            isLoading.current = true;
            loadStripe(publishableKey).then(function(stripe) {
                return stripe && setStripe(stripe);
            }).finally(function() {
                isLoading.current = false;
            });
        }
    }, [
        publishableKey
    ]);
    return /*#__PURE__*/ jsx(Elements, {
        stripe: stripe,
        children: children
    });
};

function _array_like_to_array$e(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$c(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$p(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$c(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$c() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$k(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$p(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$a(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$a(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$a(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array$c(arr, i) {
    return _array_with_holes$c(arr) || _iterable_to_array_limit$c(arr, i) || _unsupported_iterable_to_array$e(arr, i) || _non_iterable_rest$c();
}
function _unsupported_iterable_to_array$e(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$e(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$e(o, minLen);
}
var CardInput = function(param) {
    var id = param.id, label = param.label, Element = param.Element, placeholder = param.placeholder, onFocus = param.onFocus;
    var _useState = _sliced_to_array$c(useState(), 2), error = _useState[0], setError = _useState[1];
    var theme = useTheme();
    return /*#__PURE__*/ jsxs(Stack, {
        gap: "4px",
        children: [
            /*#__PURE__*/ jsx(InputLabel, {
                htmlFor: id,
                sx: {
                    textAlign: "center",
                    fontSize: "11px"
                },
                children: label
            }),
            /*#__PURE__*/ jsxs(FormControl, {
                size: "small",
                variant: "filled",
                error: !!error,
                fullWidth: true,
                children: [
                    /*#__PURE__*/ jsx(InputBox, {
                        sx: {
                            height: "36px",
                            "&>.StripeElement": {
                                flexGrow: 1,
                                padding: "9px 12px"
                            }
                        },
                        children: /*#__PURE__*/ jsx(Element, {
                            id: id,
                            onFocus: onFocus,
                            onChange: function(e) {
                                var _e_error;
                                return setError((_e_error = e.error) === null || _e_error === void 0 ? void 0 : _e_error.message);
                            },
                            options: {
                                style: {
                                    base: {
                                        color: theme.palette.primary.contrastText,
                                        textAlign: "center",
                                        "::placeholder": {
                                            color: theme.palette.grey[500]
                                        }
                                    },
                                    invalid: {
                                        color: theme.palette.error.main
                                    }
                                },
                                placeholder: placeholder
                            }
                        })
                    }),
                    /*#__PURE__*/ jsx(FormHelperText, {
                        sx: {
                            margin: "0px"
                        },
                        children: error
                    })
                ]
            })
        ]
    });
};
var CardNumber = function(props) {
    return /*#__PURE__*/ jsx(CardInput, _object_spread_props$a(_object_spread$k({}, props), {
        Element: CardNumberElement,
        placeholder: "XXXX - XXXX - XXXX - XXXX"
    }));
};
var CardExpiry = function(props) {
    return /*#__PURE__*/ jsx(CardInput, _object_spread_props$a(_object_spread$k({}, props), {
        Element: CardExpiryElement,
        placeholder: "MM/YY"
    }));
};
var CardCvc = function(props) {
    return /*#__PURE__*/ jsx(CardInput, _object_spread_props$a(_object_spread$k({}, props), {
        Element: CardCvcElement,
        placeholder: "CVC"
    }));
};

var useCardPaymentAction = function(paymentConfig) {
    var stripe = useStripe();
    var elements = useElements();
    return stripe && elements ? function() {
        return cardPaymentAction({
            stripe: stripe,
            elements: elements,
            paymentConfig: paymentConfig
        });
    } : undefined;
};

function asyncGeneratorStep$g(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$g(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$g(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$g(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$g(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var FormGrid = styled(Box)({
    display: "grid",
    gap: "8px",
    gridTemplate: '"cn cn" "exp cvc"',
    gridTemplateColumns: "1fr 1fr",
    width: "100%"
});
function TopUpMakePaymentCreditCard(param) {
    var dispatch = param.dispatch, paymentConfig = param.paymentConfig, state = param.state, onTrack = param.onTrack;
    var t = useTranslation().t;
    var submitPayment = useCardPaymentAction(paymentConfig);
    var focusTracking = useDebounced(function() {
        var _ref = _async_to_generator$g(function(input) {
            return _ts_generator$g(this, function(_state) {
                onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                    category: "top-up",
                    action: "type",
                    label: "make-payment-card-details-".concat(input)
                });
                return [
                    2
                ];
            });
        });
        return function(input) {
            return _ref.apply(this, arguments);
        };
    }(), 300);
    return /*#__PURE__*/ jsxs(Stack, {
        alignItems: "center",
        gap: "12px",
        height: "100%",
        children: [
            /*#__PURE__*/ jsx(CastValue, {
                value: state.castCredits,
                paymentConfig: paymentConfig,
                uneditable: true
            }),
            /*#__PURE__*/ jsx(Divider$1, {
                sx: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                children: t("components.topUp.makePayment.fillIn", "Fill in your details")
            }),
            /*#__PURE__*/ jsxs(FormGrid, {
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        gridArea: "cn",
                        children: /*#__PURE__*/ jsx(CardNumber, {
                            id: "cardNumber",
                            label: t("components.topUp.makePayment.cardNumber", "Card Number"),
                            onFocus: function() {
                                return focusTracking("card-number");
                            }
                        })
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        gridArea: "exp",
                        children: /*#__PURE__*/ jsx(CardExpiry, {
                            id: "cardExpiry",
                            label: t("components.topUp.makePayment.expDate", "EXP Date"),
                            onFocus: function() {
                                return focusTracking("expiry");
                            }
                        })
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        gridArea: "cvc",
                        children: /*#__PURE__*/ jsx(CardCvc, {
                            id: "cardCvc",
                            label: t("components.topUp.makePayment.cvc", "CVC"),
                            onFocus: function() {
                                return focusTracking("cvc");
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ jsx(LoadingButton, {
                fullWidth: true,
                onClick: function() {
                    void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                        category: "top-up",
                        action: "click",
                        label: "make-payment-complete-transaction"
                    }));
                    return submitPayment && dispatch(submitPayment());
                },
                loading: state.isPaymentPending,
                children: state.isPaymentPending ? t("components.topUp.makePayment.processing", "Processing") : t("components.topUp.makePayment.complete", "Complete transaction")
            }),
            /*#__PURE__*/ jsx(FormHelperText, {
                sx: {
                    margin: "0px"
                },
                error: true,
                children: state.paymentError
            }),
            /*#__PURE__*/ jsx(PaymentLockupGrey, {})
        ]
    });
}

var CastBox = styled(Box)(function(param) {
    var theme = param.theme;
    return {
        border: "1px dashed ".concat(theme.palette.primary.main),
        borderRadius: "4px",
        marginTop: "32px",
        padding: "36px 14px"
    };
});
function TopUpWalletUpdated() {
    var data = useGetMeWalletQuery(undefined).data;
    var _data_balance_units;
    return /*#__PURE__*/ jsx(Stack, {
        gap: "16px",
        children: /*#__PURE__*/ jsx(CastBox, {
            children: /*#__PURE__*/ jsx(CastOdometer, {
                value: (_data_balance_units = data === null || data === void 0 ? void 0 : data.balance.units) !== null && _data_balance_units !== void 0 ? _data_balance_units : 0,
                maxFontSize: 132
            })
        })
    });
}

function TopUpPaymentTimedOut(param) {
    var dispatch = param.dispatch, config = param.config;
    var supportEmail = config.supportEmail;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(NotificationModal, {
        title: t("components.topUp.topUpPaymentTimedOut.title", "Something went wrong"),
        icon: Warning,
        description: /*#__PURE__*/ jsx(Trans, {
            i18nKey: "components.topUp.topUpPaymentTimedOut.description",
            defaults: "It seems to be taking longer than usual to confirm the transaction from your payment provider. Your wallet may update soon, but if it doesn’t please contact us on <Email>{{supportEmail}}</Email>.",
            values: {
                supportEmail: supportEmail
            },
            components: {
                Email: /*#__PURE__*/ jsx(ExternalLink, {
                    href: "mailto:".concat(supportEmail)
                })
            }
        }),
        onClose: function() {
            return dispatch(exit$5());
        },
        confirmLabel: t("components.topUp.topUpPaymentTimedOut.close", "Close"),
        onConfirm: function() {
            return dispatch(exit$5());
        }
    });
}

var StepComponentMap$2 = new Map([
    [
        "select-amount",
        TopUpSelectAmount
    ],
    [
        "select-payment-method",
        TopUpPaymentMethod
    ],
    [
        "make-payment",
        TopUpMakePaymentCreditCard
    ],
    [
        "wallet-updated",
        TopUpWalletUpdated
    ]
]);
function TopUp(props) {
    var state = props.state, paymentConfig = props.paymentConfig, dispatch = props.dispatch, stripePublishableKey = props.stripePublishableKey, config = props.config, onTrack = props.onTrack;
    useEffect(function() {
        if (state.step) {
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "top-up",
                action: "modal-load",
                label: state.step
            }));
        }
    }, [
        onTrack,
        state.step
    ]);
    if (!state.step) {
        return null;
    }
    if (state.step === "payment-timed-out") {
        return /*#__PURE__*/ jsx(TopUpPaymentTimedOut, {
            dispatch: dispatch,
            config: config
        });
    }
    var StepComponent = StepComponentMap$2.get(state.step);
    return /*#__PURE__*/ jsx(StripeProvider, {
        publishableKey: stripePublishableKey,
        paymentConfig: paymentConfig,
        state: state,
        children: /*#__PURE__*/ jsxs(Modal, {
            variant: "light",
            sx: {
                minHeight: "640px"
            },
            children: [
                /*#__PURE__*/ jsx(TopUpHeader, {
                    step: state.step
                }),
                /*#__PURE__*/ jsx(ModalContent, {
                    children: StepComponent && /*#__PURE__*/ jsx(StepComponent, {
                        dispatch: dispatch,
                        paymentConfig: paymentConfig,
                        state: state,
                        onTrack: onTrack
                    })
                }),
                /*#__PURE__*/ jsx(ModalActions, {
                    children: /*#__PURE__*/ jsx(TopUpBottomAction, {
                        state: state,
                        dispatch: dispatch
                    })
                })
            ]
        })
    });
}

function _define_property$o(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$j(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$o(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$9(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$9(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$9(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var topUpActions = _object_spread_props$9(_object_spread$j({}, topUpSlice.actions), {
    initTopUpAction: initTopUpAction,
    waitForBalanceIncreaseAction: waitForBalanceIncreaseAction,
    paymentRequestAction: paymentRequestAction,
    cardPaymentAction: cardPaymentAction
});

function _array_like_to_array$d(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$b(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep$f(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$f(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$f(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$f(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit$b(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$b() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$b(arr, i) {
    return _array_with_holes$b(arr) || _iterable_to_array_limit$b(arr, i) || _unsupported_iterable_to_array$d(arr, i) || _non_iterable_rest$b();
}
function _unsupported_iterable_to_array$d(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$d(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$d(o, minLen);
}
function _ts_generator$f(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function Comments(param) {
    var posts = param.posts, isAdminOrMod = param.isAdminOrMod, playToken = param.playToken, hasMorePosts = param.hasMorePosts, channelId = param.channelId, fetchMorePosts = param.fetchMorePosts, onCommentPost = param.onCommentPost, onCommentAction = param.onCommentAction;
    var _useState = _sliced_to_array$b(useState(false), 2), isCommentOptionsOpen = _useState[0], setIsCommentOptionsOpen = _useState[1];
    var _useState1 = _sliced_to_array$b(useState(), 2), commentOptionsData = _useState1[0], setCommentOptionsData = _useState1[1];
    var t = useTranslation().t;
    var loadingRef = useRef(null);
    var _useState2 = _sliced_to_array$b(useState(false), 2), shouldFetchMorePosts = _useState2[0], setShouldFetchMorePosts = _useState2[1];
    useEffect(function() {
        var fetchPosts = function() {
            var _ref = _async_to_generator$f(function() {
                return _ts_generator$f(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchMorePosts()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPosts() {
                return _ref.apply(this, arguments);
            };
        }();
        if (shouldFetchMorePosts) {
            void fetchPosts();
        }
    }, [
        shouldFetchMorePosts,
        fetchMorePosts
    ]);
    useEffect(function() {
        var observer = new IntersectionObserver(function(entries) {
            var entry = entries[0];
            setShouldFetchMorePosts(entry.isIntersecting);
        });
        if (loadingRef.current) {
            observer.observe(loadingRef.current);
        }
    }, [
        loadingRef,
        hasMorePosts
    ]);
    var nowDate = new Date();
    var onOptionsClick = function() {
        var _ref = _async_to_generator$f(function(param) {
            var postId, userId, selfPost, isAdminOrMod, channelId, username;
            return _ts_generator$f(this, function(_state) {
                postId = param.postId, userId = param.userId, selfPost = param.selfPost, isAdminOrMod = param.isAdminOrMod, channelId = param.channelId, username = param.username;
                setCommentOptionsData({
                    postId: postId,
                    selfPost: selfPost,
                    userId: userId,
                    isAdminOrMod: isAdminOrMod,
                    channelId: channelId,
                    username: username
                });
                setIsCommentOptionsOpen(true);
                return [
                    2
                ];
            });
        });
        return function onOptionsClick(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var onOptionsClose = function() {
        setIsCommentOptionsOpen(false);
        setCommentOptionsData(undefined);
    };
    return /*#__PURE__*/ jsxs(Stack, {
        direction: "column",
        sx: {
            position: "relative",
            padding: "6px",
            height: "100%",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ jsx(List, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "5px",
                    borderRadius: "0",
                    backgroundColor: "transparent",
                    margin: "8px 0 42px 0",
                    overflowY: "auto",
                    height: "100%",
                    "::-webkit-scrollbar": {
                        width: 0
                    },
                    width: "100%"
                },
                children: posts.length ? /*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        posts === null || posts === void 0 ? void 0 : posts.map(function(param) {
                            var pid = param.pid, content = param.content, timestamp = param.timestamp, selfPost = param.selfPost, user = param.user;
                            return /*#__PURE__*/ jsx(Comment, {
                                userId: user.uid,
                                channelId: channelId,
                                postId: pid,
                                username: user.username,
                                postedDate: new Date(timestamp),
                                nowDate: nowDate,
                                content: content,
                                isAdminOrMod: isAdminOrMod,
                                selfPost: selfPost,
                                deleted: false,
                                onOptionsClick: onOptionsClick,
                                displayCommentOptions: isAdminOrMod || !!playToken
                            }, pid);
                        }),
                        hasMorePosts && /*#__PURE__*/ jsx(Typography, {
                            ref: loadingRef,
                            sx: function(theme) {
                                return {
                                    color: theme.palette.common.white
                                };
                            },
                            children: t("features.comments.loading", "Loading...")
                        })
                    ]
                }) : /*#__PURE__*/ jsx(Typography, {
                    sx: function(theme) {
                        return {
                            color: theme.palette.common.white
                        };
                    },
                    children: t("features.comments.noComment", "No Comments")
                })
            }),
            commentOptionsData && isCommentOptionsOpen && /*#__PURE__*/ jsx(CommentOptions, {
                channelId: channelId,
                userId: commentOptionsData.userId,
                postId: commentOptionsData.postId,
                selfPosted: commentOptionsData.selfPost,
                username: commentOptionsData.username,
                isAdminOrMod: isAdminOrMod,
                onAction: onCommentAction,
                onClose: onOptionsClose
            }),
            /*#__PURE__*/ jsx(CommentInput, {
                writePermission: !!playToken || isAdminOrMod,
                onSubmit: onCommentPost
            })
        ]
    });
}

function asyncGeneratorStep$e(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$e(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$e(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$e(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property$n(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$i(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$n(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$8(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$8(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$8(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$1(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator$e(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
// TODO: Config handling
var initialSignupConfig = {
    learnMoreUrl: "https://recast.tv/about",
    supportedRegionsUrl: "https://recast.tv/available-countries",
    recastTermsOfServiceUrl: "https://recast.tv/terms-and-conditions",
    recastPrivacyPolicyUrl: "https://recast.tv/privacy-policy",
    supportEmail: "helpme@recast.tv",
    bonusCastCount: 25,
    bonusCastExpiryDaysCount: 14
};
var signupInitialState = {
    config: initialSignupConfig,
    step: undefined,
    userEmail: undefined,
    apiError: undefined,
    isSubmitting: false,
    channel: undefined,
    isPurchaseFlow: false,
    entry: "pop-up"
};
var sessionStateEntry = sessionStorageEntry("signupState", signupInitialState);
var signupReducers = {
    start: function(state, action) {
        var _action_payload;
        state.entry = ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.entry) || "pop-up";
        if (!state.step) {
            var _action_payload1, _action_payload2, _action_payload3, _action_payload4, _action_payload5;
            state.step = "start";
            state.source = (_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.source;
            state.channel = (_action_payload2 = action.payload) === null || _action_payload2 === void 0 ? void 0 : _action_payload2.channel;
            state.providers = (_action_payload3 = action.payload) === null || _action_payload3 === void 0 ? void 0 : _action_payload3.providers;
            state.isPurchaseFlow = !!((_action_payload4 = action.payload) === null || _action_payload4 === void 0 ? void 0 : _action_payload4.isPurchaseFlow);
            state.referrer = (_action_payload5 = action.payload) === null || _action_payload5 === void 0 ? void 0 : _action_payload5.referrer;
        }
    },
    navigateToUnsupportedRegion: function(state) {
        state.step = "error-unsupported-region";
    },
    navigateToSelection: function(state) {
        state.isSubmitting = false;
        state.apiError = undefined;
        state.step = "signup-method-selection";
    },
    navigateToLogin: function(state) {
        state.isSubmitting = false;
        state.apiError = undefined;
        state.step = "login";
    },
    navigateToResetPassword: function(state) {
        state.isSubmitting = false;
        state.apiError = undefined;
        state.step = "reset-password";
    },
    navigateToUserDetails: function(state) {
        state.isSubmitting = false;
        state.apiError = undefined;
        state.step = "user-details";
    },
    navigateToVerification: function(state) {
        state.isSubmitting = false;
        state.apiError = undefined;
        state.step = "verification";
    },
    navigateToWrongEmail: function(state) {
        state.isSubmitting = false;
        state.apiError = undefined;
        state.step = "wrong-email";
    },
    navigateToDeletedAccount: function(state) {
        state.isSubmitting = false;
        state.apiError = undefined;
        state.step = "error-deleted-account";
    },
    navigateToVPNBlocked: function(state) {
        state.isSubmitting = false;
        state.apiError = undefined;
        state.step = "error-vpn-blocked";
    },
    setApiError: function(state, action) {
        state.apiError = action.payload;
    },
    clearApiError: function(state) {
        state.apiError = undefined;
    },
    clearIsSubmitting: function(state) {
        state.isSubmitting = false;
    },
    // NOTE: purchaseSlice should have extraReducer for signup/success
    success: function(state) {
        state.step = undefined;
    },
    exit: function(state) {
        state.step = undefined;
    },
    confirmEmailIsValid: function(state, action) {
        if (state.emailValidation) {
            state.emailValidation.valid = action.payload ? EmailValidity.VALID : EmailValidity.INVALID;
        }
    }
};
var authPendingAction = function(state, action) {
    var _action_meta_arg;
    state.isSubmitting = true;
    state.apiError = undefined;
    state.userEmail = (_action_meta_arg = action.meta.arg) === null || _action_meta_arg === void 0 ? void 0 : _action_meta_arg.email;
};
var extraReducers = function(builder) {
    builder.addCase(authLoginAction.pending, authPendingAction).addCase(authLoginAction.fulfilled, function(state) {
        state.step = undefined;
        state.isSubmitting = false;
    }).addCase(authSignupAction.pending, authPendingAction).addCase(authSignupAction.fulfilled, function(state) {
        state.step = "verification";
        state.isSubmitting = false;
    }).addCase(authVerifyAction.pending, authPendingAction).addCase(authVerifyAction.fulfilled, function(state) {
        state.step = "welcome";
        state.isSubmitting = false;
    }).addCase(authResendVerifyCodeAction.pending, authPendingAction).addCase(authResendVerifyCodeAction.fulfilled, function(state, action) {
        state.step = action.payload.isLoginRequest ? "login-verification" : "resend-confirm";
        state.isSubmitting = false;
    }).addCase(authResetPasswordAction.pending, authPendingAction).addCase(authResetPasswordAction.fulfilled, function(state) {
        state.step = "reset-password-confirm";
        state.isSubmitting = false;
    }).addCase(authValidateEmailAction.fulfilled, function(state, action) {
        if (action.payload.valid !== EmailValidity.INVALID) {
            state.emailValidation = _object_spread_props$8(_object_spread$i({}, action.payload), {
                email: action.meta.arg.email
            });
        }
    }).addCase(continueSocialSignUp.fulfilled, function(state, action) {
        var _action_meta_arg = action.meta.arg, status = _action_meta_arg.status, error = _action_meta_arg.error;
        switch(status){
            case "login":
                state.step = undefined;
                break;
            case "signup":
                state.step = state.entry === "account" ? undefined : "welcome";
                break;
            case "error":
                if (error === "UserDeletedError") {
                    state.step = "error-deleted-account";
                } else {
                    state.step = "signup-method-selection";
                }
                break;
            case "connect":
                state.step = "login";
                state.socialSignup = {
                    provider: action.meta.arg.provider,
                    code: action.meta.arg.code
                };
                break;
        }
    }).addCase(signupAction.pending, function(state, action) {
        state.isOptedInToShareData = action.meta.arg.isOptedInToShareData;
    }).addMatcher(function() {
        return true;
    }, function(state) {
        if (state.step) {
            sessionStateEntry.set(state);
        } else {
            sessionStateEntry.clear();
        }
    });
};
var signupApiErrorMiddleware = function(storeAPI) {
    return function(next) {
        return function(action) {
            var dispatch = storeAPI.dispatch;
            var state = storeAPI.getState();
            var authErrorActionTypes = [
                authLoginAction.rejected.type,
                authSignupAction.rejected.type,
                authVerifyAction.rejected.type,
                authResendVerifyCodeAction.rejected.type,
                authResetPasswordAction.rejected.type
            ];
            var error = undefined;
            var _action_type;
            if (authErrorActionTypes.includes((_action_type = action.type) !== null && _action_type !== void 0 ? _action_type : "")) {
                var _action_payload;
                error = (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload[0];
            }
            if (!error) {
                return next(action);
            }
            dispatch(clearIsSubmitting());
            if (error.type === "AccountNotValidatedError") {
                dispatch(authResendVerifyCodeAction({
                    email: state.signup.userEmail,
                    isLoginRequest: true
                }));
            } else if (error.type === "UserDeletedError") {
                dispatch(navigateToDeletedAccount());
            } else if (error.type === "VPNError") {
                dispatch(navigateToVPNBlocked());
            } else {
                dispatch(setApiError(error !== null && error !== void 0 ? error : {
                    type: "UnknownError",
                    message: "Unknown error"
                }));
            }
            return next(action);
        };
    };
};
var signupSlice = createSlice({
    name: "signup",
    initialState: function() {
        return sessionStateEntry.get();
    },
    reducers: signupReducers,
    extraReducers: extraReducers
});
var _signupSlice_actions = signupSlice.actions;
var start = _signupSlice_actions.start, navigateToUnsupportedRegion = _signupSlice_actions.navigateToUnsupportedRegion, navigateToSelection = _signupSlice_actions.navigateToSelection, navigateToLogin = _signupSlice_actions.navigateToLogin, navigateToResetPassword = _signupSlice_actions.navigateToResetPassword, navigateToUserDetails = _signupSlice_actions.navigateToUserDetails, navigateToVerification = _signupSlice_actions.navigateToVerification, navigateToWrongEmail = _signupSlice_actions.navigateToWrongEmail, navigateToDeletedAccount = _signupSlice_actions.navigateToDeletedAccount, navigateToVPNBlocked = _signupSlice_actions.navigateToVPNBlocked, setApiError = _signupSlice_actions.setApiError, clearApiError = _signupSlice_actions.clearApiError, clearIsSubmitting = _signupSlice_actions.clearIsSubmitting, success = _signupSlice_actions.success, exit$4 = _signupSlice_actions.exit, confirmEmailIsValid = _signupSlice_actions.confirmEmailIsValid;
signupSlice.reducer;
var continueSocialSignUp = createAsyncThunk("signup/continueSocialSignUp", function() {
    var _ref = _async_to_generator$e(function(param, param1) {
        var status, tokens, dispatch;
        return _ts_generator$e(this, function(_state) {
            status = param.status, tokens = param.tokens, dispatch = param1.dispatch;
            dispatch(updateTokens(tokens !== null && tokens !== void 0 ? tokens : null));
            if (status === "login") {
                dispatch(success());
            }
            return [
                2
            ];
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var selectSocialSignUpUrls = createSelector(function(state) {
    return state.signup.source;
}, function(state) {
    return state.signup.providers;
}, function(state) {
    return state.config.baseUrl;
}, function(source, providers, baseUrl) {
    var query = source ? "?source=".concat(source) : "";
    var getUrl = function(provider) {
        var _providers_includes;
        return ((_providers_includes = providers === null || providers === void 0 ? void 0 : providers.includes(provider)) !== null && _providers_includes !== void 0 ? _providers_includes : true) ? "".concat(baseUrl, "/auth/").concat(provider).concat(query) : undefined;
    };
    return {
        google: getUrl("google"),
        facebook: getUrl("facebook")
    };
});
var loginAction = function(values) {
    return function(dispatch, getState) {
        var _getState_signup_socialSignup;
        return dispatch(authLoginAction(_object_spread_props$8(_object_spread$i({}, values), {
            socialSignupCode: (_getState_signup_socialSignup = getState().signup.socialSignup) === null || _getState_signup_socialSignup === void 0 ? void 0 : _getState_signup_socialSignup.code
        })));
    };
};
var signupAction = createAsyncThunk("signup/signup", function() {
    var _ref = _async_to_generator$e(function(_param, _param1) {
        var signupArgs, getState, dispatch, emailValidation;
        return _ts_generator$e(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param.isOptedInToShareData, signupArgs = _object_without_properties$1(_param, [
                        "isOptedInToShareData"
                    ]), getState = _param1.getState, dispatch = _param1.dispatch;
                    emailValidation = getState().signup.emailValidation;
                    if (!((emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.email) !== signupArgs.email)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new Promise(function(resolve) {
                            return dispatch(addListener({
                                predicate: function(_, currentState) {
                                    var _currentState_signup_emailValidation;
                                    return ((_currentState_signup_emailValidation = currentState.signup.emailValidation) === null || _currentState_signup_emailValidation === void 0 ? void 0 : _currentState_signup_emailValidation.email) === signupArgs.email;
                                },
                                effect: function(_, param) {
                                    var unsubscribe = param.unsubscribe, getState = param.getState;
                                    unsubscribe();
                                    resolve(getState().signup.emailValidation);
                                }
                            }));
                        })
                    ];
                case 1:
                    emailValidation = _state.sent();
                    _state.label = 2;
                case 2:
                    if ((emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.valid) !== EmailValidity.VALID) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        dispatch(authSignupAction(_object_spread_props$8(_object_spread$i({}, signupArgs), {
                            emailValidationToken: emailValidation.token
                        })))
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(_param, _param1) {
        return _ref.apply(this, arguments);
    };
}());
var validateEmailAction = createAsyncThunk("signup/validateEmail", function() {
    var _ref = _async_to_generator$e(function(email, param) {
        var dispatch, getState, rejectWithValue, emailValidation, authValidationResult;
        return _ts_generator$e(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch = param.dispatch, getState = param.getState, rejectWithValue = param.rejectWithValue;
                    emailValidation = getState().signup.emailValidation;
                    if ((emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.email) === email) {
                        return [
                            2,
                            emailValidation
                        ];
                    }
                    return [
                        4,
                        dispatch(authValidateEmailAction({
                            email: email
                        }))
                    ];
                case 1:
                    authValidationResult = _state.sent();
                    if (authValidateEmailAction.fulfilled.match(authValidationResult)) {
                        return [
                            2,
                            _object_spread_props$8(_object_spread$i({}, authValidationResult.payload), {
                                email: email
                            })
                        ];
                    }
                    return [
                        2,
                        rejectWithValue(authValidationResult)
                    ];
            }
        });
    });
    return function(email, _) {
        return _ref.apply(this, arguments);
    };
}());
var signupVerifyAction = createAsyncThunk("signup/verify", function() {
    var _ref = _async_to_generator$e(function(args, param) {
        var getState, dispatch, result, _getState_signup, isOptedInToShareData, channel;
        return _ts_generator$e(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState, dispatch = param.dispatch;
                    return [
                        4,
                        dispatch(authVerifyAction(args))
                    ];
                case 1:
                    result = _state.sent();
                    _getState_signup = getState().signup, isOptedInToShareData = _getState_signup.isOptedInToShareData, channel = _getState_signup.channel;
                    if (authVerifyAction.fulfilled.match(result) && (channel === null || channel === void 0 ? void 0 : channel.dataShare.isEnabled) && isOptedInToShareData) {
                        void dispatch(profileApi.endpoints.updatePublishersDataShare.initiate([
                            {
                                channelUid: channel.id,
                                scopes: [
                                    PublisherDataShareScopes.email
                                ]
                            }
                        ])).unwrap();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function(args, _) {
        return _ref.apply(this, arguments);
    };
}());

function asyncGeneratorStep$d(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$d(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$d(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$d(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$d(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var isChannelPassExpiredAt = function(channelPass, date) {
    var startDate = textToDate(date);
    var nowWithDuration = addSeconds(Date.now(), channelPass.rentalPeriod);
    return isAfter(nowWithDuration, startDate);
};
var startPurchasesPayload = function() {
    var _ref = _async_to_generator$d(function(dispatch, providers, channel, isUserLoggedIn, nextStep, referrer, signupSource) {
        var _countries_find, countries, location;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch(exit$5());
                    return [
                        4,
                        dispatch(getEndpointData(mediaApi.endpoints.getCountries))
                    ];
                case 1:
                    countries = _state.sent();
                    return [
                        4,
                        dispatch(getEndpointData(mediaApi.endpoints.getLocation))
                    ];
                case 2:
                    location = _state.sent();
                    if (!((_countries_find = countries.find(function(param) {
                        var code = param.code;
                        return code === location.location;
                    })) === null || _countries_find === void 0 ? void 0 : _countries_find.enabled)) {
                        return [
                            2,
                            "unsupported-region"
                        ];
                    }
                    if (isUserLoggedIn) {
                        nextStep === null || nextStep === void 0 ? void 0 : nextStep();
                        return [
                            2,
                            ""
                        ];
                    } else {
                        dispatch(externalFlow({
                            start: start({
                                source: signupSource !== null && signupSource !== void 0 ? signupSource : "popUp",
                                channel: channel,
                                providers: providers,
                                isPurchaseFlow: true,
                                referrer: referrer
                            }),
                            end: [
                                success,
                                authLoginAction.fulfilled,
                                exit$4
                            ],
                            after: function(action) {
                                if (exit$4.match(action)) {
                                    dispatch(exit$3());
                                } else {
                                    nextStep === null || nextStep === void 0 ? void 0 : nextStep();
                                }
                            }
                        }));
                        return [
                            2,
                            "sign-up"
                        ];
                    }
            }
        });
    });
    return function startPurchasesPayload(dispatch, providers, channel, isUserLoggedIn, nextStep, referrer, signupSource) {
        return _ref.apply(this, arguments);
    };
}();
var startPurchase = createAsyncThunk("purchase/startPurchase", function() {
    var _ref = _async_to_generator$d(function(param, param1) {
        var video, providers, dataShare, shouldWarnAboutGeoblock, _param_isPurchasedContentCheckEnabled, isPurchasedContentCheckEnabled, referrer, signupSource, getState, dispatch, _video_channel_display_avatar, isUserLogged, channel, nextStep, payload;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    video = param.video, providers = param.providers, dataShare = param.dataShare, shouldWarnAboutGeoblock = param.shouldWarnAboutGeoblock, _param_isPurchasedContentCheckEnabled = param.isPurchasedContentCheckEnabled, isPurchasedContentCheckEnabled = _param_isPurchasedContentCheckEnabled === void 0 ? false : _param_isPurchasedContentCheckEnabled, referrer = param.referrer, signupSource = param.signupSource, getState = param1.getState, dispatch = param1.dispatch;
                    isUserLogged = isUserLoggedIn(getState());
                    channel = {
                        id: video.channel.id,
                        icon: ((_video_channel_display_avatar = video.channel.display.avatar) === null || _video_channel_display_avatar === void 0 ? void 0 : _video_channel_display_avatar.uri) || "",
                        name: video.channel.name,
                        dataShare: dataShare
                    };
                    dispatch(handleGeoblockWarning({
                        shouldWarnAboutGeoblock: shouldWarnAboutGeoblock,
                        channelName: channel.name
                    }));
                    nextStep = function() {
                        return dispatch(redirectToReplayIfLiveEventHaveReplay({
                            isPurchasedContentCheckEnabled: isPurchasedContentCheckEnabled
                        }));
                    };
                    return [
                        4,
                        startPurchasesPayload(dispatch, providers, channel, isUserLogged, nextStep, referrer, signupSource)
                    ];
                case 1:
                    payload = _state.sent();
                    return [
                        2,
                        payload
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var startChannelPassPurchase = createAsyncThunk("purchase/startChannelPassPurchase", function() {
    var _ref = _async_to_generator$d(function(param, param1) {
        var channelPass, channelUid, channelName, channelAvatar, providers, dataShare, shouldWarnAboutGeoblock, referrer, _param_isPurchasedContentCheckEnabled, isPurchasedContentCheckEnabled, signupSource, getState, dispatch, isUserLogged, channel, nextStep, payload;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    channelPass = param.channelPass, channelUid = param.channelUid, channelName = param.channelName, channelAvatar = param.channelAvatar, providers = param.providers, dataShare = param.dataShare, shouldWarnAboutGeoblock = param.shouldWarnAboutGeoblock, referrer = param.referrer, _param_isPurchasedContentCheckEnabled = param.isPurchasedContentCheckEnabled, isPurchasedContentCheckEnabled = _param_isPurchasedContentCheckEnabled === void 0 ? false : _param_isPurchasedContentCheckEnabled, signupSource = param.signupSource, getState = param1.getState, dispatch = param1.dispatch;
                    isUserLogged = isUserLoggedIn(getState());
                    channel = {
                        id: channelUid,
                        icon: channelAvatar,
                        name: channelName,
                        dataShare: dataShare
                    };
                    dispatch(handleGeoblockWarning({
                        shouldWarnAboutGeoblock: shouldWarnAboutGeoblock,
                        channelName: channel.name
                    }));
                    nextStep = function() {
                        return dispatch(selectChannelPass({
                            channelPass: channelPass,
                            isPurchasedContentCheckEnabled: isPurchasedContentCheckEnabled,
                            isFromStartChannelPassPurchase: true
                        }));
                    };
                    return [
                        4,
                        startPurchasesPayload(dispatch, providers, channel, isUserLogged, nextStep, referrer, signupSource)
                    ];
                case 1:
                    payload = _state.sent();
                    return [
                        2,
                        payload
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var startIntentPurchaseContinueAction = createAction("purchase/startIntentPurchase/continue");
var startIntentPurchase = createAsyncThunk("purchase/startIntentPurchase", function() {
    var _ref = _async_to_generator$d(function(_, param) {
        var dispatch, getState, isUserLogged, nextStep;
        return _ts_generator$d(this, function(_state) {
            dispatch = param.dispatch, getState = param.getState;
            isUserLogged = isUserLoggedIn(getState());
            nextStep = function() {
                var _ref = _async_to_generator$d(function() {
                    var _getState_purchase_intent_payload, _getState_purchase_intent, _getState_purchase_intent_payload_productId, product;
                    return _ts_generator$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    dispatch(getEndpointData(inventoryApi.endpoints.getProduct, (_getState_purchase_intent_payload_productId = (_getState_purchase_intent = getState().purchase.intent) === null || _getState_purchase_intent === void 0 ? void 0 : (_getState_purchase_intent_payload = _getState_purchase_intent.payload) === null || _getState_purchase_intent_payload === void 0 ? void 0 : _getState_purchase_intent_payload.productId) !== null && _getState_purchase_intent_payload_productId !== void 0 ? _getState_purchase_intent_payload_productId : ""))
                                ];
                            case 1:
                                product = _state.sent();
                                dispatch(startIntentPurchaseContinueAction({
                                    product: product
                                }));
                                dispatch(ensureWalletBalanceBeforePurchase());
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function nextStep() {
                    return _ref.apply(this, arguments);
                };
            }();
            return [
                2,
                startPurchasesPayload(dispatch, [], undefined, isUserLogged, nextStep)
            ];
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var redirectToReplayIfLiveEventHaveReplay = createAsyncThunk("purchase/redirectToReplayIfLiveEventHaveReplay", function() {
    var _ref = _async_to_generator$d(function(param, param1) {
        var isPurchasedContentCheckEnabled, dispatch, getState, video, _currentVideo_liveDetails, currentVideo, _currentVideo_liveDetails_replay, _currentVideo_liveDetails1, _currentVideo_liveDetails_replay1, _currentVideo_liveDetails2, replay;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    isPurchasedContentCheckEnabled = param.isPurchasedContentCheckEnabled, dispatch = param1.dispatch, getState = param1.getState;
                    video = getState().purchase.video;
                    if (!((video === null || video === void 0 ? void 0 : video.videoType) === VideoListingTypes.LIVE)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        dispatch(getEndpointData(publicApi.endpoints.getVideo, video.id, {
                            forceRefetch: true
                        }))
                    ];
                case 1:
                    currentVideo = _state.sent();
                    if (!(((_currentVideo_liveDetails = currentVideo.liveDetails) === null || _currentVideo_liveDetails === void 0 ? void 0 : _currentVideo_liveDetails.status) === VideoListingLiveDetailsStatus.finished)) return [
                        3,
                        4
                    ];
                    if (!(((_currentVideo_liveDetails1 = currentVideo.liveDetails) === null || _currentVideo_liveDetails1 === void 0 ? void 0 : (_currentVideo_liveDetails_replay = _currentVideo_liveDetails1.replay) === null || _currentVideo_liveDetails_replay === void 0 ? void 0 : _currentVideo_liveDetails_replay.status) === VideoListingReplayStatus.live)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        dispatch(getEndpointData(publicApi.endpoints.getVideo, currentVideo.liveDetails.replay.video))
                    ];
                case 2:
                    replay = _state.sent();
                    dispatch(updateVideo(replay));
                    return [
                        3,
                        4
                    ];
                case 3:
                    if (((_currentVideo_liveDetails2 = currentVideo.liveDetails) === null || _currentVideo_liveDetails2 === void 0 ? void 0 : (_currentVideo_liveDetails_replay1 = _currentVideo_liveDetails2.replay) === null || _currentVideo_liveDetails_replay1 === void 0 ? void 0 : _currentVideo_liveDetails_replay1.status) === VideoListingReplayStatus.pending) {
                        dispatch(replayIsProcessing());
                        return [
                            2
                        ];
                    } else {
                        dispatch(streamHasEnded());
                        return [
                            2
                        ];
                    }
                case 4:
                    dispatch(attemptToUseChannelPass({
                        isPurchasedContentCheckEnabled: isPurchasedContentCheckEnabled
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var attemptToUseChannelPass = createAsyncThunk("purchase/attemptToUseChannelPass", function() {
    var _ref = _async_to_generator$d(function(param, param1) {
        var isPurchasedContentCheckEnabled, dispatch, getState, _getState_purchase, video, step, channelPasses, purchasedChannelPasses, activeChannelPass, res, ownedVideo;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    isPurchasedContentCheckEnabled = param.isPurchasedContentCheckEnabled, dispatch = param1.dispatch, getState = param1.getState;
                    _getState_purchase = getState().purchase, video = _getState_purchase.video, step = _getState_purchase.step;
                    if (!video) {
                        throw new Error("Missing video");
                    }
                    channelPasses = video.channel.channelPasses;
                    return [
                        4,
                        dispatch(getEndpointData(purchaseApi.endpoints.getPurchasedChannelPasses, undefined, {
                            forceRefetch: true
                        }))
                    ];
                case 1:
                    purchasedChannelPasses = _state.sent();
                    activeChannelPass = purchasedChannelPasses.find(function(channelPass) {
                        return channelPass.tariff.channel.href === video.channel.href && !channelPass.revoked && channelPass.expires && isAfter(textToDate(channelPass.expires), Date.now());
                    });
                    if (!(step === "sign-up" && isPurchasedContentCheckEnabled)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        dispatch(getEndpointData(purchaseApi.endpoints.getMyPurchasesTariffs))
                    ];
                case 2:
                    res = _state.sent();
                    ownedVideo = res.find(function(tariff) {
                        return tariff.type === "SINGLE_PRODUCT" && tariff.products && tariff.products.some(function(param) {
                            var href = param.href;
                            return video.productId && hrefContainsId(href, video.productId);
                        });
                    });
                    if (ownedVideo) {
                        dispatch(exit$3());
                        return [
                            2,
                            undefined
                        ];
                    }
                    _state.label = 3;
                case 3:
                    if (activeChannelPass) {
                        if (video.liveDetails && activeChannelPass.expires && isBefore(textToDate(activeChannelPass.expires), textToDate(video.liveDetails.startTime))) {
                            return [
                                2,
                                {
                                    type: "show-channel-pass-expires",
                                    activeChannelPass: activeChannelPass
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: "active-channel-pass"
                            }
                        ];
                    } else if (channelPasses.some(function(pass) {
                        return !video.liveDetails || isChannelPassExpiredAt(pass, video.liveDetails.startTime);
                    })) {
                        return [
                            2,
                            {
                                type: "show-suggest-channel-pass"
                            }
                        ];
                    } else {
                        dispatch(ensureWalletBalanceBeforePurchase());
                        return [
                            2,
                            undefined
                        ];
                    }
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var selectChannelPass = createAsyncThunk("purchase/selectChannelPass", function() {
    var _ref = _async_to_generator$d(function(param, param1) {
        var _param_isPurchasedContentCheckEnabled, isPurchasedContentCheckEnabled, _param_isFromStartChannelPassPurchase, isFromStartChannelPassPurchase, getState, dispatch, _getState_purchase, channelPass, step, shouldWarnAboutGeoblock, purchasedChannelPasses, activeChannelPass;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param_isPurchasedContentCheckEnabled = param.isPurchasedContentCheckEnabled, isPurchasedContentCheckEnabled = _param_isPurchasedContentCheckEnabled === void 0 ? false : _param_isPurchasedContentCheckEnabled, _param_isFromStartChannelPassPurchase = param.isFromStartChannelPassPurchase, isFromStartChannelPassPurchase = _param_isFromStartChannelPassPurchase === void 0 ? false : _param_isFromStartChannelPassPurchase, getState = param1.getState, dispatch = param1.dispatch;
                    _getState_purchase = getState().purchase, channelPass = _getState_purchase.channelPass, step = _getState_purchase.step, shouldWarnAboutGeoblock = _getState_purchase.shouldWarnAboutGeoblock;
                    if (!!channelPass) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new Promise(function(resolve) {
                            return dispatch(addListener({
                                predicate: function(_, state) {
                                    return !!state.purchase.channelPass;
                                },
                                effect: function(_, param) {
                                    var unsubscribe = param.unsubscribe;
                                    unsubscribe();
                                    resolve();
                                }
                            }));
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    if (!(step === "sign-up" && isPurchasedContentCheckEnabled)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        dispatch(getEndpointData(purchaseApi.endpoints.getPurchasedChannelPasses, undefined, {
                            forceRefetch: true
                        }))
                    ];
                case 3:
                    purchasedChannelPasses = _state.sent();
                    activeChannelPass = purchasedChannelPasses.find(function(channelPass) {
                        return !channelPass.revoked && channelPass.expires && isAfter(textToDate(channelPass.expires), Date.now());
                    });
                    if (activeChannelPass) {
                        dispatch(exit$3());
                    } else {
                        if (isFromStartChannelPassPurchase && shouldWarnAboutGeoblock) {
                            return [
                                2,
                                "show-confirm-channel-pass"
                            ];
                        } else {
                            dispatch(ensureWalletBalanceBeforePurchase());
                        }
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    if (isFromStartChannelPassPurchase && shouldWarnAboutGeoblock) {
                        return [
                            2,
                            "show-confirm-channel-pass"
                        ];
                    } else {
                        dispatch(ensureWalletBalanceBeforePurchase());
                    }
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var dismissChannelPass = createAsyncThunk("purchase/dismissChannelPass", function(_, param) {
    var dispatch = param.dispatch;
    dispatch(ensureWalletBalanceBeforePurchase());
});
var purchaseConfirmation = createAsyncThunk("purchase/purchaseConfirmation", function() {
    var _ref = _async_to_generator$d(function(param, param1) {
        var _param_isBalanceSufficient, isBalanceSufficient, dispatch, getState, skipPurchaseConfirm;
        return _ts_generator$d(this, function(_state) {
            _param_isBalanceSufficient = param.isBalanceSufficient, isBalanceSufficient = _param_isBalanceSufficient === void 0 ? false : _param_isBalanceSufficient, dispatch = param1.dispatch, getState = param1.getState;
            skipPurchaseConfirm = getState().purchase.skipPurchaseConfirm;
            if (!isBalanceSufficient) {
                dispatch(ensureWalletBalanceBeforePurchase());
                return [
                    2,
                    false
                ];
            }
            if (skipPurchaseConfirm) {
                dispatch(makeVideoPurchase());
                return [
                    2,
                    false
                ];
            }
            return [
                2,
                true
            ];
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var confirmPurchase = createAsyncThunk("purchase/confirmPurchase", function() {
    var _ref = _async_to_generator$d(function(param, param1) {
        var accept, dispatch, _ref, missingCasts;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    accept = param.accept, dispatch = param1.dispatch;
                    if (!accept) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        dispatch(ensureWalletBalanceBeforePurchase())
                    ];
                case 1:
                    _ref = _state.sent(), missingCasts = _ref.payload;
                    if (missingCasts === 0) {
                        dispatch(makeVideoPurchase());
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    dispatch(exit$3());
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var ensureWalletBalanceBeforePurchase = createAsyncThunk("purchase/ensureWalletBalanceBeforePurchase", function() {
    var _ref = _async_to_generator$d(function(_, param) {
        var dispatch, getState, _getState_purchase, video, channelPass, product, getMissingCasts, missingCasts, missingCastCredits, missingCastCredits1;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch = param.dispatch, getState = param.getState;
                    _getState_purchase = getState().purchase, video = _getState_purchase.video, channelPass = _getState_purchase.channelPass, product = _getState_purchase.product;
                    getMissingCasts = function() {
                        var _ref = _async_to_generator$d(function(requiredCasts) {
                            var wallet, _wallet_balance_units, balance;
                            return _ts_generator$d(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            dispatch(getEndpointData(mediaApi.endpoints.getMeWallet))
                                        ];
                                    case 1:
                                        wallet = _state.sent();
                                        balance = (_wallet_balance_units = wallet === null || wallet === void 0 ? void 0 : wallet.balance.units) !== null && _wallet_balance_units !== void 0 ? _wallet_balance_units : 0;
                                        return [
                                            2,
                                            requiredCasts - balance
                                        ];
                                }
                            });
                        });
                        return function getMissingCasts(requiredCasts) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    if (!channelPass) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getMissingCasts(channelPass.priceDetails.price)
                    ];
                case 1:
                    missingCasts = _state.sent();
                    if (missingCasts > 0) {
                        return [
                            2,
                            missingCasts
                        ];
                    }
                    return [
                        2,
                        0
                    ];
                case 2:
                    if (!video) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        getMissingCasts(video.basicCost[0].units)
                    ];
                case 3:
                    missingCastCredits = _state.sent();
                    if (missingCastCredits > 0) {
                        return [
                            2,
                            missingCastCredits
                        ];
                    }
                    dispatch(purchaseConfirmation({
                        isBalanceSufficient: true
                    }));
                    return [
                        2,
                        0
                    ];
                case 4:
                    if (!product) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        getMissingCasts(product.priceDetails.price)
                    ];
                case 5:
                    missingCastCredits1 = _state.sent();
                    if (missingCastCredits1 > 0) {
                        return [
                            2,
                            missingCastCredits1
                        ];
                    }
                    dispatch(purchaseConfirmation({
                        isBalanceSufficient: true
                    }));
                    return [
                        2,
                        0
                    ];
                case 6:
                    return [
                        2,
                        0
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var startTopUp = createAsyncThunk("purchase/startTopUp", function() {
    var _ref = _async_to_generator$d(function(_, param) {
        var dispatch, getState;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch = param.dispatch, getState = param.getState;
                    return [
                        4,
                        new Promise(function(resolve) {
                            return dispatch(externalFlow({
                                start: initTopUpAction({
                                    entry: "low casts",
                                    minCastCredits: 200,
                                    defaultCastCredits: 500,
                                    missingCastCredits: getState().purchase.missingCastCredits,
                                    isStandalone: false
                                }),
                                end: [
                                    exit$5,
                                    complete
                                ],
                                after: function(_) {
                                    return resolve();
                                }
                            }));
                        })
                    ];
                case 1:
                    _state.sent();
                    if (!getState().purchase.channelPass) {
                        dispatch(purchaseConfirmation({}));
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var makeVideoPurchase = createAsyncThunk("purchase/makeVideoPurchase", function() {
    var _ref = _async_to_generator$d(function(_, param) {
        var dispatch, getState, _getState_purchase, video, source, recasterUid, referrer, widgetId, sourceChannelId, intent, result;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch = param.dispatch, getState = param.getState;
                    _getState_purchase = getState().purchase, video = _getState_purchase.video, source = _getState_purchase.source, recasterUid = _getState_purchase.recasterUid, referrer = _getState_purchase.referrer, widgetId = _getState_purchase.widgetId, sourceChannelId = _getState_purchase.sourceChannelId, intent = _getState_purchase.intent;
                    if (!intent) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        dispatch(purchaseApi.endpoints.purchaseIntent.initiate(intent.token)).unwrap()
                    ];
                case 1:
                    result = _state.sent();
                    dispatch(purchaseMade());
                    return [
                        2,
                        {
                            accessToken: result.item.token
                        }
                    ];
                case 2:
                    if (!video) {
                        throw new Error("Video is not defined");
                    }
                    return [
                        4,
                        dispatch(purchaseApi.endpoints.purchaseTariff.initiate({
                            tariff: video.tariff,
                            source: source,
                            recasterUid: recasterUid,
                            referrer: referrer,
                            widgetId: widgetId,
                            sourceChannelId: sourceChannelId
                        })).unwrap()
                    ];
                case 3:
                    _state.sent();
                    dispatch(purchaseMade());
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var purchaseMade = createAsyncThunk("purchase/purchaseMade", function() {
    var _ref = _async_to_generator$d(function(_, param) {
        var dispatch, getState;
        return _ts_generator$d(this, function(_state) {
            dispatch = param.dispatch, getState = param.getState;
            if (getState().purchase.dontShowAgainPurchaseMade) {
                dispatch(exit$3());
            }
            return [
                2
            ];
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var makeChannelPassPurchase = createAsyncThunk("purchase/makeChannelPassPurchase", function() {
    var _ref = _async_to_generator$d(function(_, param) {
        var dispatch, getState, _getState_purchase, channelPass, source, recasterUid;
        return _ts_generator$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch = param.dispatch, getState = param.getState;
                    return [
                        4,
                        dispatch(ensureWalletBalanceBeforePurchase())
                    ];
                case 1:
                    _state.sent();
                    _getState_purchase = getState().purchase, channelPass = _getState_purchase.channelPass, source = _getState_purchase.source, recasterUid = _getState_purchase.recasterUid;
                    if (!channelPass) {
                        throw new Error("missing channel pass");
                    }
                    return [
                        4,
                        dispatch(purchaseApi.endpoints.purchaseTariff.initiate({
                            tariff: channelPass,
                            recasterUid: recasterUid,
                            source: source
                        }, {
                            track: false
                        })).unwrap()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());

var thunkActions$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isChannelPassExpiredAt: isChannelPassExpiredAt,
  startPurchase: startPurchase,
  startChannelPassPurchase: startChannelPassPurchase,
  startIntentPurchaseContinueAction: startIntentPurchaseContinueAction,
  startIntentPurchase: startIntentPurchase,
  redirectToReplayIfLiveEventHaveReplay: redirectToReplayIfLiveEventHaveReplay,
  attemptToUseChannelPass: attemptToUseChannelPass,
  selectChannelPass: selectChannelPass,
  dismissChannelPass: dismissChannelPass,
  purchaseConfirmation: purchaseConfirmation,
  confirmPurchase: confirmPurchase,
  ensureWalletBalanceBeforePurchase: ensureWalletBalanceBeforePurchase,
  startTopUp: startTopUp,
  makeVideoPurchase: makeVideoPurchase,
  purchaseMade: purchaseMade,
  makeChannelPassPurchase: makeChannelPassPurchase
});

function _define_property$m(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$h(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$m(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$7(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$7(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$7(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var initialState$3 = {
    step: "",
    missingCastCredits: 0,
    dontShowAgainPurchaseMade: false,
    skipPurchaseConfirm: false,
    shouldWarnAboutGeoblock: false,
    dontShowGeoblockWarning: false
};
var initialStateReducer = function(state) {
    return _object_spread_props$7(_object_spread$h({}, initialState$3), {
        dontShowAgainPurchaseMade: state.dontShowAgainPurchaseMade,
        skipPurchaseConfirm: state.skipPurchaseConfirm,
        updateDontShowPurchaseMade: state.shouldWarnAboutGeoblock
    });
};
var purchaseSlice = createSlice({
    name: "purchase",
    initialState: initialState$3,
    reducers: {
        updateVideo: function(state, action) {
            state.video = action.payload;
        },
        replayIsProcessing: function(state) {
            state.step = "replay-is-processing";
        },
        streamHasEnded: function(state) {
            state.step = "livestream-ended";
        },
        goToMyDataProfile: initialStateReducer,
        goToWatchAndEarn: initialStateReducer,
        goToChannel: initialStateReducer,
        exit: initialStateReducer,
        updateDontShowPurchaseMade: function(state, action) {
            state.dontShowAgainPurchaseMade = action.payload;
        },
        updateSkipPurchaseConfirm: function(state, action) {
            state.skipPurchaseConfirm = action.payload;
        },
        handleGeoblockWarning: function(state, action) {
            state.shouldWarnAboutGeoblock = action.payload.shouldWarnAboutGeoblock;
            state.channelName = action.payload.channelName;
        }
    },
    extraReducers: function(builder) {
        var startPurchasePayloadReducer = function(state, action) {
            if (action.payload === "sign-up") {
                state.step = "sign-up";
            } else if (action.payload === "unsupported-region") {
                state.step = "unsupported-region";
            }
        };
        builder.addCase(startPurchase.pending, function(state, action) {
            state.step = "init";
            state.video = action.meta.arg.video;
            state.channel = action.meta.arg.video.channel;
            var _action_meta_arg_isDataProfileFilled;
            state.isDataProfileFilled = (_action_meta_arg_isDataProfileFilled = action.meta.arg.isDataProfileFilled) !== null && _action_meta_arg_isDataProfileFilled !== void 0 ? _action_meta_arg_isDataProfileFilled : false;
            state.source = action.meta.arg.source;
            state.recasterUid = action.meta.arg.recasterUid;
            state.referrer = action.meta.arg.referrer;
            state.widgetId = action.meta.arg.widgetId;
            state.sourceChannelId = action.meta.arg.sourceChannelId;
            state.channelPass = undefined;
        }).addCase(startPurchase.fulfilled, startPurchasePayloadReducer).addCase(startChannelPassPurchase.fulfilled, startPurchasePayloadReducer).addCase(startIntentPurchase.pending, function(state, action) {
            state.step = "init";
            var _decodeJwtToken;
            state.intent = {
                token: action.meta.arg.intentToken,
                payload: (_decodeJwtToken = decodeJwtToken(action.meta.arg.intentToken)) !== null && _decodeJwtToken !== void 0 ? _decodeJwtToken : undefined
            };
        }).addCase(startIntentPurchase.fulfilled, function(state, action) {
            if (action.payload === "") {
                state.step = "confirm-purchase";
            }
            startPurchasePayloadReducer(state, action);
        }).addCase(startIntentPurchaseContinueAction, function(state, param) {
            var payload = param.payload;
            state.step = "confirm-purchase";
            state.product = payload.product;
        }).addCase(attemptToUseChannelPass.fulfilled, function(state, action) {
            var _action_payload, _action_payload1, _action_payload2;
            if (((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.type) === "show-suggest-channel-pass") {
                state.step = "suggest-channel-pass";
            } else if (((_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.type) === "show-channel-pass-expires") {
                state.step = "live-event-expired-channel-pass";
                state.activeChannelPass = action.payload.activeChannelPass;
            } else if (((_action_payload2 = action.payload) === null || _action_payload2 === void 0 ? void 0 : _action_payload2.type) === "active-channel-pass") {
                return initialState$3;
            }
            return;
        }).addCase(purchaseConfirmation.fulfilled, function(state, action) {
            if ((state.step === "init" || state.step === "sign-up" || state.step === "top-up" || state.step === "suggest-channel-pass") && action.payload) {
                state.step = "confirm-purchase";
            }
        }).addCase(confirmPurchase.pending, function(state, action) {
            if (action.meta.arg.dontShowAgain) {
                state.skipPurchaseConfirm = true;
            }
        }).addCase(startTopUp.pending, function(state) {
            state.step = "top-up";
        }).addCase(purchaseMade.fulfilled, function(state, action) {
            if (state.step === "init" || state.step === "sign-up" || state.step === "confirm-purchase" || state.step === "top-up" || state.step === "suggest-channel-pass") {
                state.step = "purchase-made";
            }
        }).addCase(selectChannelPass.pending, function(state, action) {
            state.channelPass = action.meta.arg.channelPass;
        }).addCase(selectChannelPass.fulfilled, function(state, action) {
            if (action.payload === "show-confirm-channel-pass") {
                state.step = "confirm-channel-pass-purchase";
            }
        }).addCase(ensureWalletBalanceBeforePurchase.fulfilled, function(state, action) {
            if (action.payload > 0) {
                state.step = "need-more-credits";
                state.missingCastCredits = action.payload;
            } else if (state.channelPass) {
                state.step = "confirm-channel-pass-purchase";
            }
        }).addCase(startTopUp.fulfilled, function(state) {
            if (state.channelPass) {
                state.step = "confirm-channel-pass-purchase";
                state.dontShowGeoblockWarning = true;
            }
        }).addCase(makeChannelPassPurchase.fulfilled, function(state) {
            return state.dontShowAgainPurchaseMade ? initialStateReducer(state) : _object_spread_props$7(_object_spread$h({}, state), {
                step: "channel-pass-purchased"
            });
        }).addCase(makeVideoPurchase.fulfilled, function(state, action) {
            if (typeof action.payload === "object" && "accessToken" in action.payload) {
                state.accessToken = action.payload.accessToken;
            }
        });
    }
});
var _purchaseSlice_actions = purchaseSlice.actions;
var exit$3 = _purchaseSlice_actions.exit, updateVideo = _purchaseSlice_actions.updateVideo, streamHasEnded = _purchaseSlice_actions.streamHasEnded, replayIsProcessing = _purchaseSlice_actions.replayIsProcessing; _purchaseSlice_actions.goToMyDataProfile; _purchaseSlice_actions.goToWatchAndEarn; var goToChannel = _purchaseSlice_actions.goToChannel, updateDontShowPurchaseMade = _purchaseSlice_actions.updateDontShowPurchaseMade, updateSkipPurchaseConfirm = _purchaseSlice_actions.updateSkipPurchaseConfirm, handleGeoblockWarning = _purchaseSlice_actions.handleGeoblockWarning;

function PurchaseNeedMoreCredits(param) {
    var dispatch = param.dispatch, state = param.state, balance = param.balance, onTrack = param.onTrack;
    var _state_channelPass, _state_video_basicCost_, _state_video;
    var t = useTranslation().t;
    var _state_channelPass_priceDetails_price, _ref;
    var required = (_ref = (_state_channelPass_priceDetails_price = (_state_channelPass = state.channelPass) === null || _state_channelPass === void 0 ? void 0 : _state_channelPass.priceDetails.price) !== null && _state_channelPass_priceDetails_price !== void 0 ? _state_channelPass_priceDetails_price : (_state_video = state.video) === null || _state_video === void 0 ? void 0 : (_state_video_basicCost_ = _state_video.basicCost[0]) === null || _state_video_basicCost_ === void 0 ? void 0 : _state_video_basicCost_.units) !== null && _ref !== void 0 ? _ref : 0;
    return /*#__PURE__*/ jsxs(Stack, {
        alignItems: "stretch",
        sx: {
            "&>svg": {
                alignSelf: "center"
            }
        },
        children: [
            /*#__PURE__*/ jsx(CastCreditProgress, {
                current: balance,
                required: required
            }),
            /*#__PURE__*/ jsx(Button, {
                sx: {
                    marginTop: "24px",
                    marginBottom: "16px"
                },
                fullWidth: true,
                onClick: function() {
                    void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                        category: "purchase",
                        action: "click",
                        label: "need-more-credits-buy"
                    }));
                    dispatch(startTopUp());
                },
                children: t("components.purchase.needMoreCredits.buyCastCredits", "Buy Cast Credits")
            }),
            /*#__PURE__*/ jsx(PaymentLockupGrey, {})
        ]
    });
}

function _define_property$l(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$g(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$l(target, key, source[key]);
        });
    }
    return target;
}
var getPurchaseMadeSubtitle = function(step, video, t) {
    if ((video === null || video === void 0 ? void 0 : video.videoType) === VideoListingTypes.ON_DEMAND) {
        return t("components.purchase.header.subtitle.youHaveAccessToVideo", "You now have access to the full video");
    }
    return t("components.purchase.header.subtitle.youAreBooked", "You are booked!");
};
var getHeaderProps = function(step, video, missingCastCredits, shouldWarnAboutGeoblock, dontShowGeoblockWarning, t) {
    switch(step){
        case "need-more-credits":
            return {
                icon: /*#__PURE__*/ jsx(Icon, {
                    component: ThreeCasts,
                    sx: {
                        width: 128,
                        height: 64
                    }
                }),
                title: t("components.purchase.header.title.youNeedSomeMoreCredits", missingCastCredits === 1 ? "You need 1 more credit!" : "You need {{ count }} more credits!", {
                    count: missingCastCredits
                })
            };
        case "suggest-channel-pass":
            return {
                icon: /*#__PURE__*/ jsx(Icon, {
                    component: ChannelPass$1,
                    sx: {
                        fontSize: 64,
                        color: "black"
                    }
                }),
                title: t("feature.channelPasses.suggestChannelPass.title", "Maybe consider a Channel Pass?"),
                subtitle: t("feature.channelPasses.suggestChannelPass.subtitle", "Watch ALL of this channel's content for less")
            };
        case "confirm-purchase":
            return {
                icon: /*#__PURE__*/ jsx(Icon, {
                    component: Padlock,
                    sx: function(theme) {
                        return {
                            fontSize: 64,
                            color: theme.palette.common.black
                        };
                    }
                }),
                title: t("components.purchase.header.title.confirmPurchase", "Do you still want to watch this video?")
            };
        case "purchase-made":
            return {
                icon: /*#__PURE__*/ jsx(Icon, {
                    component: RecastR,
                    sx: {
                        fontSize: 96,
                        color: "black"
                    }
                }),
                title: t("components.purchase.header.title.success", "Success!"),
                subtitle: getPurchaseMadeSubtitle(step, video, t)
            };
        case "confirm-channel-pass-purchase":
            return {
                icon: /*#__PURE__*/ jsx(Icon, {
                    component: ChannelPass$1,
                    sx: {
                        fontSize: "64px",
                        color: "black"
                    }
                }),
                title: shouldWarnAboutGeoblock && !dontShowGeoblockWarning ? t("feature.channelPasses.purchaseFlow.confirmationTitleWithWarning", "Do you still wish to buy?") : t("feature.channelPasses.purchaseFlow.confirmationTitle", "We just want to check"),
                subtitle: shouldWarnAboutGeoblock && !dontShowGeoblockWarning ? t("feature.channelPasses.purchaseFlow.confirmationSubtitleWithWarning", "This channel has some geo-blocked content") : t("feature.channelPasses.purchaseFlow.confirmationSubtitle", "Do you still want to buy this pass?")
            };
        case "channel-pass-purchased":
            return {
                icon: /*#__PURE__*/ jsx(Icon, {
                    component: RecastR,
                    sx: {
                        fontSize: 96,
                        color: "black"
                    }
                }),
                title: t("components.purchase.header.title.success", "Success!"),
                subtitle: t("components.purchase.header.subtitle.youAreAllSetToWatch", "You're all set to watch")
            };
        case "live-event-expired-channel-pass":
            return {
                icon: /*#__PURE__*/ jsx(Icon, {
                    component: ChannelPass$1,
                    sx: {
                        fontSize: "64px",
                        color: "black"
                    }
                }),
                title: t("feature.channelPasses.futureEvent.title", "Please Note!"),
                subtitle: t("feature.channelPasses.futureEvent.subtitle", "This event is not covered by your current pass")
            };
        default:
            return {
                title: ""
            };
    }
};
function PurchaseHeader(param) {
    var step = param.step, video = param.video, missingCastCredits = param.missingCastCredits, shouldWarnAboutGeoblock = param.shouldWarnAboutGeoblock, dontShowGeoblockWarning = param.dontShowGeoblockWarning;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(ModalHeader, _object_spread$g({}, getHeaderProps(step, video, missingCastCredits, shouldWarnAboutGeoblock, dontShowGeoblockWarning, t)));
}

function getActionLabel(t, state) {
    if (state.step === "purchase-made") {
        var _state_video, _state_video_liveDetails;
        var _state_video_liveDetails_startTime;
        var isLiveEventInFuture = ((_state_video = state.video) === null || _state_video === void 0 ? void 0 : _state_video.videoType) === VideoListingTypes.LIVE && isFuture(new Date((_state_video_liveDetails_startTime = (_state_video_liveDetails = state.video.liveDetails) === null || _state_video_liveDetails === void 0 ? void 0 : _state_video_liveDetails.startTime) !== null && _state_video_liveDetails_startTime !== void 0 ? _state_video_liveDetails_startTime : ""));
        if (isLiveEventInFuture) {
            return t("components.purchase.bottomAction.close", "Close");
        }
        return t("components.purchase.bottomAction.letsGo", "Let's go!");
    } else if (state.step === "channel-pass-purchased") {
        return t("components.purchase.bottomAction.letsGo", "Let's go!");
    } else if (state.step === "sign-up" || state.step === "init") {
        return "";
    } else if (state.shouldWarnAboutGeoblock) {
        return t("components.purchase.bottomAction.close", "Close");
    }
    return t("components.purchase.bottomAction.notNow", "Not now");
}
function PurchaseBottomAction(param) {
    var dispatch = param.dispatch, state = param.state;
    var t = useTranslation().t;
    var actionLabel = getActionLabel(t, state);
    return /*#__PURE__*/ jsx(ModalActions, {
        children: /*#__PURE__*/ jsx(ModalButton, {
            onClick: function() {
                return dispatch(exit$3());
            },
            children: actionLabel
        })
    });
}

function LiveEventReplayProcessing(param) {
    var video = param.video, dispatch = param.dispatch, onTrack = param.onTrack;
    return /*#__PURE__*/ jsx(ReplayIsProcessingModal, {
        channelName: video.channel.name,
        onConfirm: function() {
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "purchase",
                action: "click",
                label: "replay-is-processing-confirm"
            }));
            dispatch(goToChannel());
        },
        onClose: function() {
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "purchase",
                action: "click",
                label: "replay-is-processing-close"
            }));
            dispatch(exit$3());
        }
    });
}

function LiveEventEnded(param) {
    var video = param.video, dispatch = param.dispatch, onTrack = param.onTrack;
    return /*#__PURE__*/ jsx(LiveEventEndedModal, {
        channelName: video.channel.name,
        onConfirm: function() {
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "purchase",
                action: "click",
                label: "livestream-ended-confirm"
            }));
            dispatch(goToChannel());
        },
        onClose: function() {
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "purchase",
                action: "click",
                label: "livestream-ended-close"
            }));
            dispatch(exit$3());
        }
    });
}

function PurchaseConfirmVideo(param) {
    var dispatch = param.dispatch, state = param.state, onTrack = param.onTrack;
    var _state_video, _state_video1;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(Formik, {
        initialValues: {
            dontShowAgain: false
        },
        onSubmit: function(param) {
            var dontShowAgain = param.dontShowAgain;
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "purchase",
                action: "click",
                label: "confirm-purchase-confirm"
            }));
            dispatch(confirmPurchase({
                accept: true,
                dontShowAgain: dontShowAgain
            }));
        },
        children: /*#__PURE__*/ jsx(Form, {
            children: /*#__PURE__*/ jsxs(Stack, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ jsxs(Stack, {
                        sx: {
                            alignSelf: "stretch",
                            height: "212px",
                            marginTop: "20px",
                            img: {
                                objectFit: "cover"
                            }
                        },
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            state.video && /*#__PURE__*/ jsx(Image, {
                                height: 212,
                                width: 368,
                                src: (_state_video = state.video) === null || _state_video === void 0 ? void 0 : _state_video.listingDisplay.thumbnail.image.uri,
                                alt: ((_state_video1 = state.video) === null || _state_video1 === void 0 ? void 0 : _state_video1.listingDisplay.thumbnail.title) || ""
                            }),
                            state.product && /*#__PURE__*/ jsx(Typography, {
                                children: state.product.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(Button, {
                        fullWidth: true,
                        sx: {
                            marginTop: "24px"
                        },
                        type: "submit",
                        children: t("components.purchase.confirmVideo.yes", "Yes I do!")
                    }),
                    /*#__PURE__*/ jsx(FormikCheckbox, {
                        sx: {
                            marginTop: "8px"
                        },
                        name: "dontShowAgain",
                        label: t("components.purchase.confirmVideo.dontShowAgain", "Don't show me this again")
                    })
                ]
            })
        })
    });
}

function _define_property$k(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$f(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$k(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$6(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var StyledStack$3 = styled(Stack)({
    border: "1px solid #E5E5E5",
    marginTop: "16px",
    width: "100%"
});
var PurchaseMadeContent = function(param) {
    var dispatch = param.dispatch, onTrack = param.onTrack, text = param.text;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(StyledStack$3, {
                sx: {
                    height: 207
                },
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ jsx(SuccessCasty, {})
            }),
            /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                color: "text.secondary",
                align: "center",
                sx: {
                    marginTop: "24px"
                },
                children: text
            }),
            /*#__PURE__*/ jsx(Checkbox, {
                sx: {
                    marginTop: "4px"
                },
                label: t("components.purchase.purchaseMade.dontShowAgain", "Don't show me this again"),
                checkboxProps: {
                    onChange: function(e) {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "purchase",
                            action: "click",
                            label: "purchase-made-dont-show-again-".concat(e.target.checked)
                        }));
                        dispatch(updateDontShowPurchaseMade(e.target.checked));
                    }
                }
            })
        ]
    });
};
var VoDAndLiveEventContent = function(_param) {
    var video = _param.video, props = _object_without_properties(_param, [
        "video"
    ]);
    var _video_channel;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(PurchaseMadeContent, _object_spread_props$6(_object_spread$f({}, props), {
        text: t("components.purchase.purchaseMade.thanksForSupporting", "Thanks for supporting {{channel}}. You've spent {{casts}} Cast Credits. Every time you spend on Recast you are directly benefiting the content creator.", {
            channel: video === null || video === void 0 ? void 0 : (_video_channel = video.channel) === null || _video_channel === void 0 ? void 0 : _video_channel.name,
            casts: video === null || video === void 0 ? void 0 : video.basicCost[0].units
        })
    }));
};
var ChannelPassContent = function(_param) {
    var channel = _param.channel, channelName = _param.channelName, channelPass = _param.channelPass, props = _object_without_properties(_param, [
        "channel",
        "channelName",
        "channelPass"
    ]);
    var t = useTranslation().t;
    var _channelPass_rentalPeriod;
    var passDuration = secondsToDays((_channelPass_rentalPeriod = channelPass === null || channelPass === void 0 ? void 0 : channelPass.rentalPeriod) !== null && _channelPass_rentalPeriod !== void 0 ? _channelPass_rentalPeriod : 0);
    return /*#__PURE__*/ jsx(PurchaseMadeContent, _object_spread_props$6(_object_spread$f({}, props), {
        text: "".concat(t("feature.channelPasses.purchaseFlow.confirmationDescription", "You can now enjoy all of {{channelName}}'s content for the next {{passDuration}}", {
            channelName: (channel === null || channel === void 0 ? void 0 : channel.name) || channelName,
            passDuration: passDuration > 1 ? passDuration : ""
        }), " ").concat(passDuration > 1 ? t("feature.channelPasses.pass.days", "days") : t("feature.channelPasses.pass.day", "day"))
    }));
};
var FutureEventContent = function(param) {
    var video = param.video, startTime = param.startTime;
    var t = useTranslation().t;
    var locale = useDateLocale();
    var now = new Date();
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs(StyledStack$3, {
                sx: {
                    height: 207
                },
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ jsx(SuccessCasty, {}),
                    /*#__PURE__*/ jsxs(Stack, {
                        direction: "row",
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "center",
                        marginTop: "24px",
                        children: [
                            /*#__PURE__*/ jsx(Icon, {
                                component: EventCalendar,
                                sx: {
                                    margin: "8px"
                                }
                            }),
                            /*#__PURE__*/ jsx(Typography, {
                                variant: "body2",
                                sx: {
                                    fontWeight: 600
                                },
                                children: video === null || video === void 0 ? void 0 : video.listingDisplay.thumbnail.title
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                color: "text.secondary",
                align: "center",
                sx: {
                    marginTop: "24px"
                },
                children: t("components.purchase.liveEventInFuture.secondary.today", "See you back here {{date}}.", {
                    date: dateToRelativeString(startTime, now, locale)
                })
            })
        ]
    });
};
function PurchaseMade(param) {
    var dispatch = param.dispatch, state = param.state;
    var _state_video_liveDetails, _state_video, _state_video1;
    var _state_video_liveDetails_startTime;
    var startTime = new Date((_state_video_liveDetails_startTime = (_state_video = state.video) === null || _state_video === void 0 ? void 0 : (_state_video_liveDetails = _state_video.liveDetails) === null || _state_video_liveDetails === void 0 ? void 0 : _state_video_liveDetails.startTime) !== null && _state_video_liveDetails_startTime !== void 0 ? _state_video_liveDetails_startTime : "");
    var isLiveEventInFuture = ((_state_video1 = state.video) === null || _state_video1 === void 0 ? void 0 : _state_video1.videoType) === VideoListingTypes.LIVE && isFuture(startTime);
    var Content = state.step === "channel-pass-purchased" ? ChannelPassContent : isLiveEventInFuture ? FutureEventContent : VoDAndLiveEventContent;
    return /*#__PURE__*/ jsx(Stack, {
        alignItems: "center",
        children: /*#__PURE__*/ jsx(Content, {
            video: state.video,
            channel: state.channel,
            channelName: state.channelName,
            channelPass: state.channelPass,
            startTime: startTime,
            dispatch: dispatch
        })
    });
}

var StyledButton = styled(Button)({
    height: "auto",
    width: "100%",
    margin: "20px 0"
});
var StyledInfoText = styled(Typography)({
    textAlign: "center"
});
var SuggestChannelPassButtons = function(props) {
    var video = props.video, selectedPass = props.selectedPass, dispatch = props.dispatch;
    var _video_basicCost__units;
    var videoCost = (_video_basicCost__units = video === null || video === void 0 ? void 0 : video.basicCost[0].units) !== null && _video_basicCost__units !== void 0 ? _video_basicCost__units : 0;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(StyledButton, {
                disabled: !selectedPass,
                onClick: function() {
                    return selectedPass && dispatch(selectChannelPass({
                        channelPass: selectedPass
                    }));
                },
                children: selectedPass ? t("feature.channelPasses.suggestChannelPass.buyPass", "Buy Channel Pass & Watch Video") : t("feature.channelPasses.suggestChannelPass.selectPass", "Select pass to continue")
            }),
            /*#__PURE__*/ jsx(StyledInfoText, {
                variant: "body2",
                sx: function(param) {
                    var palette = param.palette;
                    return {
                        marginBottom: "10px",
                        color: palette.text.secondary
                    };
                },
                children: t("feature.channelPasses.suggestChannelPass.passExpiry", "When Channel Passes expire you will no longer be able to view the videos you have watched using the channel pass")
            }),
            /*#__PURE__*/ jsx(StyledInfoText, {
                variant: "body2",
                sx: {
                    color: "black",
                    fontWeight: 400
                },
                children: t("feature.channelPasses.suggestChannelPass.or", "or")
            }),
            /*#__PURE__*/ jsxs(StyledButton, {
                className: selectedPass ? "button--gray-light" : "",
                onClick: function() {
                    return dispatch(dismissChannelPass());
                },
                children: [
                    t("feature.channelPasses.suggestChannelPass.buyVideo", "Watch video for {{videoCost}}", {
                        videoCost: videoCost
                    }),
                    " ",
                    videoCost > 1 ? t("feature.channelPasses.futureEvent.buttonText.multipleCredits", "credits") : t("singleCredit", "credit")
                ]
            })
        ]
    });
};

function _define_property$j(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$e(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$j(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var icon = {
    width: "1em",
    height: "1em",
    borderRadius: "50%",
    backgroundColor: "white",
    position: "relative"
};
var StyledRadio = styled(Radio)({
    padding: "0.33em",
    "&:hover": {
        backgroundColor: "transparent"
    }
});
var StyledIcon = styled("span")(icon);
var StyledCheckedIcon = styled("span")(function(param) {
    var theme = param.theme;
    return _object_spread_props$5(_object_spread$e({}, icon), {
        "&:before": {
            borderRadius: "50%",
            position: "absolute",
            width: "0.67em",
            height: "0.67em",
            background: theme.palette.primary.main,
            left: "0.17em",
            top: "0.17em",
            content: '""'
        }
    });
});
var ModalRadio = function(props) {
    return /*#__PURE__*/ jsx(StyledRadio, _object_spread$e({
        disableRipple: true,
        color: "default",
        checkedIcon: /*#__PURE__*/ jsx(StyledCheckedIcon, {}),
        icon: /*#__PURE__*/ jsx(StyledIcon, {})
    }, props));
};

function _array_like_to_array$c(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes$1(arr) {
    if (Array.isArray(arr)) return _array_like_to_array$c(arr);
}
function _define_property$i(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array$1(arr) {
    return _array_without_holes$1(arr) || _iterable_to_array$1(arr) || _unsupported_iterable_to_array$c(arr) || _non_iterable_spread$1();
}
function _unsupported_iterable_to_array$c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$c(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$c(o, minLen);
}
var mediumQuery = "@container (max-width: 170px)";
var smallQuery = "@container (max-width: 105px)";
var ChannelPassRadio = function(props) {
    var price = props.price, duration = props.duration, selectedPass = props.selectedPass, passId = props.passId, onClick = props.onClick, sx = props.sx;
    var t = useTranslation().t;
    var durationInDays = secondsToDays(duration);
    return /*#__PURE__*/ jsx(Ticket, {
        onClick: onClick,
        sx: [
            {
                cursor: onClick && "pointer",
                containerType: "size",
                aspectRatio: "180/223",
                flexGrow: 1
            }
        ].concat(_to_consumable_array$1(Array.isArray(sx) ? sx : [
            sx
        ])),
        topLeft: /*#__PURE__*/ jsx(FormControlLabel, {
            onClick: onClick,
            control: /*#__PURE__*/ jsx(ModalRadio, {
                checked: selectedPass === passId,
                sx: _define_property$i({
                    fontSize: "24px"
                }, mediumQuery, {
                    fontSize: "16px"
                })
            }),
            label: ""
        }),
        children: /*#__PURE__*/ jsxs(Stack, {
            alignItems: "center",
            children: [
                /*#__PURE__*/ jsx(Icon, {
                    component: ChannelPass$1,
                    sx: function(param) {
                        var palette = param.palette;
                        var _obj;
                        return _obj = {
                            color: palette.primary.main,
                            fontSize: "40px",
                            marginTop: "12px"
                        }, _define_property$i(_obj, mediumQuery, {
                            fontSize: "24px",
                            marginTop: "-2px"
                        }), _define_property$i(_obj, smallQuery, {
                            fontSize: "16px",
                            marginTop: "-8px"
                        }), _obj;
                    }
                }),
                /*#__PURE__*/ jsx(Typography, {
                    sx: function(param) {
                        var palette = param.palette;
                        return _define_property$i({
                            color: palette.primary.main,
                            marginTop: "8px"
                        }, mediumQuery, {
                            display: "none"
                        });
                    },
                    children: t("feature.channelPasses.pass.description", "CHANNEL PASS")
                }),
                /*#__PURE__*/ jsxs(Typography, {
                    variant: "body1",
                    sx: function(param) {
                        var palette = param.palette;
                        var _obj;
                        return _obj = {
                            fontSize: "40px",
                            fontWeight: 600,
                            lineHeight: "56px",
                            color: palette.common.white
                        }, _define_property$i(_obj, mediumQuery, {
                            fontSize: "24px",
                            lineHeight: "30px",
                            marginTop: "8px"
                        }), _define_property$i(_obj, smallQuery, {
                            fontSize: "18px",
                            lineHeight: "20px",
                            marginTop: "4px"
                        }), _obj;
                    },
                    children: [
                        durationInDays,
                        " ",
                        durationInDays > 1 ? t("feature.channelPasses.pass.days", "days") : t("feature.channelPasses.pass.day", "day")
                    ]
                }),
                /*#__PURE__*/ jsxs(Stack, {
                    sx: _define_property$i({
                        flexDirection: "row",
                        gap: "0 4px",
                        marginTop: "2px",
                        alignItems: "center"
                    }, mediumQuery, {
                        flexDirection: "column"
                    }),
                    children: [
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body1",
                            sx: _define_property$i({
                                fontSize: "14px",
                                fontWeight: 300,
                                lineHeight: "16px",
                                color: "#B4B4B4"
                            }, mediumQuery, {
                                fontSize: "10px"
                            }),
                            children: t("feature.channelPass.pass.forOnly", "for only")
                        }),
                        /*#__PURE__*/ jsxs(Stack, {
                            direction: "row",
                            alignItems: "baseline",
                            gap: "2px",
                            children: [
                                /*#__PURE__*/ jsx(Typography, {
                                    variant: "h3",
                                    sx: function(param) {
                                        var palette = param.palette;
                                        return {
                                            fontSize: "14px",
                                            fontWeight: 300,
                                            lineHeight: "16px",
                                            color: palette.common.white
                                        };
                                    },
                                    children: price
                                }),
                                /*#__PURE__*/ jsx(Icon, {
                                    component: CastCredit,
                                    sx: function(param) {
                                        var palette = param.palette;
                                        return {
                                            fontSize: "10px",
                                            color: palette.common.white
                                        };
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

function _array_like_to_array$b(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$a(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$a(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$a() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$a(arr, i) {
    return _array_with_holes$a(arr) || _iterable_to_array_limit$a(arr, i) || _unsupported_iterable_to_array$b(arr, i) || _non_iterable_rest$a();
}
function _unsupported_iterable_to_array$b(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$b(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$b(o, minLen);
}
var SuggestChannelPass = function(param) {
    var state = param.state, dispatch = param.dispatch;
    var video = state.video, channel = state.channel;
    var _useState = _sliced_to_array$a(useState(null), 2), selectedPass = _useState[0], setSelectedPass = _useState[1];
    var channelPasses = useMemo(function() {
        if (video && (channel === null || channel === void 0 ? void 0 : channel.channelPasses)) {
            var _video_liveDetails;
            var isScheduledBroadcast = (video === null || video === void 0 ? void 0 : video.videoType) === "live" && (video === null || video === void 0 ? void 0 : (_video_liveDetails = video.liveDetails) === null || _video_liveDetails === void 0 ? void 0 : _video_liveDetails.status) !== VideoListingLiveDetailsStatus.live;
            return channel.channelPasses.filter(function(pass) {
                var _video_liveDetails;
                return isScheduledBroadcast && ((_video_liveDetails = video.liveDetails) === null || _video_liveDetails === void 0 ? void 0 : _video_liveDetails.startTime) ? isChannelPassExpiredAt(pass, video.liveDetails.startTime) : true;
            }).sort(function(a, b) {
                return a.rentalPeriod - b.rentalPeriod;
            });
        }
        return [];
    }, [
        channel === null || channel === void 0 ? void 0 : channel.channelPasses,
        video
    ]);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Stack, {
                direction: "row",
                gap: "8px",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "200px",
                children: channelPasses.map(function(option) {
                    return /*#__PURE__*/ jsx(ChannelPassRadio, {
                        onClick: function() {
                            return setSelectedPass(option);
                        },
                        passId: option.id,
                        selectedPass: selectedPass === null || selectedPass === void 0 ? void 0 : selectedPass.id,
                        price: option.priceDetails.price,
                        duration: option.rentalPeriod
                    }, option.id);
                })
            }),
            /*#__PURE__*/ jsx(SuggestChannelPassButtons, {
                video: video,
                selectedPass: selectedPass,
                dispatch: dispatch
            })
        ]
    });
};

var ChannelPassConfirmation = function(props) {
    var _state_channelPass, _state_channelPass1, _state_channelPass2;
    var state = props.state, dispatch = props.dispatch;
    var shouldWarnAboutGeoblock = state.shouldWarnAboutGeoblock;
    var t = useTranslation().t;
    var _state_channelPass_id, _state_channelPass_priceDetails_price, _state_channelPass_rentalPeriod;
    return /*#__PURE__*/ jsxs(Stack, {
        alignItems: "center",
        sx: {
            marginTop: "4px"
        },
        children: [
            /*#__PURE__*/ jsx(ChannelPassRadio, {
                passId: (_state_channelPass_id = (_state_channelPass = state.channelPass) === null || _state_channelPass === void 0 ? void 0 : _state_channelPass.id) !== null && _state_channelPass_id !== void 0 ? _state_channelPass_id : "",
                price: (_state_channelPass_priceDetails_price = (_state_channelPass1 = state.channelPass) === null || _state_channelPass1 === void 0 ? void 0 : _state_channelPass1.priceDetails.price) !== null && _state_channelPass_priceDetails_price !== void 0 ? _state_channelPass_priceDetails_price : 0,
                duration: (_state_channelPass_rentalPeriod = (_state_channelPass2 = state.channelPass) === null || _state_channelPass2 === void 0 ? void 0 : _state_channelPass2.rentalPeriod) !== null && _state_channelPass_rentalPeriod !== void 0 ? _state_channelPass_rentalPeriod : 0,
                sx: {
                    width: "180px"
                }
            }),
            shouldWarnAboutGeoblock && !state.dontShowGeoblockWarning ? /*#__PURE__*/ jsx(Formik, {
                initialValues: {
                    geoblockWarning: false
                },
                onSubmit: function(param, param1) {
                    var geoblockWarning = param.geoblockWarning, setFieldError = param1.setFieldError;
                    if (!geoblockWarning) {
                        setFieldError("geoblockWarning", t("feature.channelPasses.purchaseFlow.geoblockWarningError", "Please confirm you have checked that the content you want to watch is available to you"));
                    } else {
                        dispatch(makeChannelPassPurchase());
                    }
                },
                children: function(param) {
                    var errors = param.errors;
                    return /*#__PURE__*/ jsxs(Form, {
                        children: [
                            /*#__PURE__*/ jsx(FormikCheckbox, {
                                name: "geoblockWarning",
                                error: !!errors.geoblockWarning,
                                sx: {
                                    marginTop: "35px",
                                    alignItems: "flex-start",
                                    "& span:first-child": {
                                        paddingTop: 0,
                                        paddingLeft: 0
                                    }
                                },
                                label: t("feature.channelPasses.purchaseFlow.geoblockWarningLabel", "Some content from {{channelName}} is geoblocked. Select to confirm you have checked the content you want to watch is available in your region", {
                                    channelName: state.channelName
                                })
                            }),
                            errors.geoblockWarning ? /*#__PURE__*/ jsx(Typography, {
                                variant: "body2",
                                color: "error",
                                sx: {
                                    marginTop: "9px"
                                },
                                children: errors.geoblockWarning
                            }) : null,
                            /*#__PURE__*/ jsx(Button, {
                                fullWidth: true,
                                sx: {
                                    marginTop: "34px"
                                },
                                type: "submit",
                                disabled: !!errors.geoblockWarning,
                                children: t("feature.channelPasses.purchaseFlow.confirmationButtonTextWithWarning", "Purchase Pass")
                            })
                        ]
                    });
                }
            }) : /*#__PURE__*/ jsx(Button, {
                fullWidth: true,
                sx: {
                    marginTop: "34px"
                },
                onClick: function() {
                    return dispatch(makeChannelPassPurchase());
                },
                children: t("feature.channelPasses.purchaseFlow.confirmationButtonText", "Yes I do!")
            })
        ]
    });
};

var Container = styled(Box)({
    display: "grid",
    gridTemplate: '"top-left div top-right" "bottom-left div bottom-right"',
    gridTemplateColumns: "1fr 1px 1fr",
    rowGap: "4px",
    gridTemplateRows: "minmax(166px) auto"
});
var TopBackground = styled("div")(function(param) {
    var theme = param.theme;
    return {
        gridArea: "1 / 1 / 1 / 4",
        background: theme.palette.grey[100]
    };
});
var Divider = styled("div")(function(param) {
    var theme = param.theme;
    return {
        height: "100%",
        borderRight: "1px dashed ".concat(theme.palette.grey[400]),
        gridArea: "div"
    };
});
var TopLeft = styled(Box)({
    gridArea: "top-left",
    padding: "16px 8px",
    background: "#B1EFE9",
    clipPath: "polygon(0 0, 52% 0, calc(100% - 4px) 50%, 52% 100%, 0 100%)"
});
var TopRight = styled(Box)({
    gridArea: "top-right",
    padding: "16px 12px",
    "& img": {
        width: "100%",
        height: "unset",
        aspectRatio: "16/9",
        objectFit: "cover"
    }
});
var formatDateForCard = function(dateString) {
    var date = textToDate(dateString);
    var day = isToday(date) ? "Today" : format(date, "d MMM");
    var hour = format(date, "HH:mm a");
    return "".concat(day, " @ ").concat(hour);
};
var EventWarningCard = function(props) {
    var videoThumbnail = props.videoThumbnail, passExpiry = props.passExpiry, eventStartTime = props.eventStartTime;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Container, {
        children: [
            /*#__PURE__*/ jsx(TopBackground, {}),
            /*#__PURE__*/ jsx(Divider, {}),
            /*#__PURE__*/ jsxs(TopLeft, {
                children: [
                    /*#__PURE__*/ jsx(ChannelPass$1, {
                        fontSize: "32px"
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        fontSize: "12px",
                        sx: {
                            width: "80%",
                            padding: "20px 0"
                        },
                        children: /*#__PURE__*/ jsx(Trans, {
                            i18nKey: "feature.channelPasses.futureEvent.cardDescription",
                            defaults: "Your channel pass expires <S>before</S> this event starts",
                            components: {
                                S: /*#__PURE__*/ jsx("strong", {})
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ jsxs(TopRight, {
                children: [
                    /*#__PURE__*/ jsx(Image, {
                        src: videoThumbnail.image.uri,
                        alt: videoThumbnail.title,
                        width: 160,
                        height: 90
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "body2",
                        fontWeight: 400,
                        sx: {
                            paddingTop: "5px"
                        },
                        children: videoThumbnail.title
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Box, {
                gridArea: "bottom-left",
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body2",
                    children: t("feature.channelPasses.futureEvent.passExpires", "Pass expires {{expiryDate}}", {
                        expiryDate: formatDateForCard(passExpiry)
                    })
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                gridArea: "bottom-right",
                paddingLeft: "12px",
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body2",
                    children: t("feature.channelPasses.futureEvent.eventStart", "Event start: {{eventStart}}", {
                        eventStart: formatDateForCard(eventStartTime)
                    })
                })
            })
        ]
    });
};

var LiveEventExpiredChannelPass = function(param) {
    var state = param.state, dispatch = param.dispatch;
    var t = useTranslation().t;
    var video = state.video, activeChannelPass = state.activeChannelPass;
    if (!(video === null || video === void 0 ? void 0 : video.liveDetails) || !(activeChannelPass === null || activeChannelPass === void 0 ? void 0 : activeChannelPass.expires)) {
        return null;
    }
    var videoThumbnail = video.listingDisplay.thumbnail;
    var passExpiry = activeChannelPass.expires;
    var eventStartTime = video.liveDetails.startTime;
    var eventCost = video.basicCost[0].units;
    return /*#__PURE__*/ jsxs(Box, {
        marginTop: "30px",
        children: [
            /*#__PURE__*/ jsx(EventWarningCard, {
                videoThumbnail: videoThumbnail,
                passExpiry: passExpiry,
                eventStartTime: eventStartTime
            }),
            /*#__PURE__*/ jsxs(Typography, {
                variant: "body2",
                align: "center",
                marginTop: "26px",
                children: [
                    t("feature.channelPasses.futureEvent.warningDescription", "Your pass will expire on {{passExpiry}}. You can still book your place for this event now for {{eventCost}}", {
                        passExpiry: format(textToDate(passExpiry), "d MMM"),
                        eventCost: eventCost
                    }),
                    " ",
                    eventCost > 1 ? t("feature.channelPasses.futureEvent.multipleCastCredits", "Cast Credits.") : t("feature.channelPasses.futureEvent.singleCastCredit", "Cast Credit."),
                    " ",
                    t("feature.channelPasses.futureEvent.buyNewPass", "Alternatively you can wait until your current pass expires and buy a new one (if available)")
                ]
            }),
            /*#__PURE__*/ jsxs(Button, {
                fullWidth: true,
                onClick: function() {
                    return dispatch(ensureWalletBalanceBeforePurchase());
                },
                sx: {
                    marginTop: "20px",
                    padding: "6px"
                },
                children: [
                    t("feature.channelPasses.futureEvent.buttonText.bookPlace", "I understand, book my place for {{eventCost}}", {
                        eventCost: eventCost
                    }),
                    " ",
                    eventCost > 1 ? t("feature.channelPasses.futureEvent.buttonText.multipleCredits", "credits") : t("singleCredit", "credit")
                ]
            })
        ]
    });
};

function _define_property$h(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$d(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$h(target, key, source[key]);
        });
    }
    return target;
}
var StepComponentMap$1 = new Map([
    [
        "init",
        undefined
    ],
    [
        "sign-up",
        ModalLoader
    ],
    [
        "suggest-channel-pass",
        SuggestChannelPass
    ],
    [
        "confirm-purchase",
        PurchaseConfirmVideo
    ],
    [
        "need-more-credits",
        PurchaseNeedMoreCredits
    ],
    [
        "top-up",
        undefined
    ],
    [
        "purchase-made",
        PurchaseMade
    ],
    [
        "confirm-channel-pass-purchase",
        ChannelPassConfirmation
    ],
    [
        "channel-pass-purchased",
        PurchaseMade
    ],
    [
        "live-event-expired-channel-pass",
        LiveEventExpiredChannelPass
    ]
]);
function Purchase(props) {
    var state = props.state, dispatch = props.dispatch, onTrack = props.onTrack, supportedRegionsUrl = props.supportedRegionsUrl;
    useEffect(function() {
        if (state.step) {
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "purchase",
                action: "modal-load",
                label: state.step
            }));
        }
    }, [
        onTrack,
        state.step
    ]);
    if (state.step === "") {
        return null;
    }
    if (state.step === "livestream-ended") {
        return /*#__PURE__*/ jsx(LiveEventEnded, {
            video: state.video,
            dispatch: dispatch
        });
    }
    if (state.step === "replay-is-processing") {
        return /*#__PURE__*/ jsx(LiveEventReplayProcessing, {
            video: state.video,
            dispatch: dispatch
        });
    }
    if (state.step === "unsupported-region") {
        return /*#__PURE__*/ jsx(Modal, {
            variant: "light",
            sx: {
                minHeight: "640px"
            },
            children: /*#__PURE__*/ jsx(ModalUnsupportedRegion, {
                supportedRegionsUrl: supportedRegionsUrl,
                onBackClick: function() {
                    return dispatch(exit$3());
                }
            })
        });
    }
    var StepComponent = StepComponentMap$1.get(state.step);
    return /*#__PURE__*/ jsxs(Modal, {
        variant: "light",
        sx: {
            minHeight: "640px"
        },
        children: [
            /*#__PURE__*/ jsx(PurchaseHeader, {
                step: state.step,
                video: state.video,
                missingCastCredits: state.missingCastCredits,
                shouldWarnAboutGeoblock: state.shouldWarnAboutGeoblock,
                dontShowGeoblockWarning: state.dontShowGeoblockWarning
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: StepComponent && /*#__PURE__*/ jsx(StepComponent, _object_spread$d({}, props))
            }),
            /*#__PURE__*/ jsx(PurchaseBottomAction, {
                dispatch: dispatch,
                state: state
            })
        ]
    });
}

var purchaseStorage = [
    {
        selector: function(state) {
            return state.purchase.skipPurchaseConfirm;
        },
        actionCreator: updateSkipPurchaseConfirm,
        entry: localStorageEntry("skipPurchaseConfirmation", false)
    },
    {
        selector: function(state) {
            return state.purchase.dontShowAgainPurchaseMade;
        },
        actionCreator: updateDontShowPurchaseMade,
        entry: localStorageEntry("dontShowAgainPurchaseMade", false)
    }
];

function _define_property$g(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$c(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$g(target, key, source[key]);
        });
    }
    return target;
}
var purchaseActions = _object_spread$c({}, purchaseSlice.actions, thunkActions$1);

var initialState$2 = {
    api: "mediaApi"
};
var followSlice = createSlice({
    name: "follow",
    initialState: initialState$2,
    reducers: {
        exit: function(state) {
            return state;
        }
    }
});
var exit$2 = followSlice.actions.exit;

function asyncGeneratorStep$c(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$c(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$c(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$c(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$c(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var startFollow = createAsyncThunk("follow/start", function() {
    var _ref = _async_to_generator$c(function(params, param) {
        var getState, dispatch, nextStep;
        return _ts_generator$c(this, function(_state) {
            getState = param.getState, dispatch = param.dispatch;
            nextStep = function() {
                dispatch(follow(params));
            };
            if (isUserLoggedIn(getState())) {
                nextStep();
            } else {
                dispatch(externalFlow({
                    start: start({
                        source: "popUp"
                    }),
                    end: [
                        success,
                        authLoginAction.fulfilled,
                        exit$4
                    ],
                    after: function(action) {
                        if (exit$4.match(action)) {
                            dispatch(exit$2());
                        } else {
                            nextStep();
                        }
                    }
                }));
            }
            return [
                2
            ];
        });
    });
    return function(params, _) {
        return _ref.apply(this, arguments);
    };
}());
var follow = createAsyncThunk("follow/follow", function() {
    var _ref = _async_to_generator$c(function(param, param1) {
        var channelId, dispatch, followChannel, subscription;
        return _ts_generator$c(this, function(_state) {
            switch(_state.label){
                case 0:
                    channelId = param.channelId, dispatch = param1.dispatch;
                    followChannel = mediaApi.endpoints.followChannel;
                    subscription = dispatch(followChannel.initiate(channelId, {
                        track: false
                    }));
                    return [
                        4,
                        subscription.unwrap()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());

var thunkActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  startFollow: startFollow,
  follow: follow
});

function _define_property$f(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$b(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$f(target, key, source[key]);
        });
    }
    return target;
}
var followActions = _object_spread$b({}, followSlice.actions, thunkActions);

// TODO: Need proper colour palette to invert correctly...
var StyledStack$2 = styled(Stack)(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        alignItems: "flex-start",
        justifyContent: "center",
        textAlign: "left",
        padding: "25px 19px 39px 25px",
        background: theme.palette.common.black,
        color: theme.palette.common.white,
        marginBottom: "26px",
        borderRadius: "3px",
        height: "368px"
    };
});
var StyledTypography = styled(Typography)(function() {
    return {
        fontSize: "28px",
        fontWeight: "600",
        lineHeight: "32px"
    };
});
var Icons = styled(Stack)(function() {
    return {
        flexDirection: "row",
        marginBottom: "38px",
        gap: "12px"
    };
});
var TellMeMoreButton = styled(ModalButton)(function(param) {
    var theme = param.theme;
    return {
        marginTop: "42px",
        color: theme.palette.common.white,
        "&:hover": {
            background: "none",
            borderColor: theme.palette.primary.main
        },
        transition: "border 0.3s"
    };
});
var SignupEntryHeader = function(param) {
    var onTellMeMoreClick = param.onTellMeMoreClick, channel = param.channel;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(StyledStack$2, {
        children: [
            /*#__PURE__*/ jsxs(Icons, {
                children: [
                    /*#__PURE__*/ jsxs(Stack, {
                        children: [
                            /*#__PURE__*/ jsx(Icon, {
                                component: RecastR,
                                sx: {
                                    color: "primary.main",
                                    width: "57px",
                                    height: "57px",
                                    marginBottom: "11px",
                                    marginLeft: "11.5px"
                                }
                            }),
                            /*#__PURE__*/ jsx(Icon, {
                                component: RecastText,
                                sx: {
                                    width: "80px",
                                    height: "19px",
                                    color: "primary.main"
                                }
                            })
                        ]
                    }),
                    channel && /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ jsx(Icon, {
                                component: Cross,
                                sx: {
                                    marginTop: "20px",
                                    marginRight: "11.5px",
                                    height: "24px",
                                    width: "24px"
                                }
                            }),
                            /*#__PURE__*/ jsx(Avatar, {
                                src: channel.icon,
                                alt: channel.name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsxs(StyledTypography, {
                children: [
                    "Join Recast to watch the very best content",
                    channel && /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ jsxs(StyledTypography, {
                                sx: {
                                    display: "inline"
                                },
                                children: [
                                    " ",
                                    "from",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ jsx(StyledTypography, {
                                sx: {
                                    display: "inline",
                                    color: "primary.main"
                                },
                                children: channel.name
                            })
                        ]
                    }),
                    " ",
                    "for pennies."
                ]
            }),
            /*#__PURE__*/ jsx(TellMeMoreButton, {
                onClick: onTellMeMoreClick,
                children: t("components.signup.entry.tellMe", "Tell me more")
            })
        ]
    });
};

var SignupSelection = function(props) {
    var onEmailSignupClick = props.onEmailSignupClick, recastTermsOfServiceUrl = props.recastTermsOfServiceUrl, recastPrivacyPolicyUrl = props.recastPrivacyPolicyUrl, googleSignupUrl = props.googleSignupUrl, facebookSignupUrl = props.facebookSignupUrl, onTrack = props.onTrack;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Box, {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px"
        },
        children: [
            /*#__PURE__*/ jsx(Button, {
                onClick: onEmailSignupClick,
                variant: "contained",
                fullWidth: true,
                "aria-label": t("components.signup.selection.email", "Join now with email"),
                sx: {
                    height: "44px"
                },
                children: t("components.signup.selection.email", "Join now with email")
            }),
            facebookSignupUrl && /*#__PURE__*/ jsx(SocialLoginButton, {
                onClick: function() {
                    return void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                        category: "sign-up",
                        action: "click",
                        label: "signup-method-selection-facebook"
                    }));
                },
                fullWidth: true,
                socialLoginType: "facebook",
                "aria-label": t("components.signup.selection.facebookSignup", "Continue with Facebook"),
                disabled: !facebookSignupUrl,
                href: facebookSignupUrl,
                children: t("components.signup.selection.facebookSignup", "Continue with Facebook")
            }),
            googleSignupUrl && /*#__PURE__*/ jsx(SocialLoginButton, {
                onClick: function() {
                    return void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                        category: "sign-up",
                        action: "click",
                        label: "signup-method-selection-google"
                    }));
                },
                fullWidth: true,
                socialLoginType: "google",
                "aria-label": t("components.signup.selection.googleSignup", "Continue with Google"),
                disabled: !googleSignupUrl,
                href: googleSignupUrl,
                sx: {
                    marginBottom: "12px"
                },
                children: t("components.signup.selection.googleSignup", "Continue with Google")
            }),
            /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                sx: {
                    color: "text.secondary",
                    fontSize: "9px",
                    lineHeight: "10px",
                    textAlign: "center",
                    maxWidth: "300px",
                    margin: "auto",
                    marginBottom: "10px"
                },
                children: /*#__PURE__*/ jsx(Trans, {
                    i18nKey: "components.signup.terms.recastAgreement",
                    defaults: "By joining I agree to Recast's <PrivacyLink>Privacy Policy</PrivacyLink> and <TermsLink>Terms of Service</TermsLink>.",
                    components: {
                        PrivacyLink: /*#__PURE__*/ jsx(ExternalLink, {
                            underline: "hover",
                            href: recastPrivacyPolicyUrl
                        }),
                        TermsLink: /*#__PURE__*/ jsx(ExternalLink, {
                            underline: "hover",
                            href: recastTermsOfServiceUrl
                        })
                    }
                })
            })
        ]
    });
};

var LoginLink = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ jsx(Typography, {
        variant: "body2",
        sx: {
            fontSize: "10px",
            lineHeight: "10px",
            textAlign: "center",
            maxWidth: "300px",
            fontWeight: 600,
            padding: 0,
            marginTop: "16px"
        },
        children: /*#__PURE__*/ jsx(Trans, {
            i18nKey: "components.signup.loginLink",
            defaults: "Already have an account? <Link>Login</Link>",
            components: {
                Link: /*#__PURE__*/ jsx(InternalLink, {
                    sx: {
                        cursor: "pointer",
                        textDecoration: "none",
                        "&:hover": {
                            textDecoration: "underline"
                        }
                    },
                    onClick: onClick
                })
            }
        })
    });
};

var StyledStack$1 = styled(Stack)(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        alignItems: "flex-start",
        justifyContent: "center",
        background: theme.palette.common.black,
        padding: "0",
        width: "100%",
        marginBottom: "26px",
        video: {
            width: "100%",
            height: "368px"
        }
    };
});
var SignupEntryVideo = function() {
    var whatIsRecastVideoUrl = "https://s3.eu-west-1.amazonaws.com/corporate-uploads.recast.app/what-is-recast-for-fans.mp4";
    return /*#__PURE__*/ jsx(StyledStack$1, {
        children: /*#__PURE__*/ jsx("video", {
            controls: true,
            autoPlay: true,
            controlsList: "nofullscreen nodownload noremoteplayback noplaybackrate",
            children: /*#__PURE__*/ jsx("source", {
                src: whatIsRecastVideoUrl,
                type: "video/mp4"
            })
        })
    });
};

function _array_like_to_array$a(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$9(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$9(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$9() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$9(arr, i) {
    return _array_with_holes$9(arr) || _iterable_to_array_limit$9(arr, i) || _unsupported_iterable_to_array$a(arr, i) || _non_iterable_rest$9();
}
function _unsupported_iterable_to_array$a(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$a(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$a(o, minLen);
}
var SignupSelectionStep = function(param) {
    var state = param.state, dispatch = param.dispatch, config = param.config, onTrack = param.onTrack;
    var socialSignupUrl = selectSocialSignUpUrls({
        signup: state,
        config: config
    });
    var channel = state.channel;
    var _useState = _sliced_to_array$9(useState(false), 2), isEntryVideoVisible = _useState[0], setIsEntryVideoVisible = _useState[1];
    var showTellMeMoreVideo = function() {
        return setIsEntryVideoVisible(true);
    };
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            !isEntryVideoVisible && /*#__PURE__*/ jsx(SignupEntryHeader, {
                channel: channel,
                onTellMeMoreClick: showTellMeMoreVideo
            }),
            isEntryVideoVisible && /*#__PURE__*/ jsx(SignupEntryVideo, {}),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsx(SignupSelection, {
                    onEmailSignupClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "signup-method-selection-email"
                        }));
                        dispatch(navigateToUserDetails());
                    },
                    recastTermsOfServiceUrl: state.config.recastTermsOfServiceUrl,
                    recastPrivacyPolicyUrl: state.config.recastPrivacyPolicyUrl,
                    googleSignupUrl: socialSignupUrl.google,
                    facebookSignupUrl: socialSignupUrl.facebook,
                    onTrack: onTrack
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(LoginLink, {
                    onClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "signup-method-selection-already-have-account-log-in"
                        }));
                        dispatch(navigateToLogin());
                    }
                })
            })
        ]
    });
};

function _define_property$e(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$a(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$e(target, key, source[key]);
        });
    }
    return target;
}
var SignupHeader = function(props) {
    return /*#__PURE__*/ jsx(ModalHeader, _object_spread$a({
        containerSx: {
            marginBottom: "20px"
        },
        icon: /*#__PURE__*/ jsx(Icon, {
            component: RecastR,
            sx: {
                fontSize: "96px",
                marginBottom: "24px",
                color: "common.black"
            }
        }),
        titleProps: {
            variant: "h3"
        },
        subtitleProps: {
            sx: {
                display: "flex",
                alignItems: "center",
                gap: "5px"
            }
        }
    }, props));
};

function _array_like_to_array$9(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$8(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep$b(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$b(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$b(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$b(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit$8(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$8() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$8(arr, i) {
    return _array_with_holes$8(arr) || _iterable_to_array_limit$8(arr, i) || _unsupported_iterable_to_array$9(arr, i) || _non_iterable_rest$8();
}
function _unsupported_iterable_to_array$9(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$9(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$9(o, minLen);
}
function _ts_generator$b(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var getSignupFormValidationSchema = function(translations, minPasswordLength) {
    var t = translations.t;
    var zEmail = z.string({
        required_error: t("components.signup.errors.emailRequired", "Email is required")
    }).email({
        message: t("components.signup.errors.emailInvalid", "Invalid email address")
    });
    var zPassword = z.string({
        required_error: t("components.signup.errors.passwordRequired", "Password is required")
    }).min(minPasswordLength, {
        message: t("components.signup.signup.passwordTooShort", "Password must be at least {{minPasswordLength}} characters long", {
            minPasswordLength: minPasswordLength
        })
    });
    return toFormikValidationSchema(z.object({
        email: zEmail,
        password: zPassword,
        isOptedInToMarketing: z.boolean()
    }));
};
var EmailValidationPrompt = function(param) {
    var emailValidation = param.emailValidation, onEmailValidityConfirm = param.onEmailValidityConfirm, validateEmail = param.validateEmail;
    var _useField = _sliced_to_array$8(useField("email"), 3), _useField_ = _useField[0], email = _useField_.value, _useField_1 = _useField[1], error = _useField_1.error, touched = _useField_1.touched, setError = _useField[2].setError;
    var t = useTranslation().t;
    useEffect(function() {
        if (email === (emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.email) && emailValidation.valid === EmailValidity.INVALID && !error && touched) {
            setError(t("components.signup.errors.emailInvalid", "Invalid email address"));
        }
    }, [
        email,
        emailValidation,
        error,
        setError,
        t,
        touched
    ]);
    useEffect(function() {
        if (touched) {
            validateEmail(email);
        }
    }, [
        email,
        touched,
        validateEmail
    ]);
    return (emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.email) === email && emailValidation.valid === EmailValidity.SUSPECTED ? /*#__PURE__*/ jsx(FieldPrompt, {
        sx: {
            marginTop: "2px"
        },
        buttons: [
            {
                label: t("button.yes", "yes"),
                onClick: function() {
                    return onEmailValidityConfirm(true);
                }
            },
            {
                label: t("button.no", "no"),
                variant: "outlined",
                onClick: function() {
                    return onEmailValidityConfirm(false);
                }
            }
        ],
        children: t("components.signup.signup.isEmailCorrect", "Are you sure this is the correct email address?")
    }) : null;
};
var SignupForm = function(props) {
    var onSubmit = props.onSubmit, onInputChange = props.onInputChange, isSubmitting = props.isSubmitting, validateEmail = props.validateEmail, supportEmail = props.supportEmail, apiError = props.apiError, emailValidation = props.emailValidation, onEmailValidityConfirm = props.onEmailValidityConfirm, channel = props.channel;
    var translations = useTranslation();
    var t = translations.t;
    var minPasswordLength = 8;
    var initialValues = {
        email: "",
        password: "",
        isOptedInToMarketing: false,
        isOptedInToShareData: false
    };
    var handleSubmit = function() {
        var _ref = _async_to_generator$b(function(values) {
            return _ts_generator$b(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var validationSchema = getSignupFormValidationSchema(translations, minPasswordLength);
    var _t;
    return /*#__PURE__*/ jsx(Formik, {
        onSubmit: handleSubmit,
        initialValues: initialValues,
        validationSchema: validationSchema,
        initialErrors: {
            email: apiError === null || apiError === void 0 ? void 0 : apiError.message
        },
        initialTouched: {
            email: !!(apiError === null || apiError === void 0 ? void 0 : apiError.message)
        },
        children: /*#__PURE__*/ jsxs(Form, {
            children: [
                /*#__PURE__*/ jsx(FormikFormInput, {
                    label: t("components.common.email.emailLabel", "Email"),
                    id: "email",
                    name: "email",
                    containerSx: {
                        marginBottom: "5px"
                    },
                    disabled: isSubmitting,
                    onChangeCallback: onInputChange,
                    belowComponent: /*#__PURE__*/ jsx(EmailValidationPrompt, {
                        emailValidation: emailValidation,
                        onEmailValidityConfirm: onEmailValidityConfirm,
                        validateEmail: validateEmail
                    })
                }),
                /*#__PURE__*/ jsx(FormikFormPasswordInput, {
                    label: (_t = t("components.common.password.passwordInputLabel", "Password")) !== null && _t !== void 0 ? _t : "Password",
                    id: "password",
                    name: "password",
                    containerSx: {
                        marginBottom: "10px"
                    },
                    withStrengthBar: true,
                    minPasswordLength: minPasswordLength,
                    disabled: isSubmitting,
                    onChangeCallback: onInputChange
                }),
                /*#__PURE__*/ jsx(FormikCheckbox, {
                    name: "isOptedInToMarketing",
                    label: t("components.signup.signup.optInToMarketing", "Opt in to Recast marketing and never miss any streams or videos from the channels you love"),
                    sx: {
                        marginBottom: "5px"
                    },
                    checkboxProps: {
                        disabled: isSubmitting
                    }
                }),
                (channel === null || channel === void 0 ? void 0 : channel.dataShare.isEnabled) && /*#__PURE__*/ jsx(FormikCheckbox, {
                    name: "isOptedInToShareData",
                    label: /*#__PURE__*/ jsx(Trans, {
                        i18nKey: "components.signup.signup.optInToDataShare",
                        defaults: "Opt in to receive news, offers and competitions by email directly from {{channelName}}. Your personal data will be used in accordance with {{channelName}}’s <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink>.",
                        values: {
                            channelName: channel.name
                        },
                        components: {
                            PrivacyPolicyLink: /*#__PURE__*/ jsx(ExternalLink, {
                                href: channel.dataShare.privacyPolicy
                            })
                        }
                    }),
                    sx: {
                        marginBottom: "5px"
                    },
                    checkboxProps: {
                        disabled: isSubmitting
                    }
                }),
                /*#__PURE__*/ jsx(FormikFormApiErrorText, {
                    apiError: apiError,
                    supportEmail: supportEmail
                }),
                /*#__PURE__*/ jsx(LoadingButton, {
                    type: "submit",
                    variant: "contained",
                    fullWidth: true,
                    "aria-label": t("components.signup.signup.submit", "Join Now & Watch"),
                    disabled: isSubmitting,
                    loading: isSubmitting,
                    children: t("components.signup.signup.submit", "Join Now & Watch")
                })
            ]
        })
    });
};

function asyncGeneratorStep$a(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$a(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$a(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$a(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property$d(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$9(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$d(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$4(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator$a(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var emailValidationDebounceMs = 300;
var inputDebounceMs$1 = 300;
var SignupUserDetailsStep = function(param) {
    var state = param.state, config = param.config, dispatch = param.dispatch, urlTrackingParams = param.urlTrackingParams, onTrack = param.onTrack;
    var t = useTranslation().t;
    var recaptchaSiteKey = config.recaptchaSiteKey;
    var getRecaptchaData = useRecaptcha(recaptchaSiteKey !== null && recaptchaSiteKey !== void 0 ? recaptchaSiteKey : "").getRecaptchaData;
    var referrer = state.referrer;
    var handleSubmit = function() {
        var _ref = _async_to_generator$a(function(values) {
            var email, password, isOptedInToMarketing, isOptedInToShareData, recaptchaData, marketingConsent;
            return _ts_generator$a(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = values.email, password = values.password, isOptedInToMarketing = values.isOptedInToMarketing, isOptedInToShareData = values.isOptedInToShareData;
                        return [
                            4,
                            getRecaptchaData("signup")
                        ];
                    case 1:
                        recaptchaData = _state.sent();
                        marketingConsent = isOptedInToMarketing ? MarketingConsentType.optedIn : MarketingConsentType.optedOut;
                        return [
                            4,
                            onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                category: "sign-up",
                                action: "click",
                                label: "user-details-join-now-and-watch"
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            dispatch(signupAction(_object_spread$9(_object_spread_props$4(_object_spread$9({}, urlTrackingParams), {
                                email: email,
                                password: password,
                                marketingConsent: marketingConsent,
                                isOptedInToShareData: isOptedInToShareData,
                                referrer: referrer
                            }), !!recaptchaData && recaptchaSiteKey && {
                                recaptchaData: recaptchaData
                            })))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var validateEmail = useCallback(function() {
        var _ref = _async_to_generator$a(function(email) {
            var thunkResult, isFullfilled;
            return _ts_generator$a(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch(validateEmailAction(email))
                        ];
                    case 1:
                        thunkResult = _state.sent();
                        isFullfilled = authValidateEmailAction.fulfilled.match(thunkResult);
                        return [
                            2,
                            isFullfilled && thunkResult.payload.valid !== EmailValidity.INVALID
                        ];
                }
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }(), [
        dispatch
    ]);
    var handleValidateEmail = useDebounced(validateEmail, emailValidationDebounceMs);
    var handleInputChange = useDebounced(function() {
        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
            category: "sign-up",
            action: "type",
            label: "user-details-details-entered"
        }));
        dispatch(clearApiError());
    }, inputDebounceMs$1);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SignupHeader, {
                title: t("components.signup.userDetails.title", "Join Recast now"),
                subtitle: ""
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsx(SignupForm, {
                    onSubmit: function() {
                        var _ref = _async_to_generator$a(function(values) {
                            return _ts_generator$a(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            handleSubmit(values)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(values) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    onInputChange: handleInputChange,
                    validateEmail: handleValidateEmail,
                    apiError: state.apiError,
                    isSubmitting: state.isSubmitting,
                    supportEmail: state.config.supportEmail,
                    emailValidation: state.emailValidation,
                    onEmailValidityConfirm: function(isValid) {
                        return dispatch(confirmEmailIsValid(isValid));
                    },
                    channel: state.channel
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(LoginLink, {
                    onClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "user-details-already-have-account-log-in"
                        }));
                        dispatch(navigateToLogin());
                    }
                })
            })
        ]
    });
};

function asyncGeneratorStep$9(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$9(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$9(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$9(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property$c(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator$9(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var SocialButtonContainer = styled(Box)(function(param) {
    var theme = param.theme;
    return _define_property$c({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px"
    }, theme.breakpoints.up("sm"), {
        flexDirection: "row",
        justifyContent: "center"
    });
});
var getLoginFormValidationSchema = function(translations) {
    var t = translations.t;
    var zEmail = z.string({
        required_error: t("components.signup.errors.emailRequired", "Email is required")
    }).email({
        message: t("components.signup.errors.emailInvalid", "Invalid email address")
    });
    var zPassword = z.string({
        required_error: t("components.signup.errors.passwordRequired", "Password is required")
    });
    return toFormikValidationSchema(z.object({
        email: zEmail,
        password: zPassword
    }));
};
var LoginForm = function(props) {
    var onSubmit = props.onSubmit, onInputChange = props.onInputChange, onForgotPasswordClick = props.onForgotPasswordClick, supportEmail = props.supportEmail, apiError = props.apiError, isSubmitting = props.isSubmitting, socialLinkProvider = props.socialLinkProvider, googleSignupUrl = props.googleSignupUrl, facebookSignupUrl = props.facebookSignupUrl, onTrack = props.onTrack;
    var translations = useTranslation();
    var t = translations.t;
    var initialValues = {
        email: "",
        password: ""
    };
    var handleSubmit = function() {
        var _ref = _async_to_generator$9(function(values) {
            return _ts_generator$9(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var validationSchema = getLoginFormValidationSchema(translations);
    return /*#__PURE__*/ jsx(Formik, {
        onSubmit: handleSubmit,
        initialValues: initialValues,
        validationSchema: validationSchema,
        children: /*#__PURE__*/ jsxs(Form, {
            children: [
                !!socialLinkProvider && /*#__PURE__*/ jsx(Typography, {
                    variant: "body2",
                    sx: {
                        textAlign: "center",
                        marginBottom: "10px"
                    },
                    children: t("components.signup.login.loginToLinkAccount", "There is already an account with the email linked to your {{provider}} account. Please login below and we will link up your {{provider}} account", {
                        provider: capitalize(socialLinkProvider)
                    })
                }),
                /*#__PURE__*/ jsx(FormikFormInput, {
                    label: t("components.common.email.emailLabel", "Email"),
                    id: "email",
                    name: "email",
                    containerSx: {
                        marginBottom: "5px"
                    },
                    disabled: isSubmitting,
                    onChangeCallback: onInputChange
                }),
                /*#__PURE__*/ jsx(FormikFormPasswordInput, {
                    label: t("components.common.password.passwordInputLabel", "Password"),
                    id: "password",
                    name: "password",
                    disabled: isSubmitting,
                    onChangeCallback: onInputChange
                }),
                /*#__PURE__*/ jsx(FormikFormApiErrorText, {
                    apiError: apiError,
                    supportEmail: supportEmail
                }),
                /*#__PURE__*/ jsx(LoadingButton, {
                    type: "submit",
                    variant: "contained",
                    fullWidth: true,
                    "aria-label": t("components.signup.login.login", "Login"),
                    sx: {
                        marginBottom: "10px"
                    },
                    disabled: isSubmitting,
                    loading: isSubmitting,
                    children: t("components.signup.login.login", "Login")
                }),
                /*#__PURE__*/ jsx(Typography, {
                    variant: "body2",
                    sx: {
                        textAlign: "center",
                        maxWidth: "300px",
                        margin: "auto",
                        marginBottom: "25px"
                    },
                    children: /*#__PURE__*/ jsx(InternalLink, {
                        onClick: onForgotPasswordClick,
                        children: t("components.signup.login.forgotPassword", "Forgotten your password?")
                    })
                }),
                /*#__PURE__*/ jsx(Typography, {
                    variant: "body2",
                    sx: {
                        textAlign: "center",
                        marginBottom: "15px"
                    },
                    children: t("components.signup.login.or", "Or")
                }),
                /*#__PURE__*/ jsxs(SocialButtonContainer, {
                    children: [
                        facebookSignupUrl && /*#__PURE__*/ jsx(SocialLoginButton, {
                            socialLoginType: "facebook",
                            fullWidth: true,
                            "aria-label": t("components.signup.login.facebookLogin", "Login with Facebook"),
                            href: facebookSignupUrl,
                            disabled: isSubmitting,
                            onClick: function() {
                                void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                    category: "sign-up",
                                    action: "click",
                                    label: "login-facebook"
                                }));
                            },
                            children: t("components.signup.login.facebookLogin", "Login with Facebook")
                        }),
                        googleSignupUrl && /*#__PURE__*/ jsx(SocialLoginButton, {
                            fullWidth: true,
                            socialLoginType: "google",
                            "aria-label": t("components.signup.login.googleLogin", "Login with Google"),
                            href: googleSignupUrl,
                            disabled: isSubmitting,
                            onClick: function() {
                                void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                    category: "sign-up",
                                    action: "click",
                                    label: "login-facebook"
                                }));
                            },
                            children: t("components.signup.login.googleLogin", "Login with Google")
                        })
                    ]
                })
            ]
        })
    });
};

function asyncGeneratorStep$8(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$8(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$8(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$8(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$8(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var inputDebounceMs = 300;
var SignupLoginStep$1 = function(param) {
    var state = param.state, dispatch = param.dispatch, config = param.config, onTrack = param.onTrack;
    var _state_socialSignup;
    var t = useTranslation().t;
    var handleLogin = function() {
        var _ref = _async_to_generator$8(function(values) {
            return _ts_generator$8(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                category: "sign-up",
                                action: "click",
                                label: "login-email"
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch(loginAction(values))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLogin(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInputChange = useDebounced(function() {
        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
            category: "sign-up",
            action: "type",
            label: "user-details-details-entered"
        }));
        dispatch(clearApiError());
    }, inputDebounceMs);
    var socialSignupUrl = selectSocialSignUpUrls({
        signup: state,
        config: config
    });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SignupHeader, {
                title: t("components.signup.login.title", "Welcome back!"),
                subtitle: t("components.signup.login.subtitle", "Enter your login details below")
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsx(LoginForm, {
                    onSubmit: handleLogin,
                    onInputChange: handleInputChange,
                    onForgotPasswordClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "login-forgot-password"
                        }));
                        dispatch(navigateToResetPassword());
                    },
                    supportEmail: state.config.supportEmail,
                    apiError: state.apiError,
                    isSubmitting: state.isSubmitting,
                    socialLinkProvider: (_state_socialSignup = state.socialSignup) === null || _state_socialSignup === void 0 ? void 0 : _state_socialSignup.provider,
                    googleSignupUrl: socialSignupUrl.google,
                    facebookSignupUrl: socialSignupUrl.facebook,
                    onTrack: onTrack
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(ModalButton, {
                    onClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "login-back"
                        }));
                        dispatch(navigateToSelection());
                    },
                    children: t("common.back", "Back")
                })
            })
        ]
    });
};

function asyncGeneratorStep$7(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$7(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$7(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$7(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$7(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var getResetFormValidationSchema = function(translations) {
    var t = translations.t;
    var zEmail = z.string({
        required_error: t("components.signup.errors.emailRequired", "Email is required")
    }).email({
        message: t("components.signup.errors.emailInvalid", "Invalid email address")
    });
    return toFormikValidationSchema(z.object({
        email: zEmail
    }));
};
var ResetForm = function(props) {
    var onSubmit = props.onSubmit, isSubmitting = props.isSubmitting, supportEmail = props.supportEmail, apiError = props.apiError;
    var translations = useTranslation();
    var t = translations.t;
    var initialValues = {
        email: ""
    };
    var handleSubmit = function() {
        var _ref = _async_to_generator$7(function(values) {
            return _ts_generator$7(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var validationSchema = getResetFormValidationSchema(translations);
    return /*#__PURE__*/ jsx(Formik, {
        onSubmit: handleSubmit,
        initialValues: initialValues,
        validationSchema: validationSchema,
        children: /*#__PURE__*/ jsxs(Form, {
            children: [
                /*#__PURE__*/ jsx(FormikFormInput, {
                    label: t("components.common.email.emailLabel", "Email"),
                    id: "email",
                    name: "email",
                    disabled: isSubmitting
                }),
                /*#__PURE__*/ jsx(FormikFormApiErrorText, {
                    apiError: apiError,
                    supportEmail: supportEmail
                }),
                /*#__PURE__*/ jsx(LoadingButton, {
                    type: "submit",
                    variant: "contained",
                    fullWidth: true,
                    "aria-label": t("components.signup.reset.resetPassword", "Reset Password"),
                    disabled: isSubmitting,
                    loading: isSubmitting,
                    children: t("components.signup.reset.resetPassword", "Reset Password")
                })
            ]
        })
    });
};

function asyncGeneratorStep$6(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$6(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$6(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$6(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$6(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var SignupResetStep = function(param) {
    var state = param.state, dispatch = param.dispatch, onTrack = param.onTrack;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SignupHeader, {
                title: t("components.signup.reset.title", "No need to panic!"),
                subtitle: t("components.signup.reset.subtitle", "Enter your email address to reset your password")
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsx(ResetForm, {
                    onSubmit: function() {
                        var _ref = _async_to_generator$6(function(values) {
                            return _ts_generator$6(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                                category: "sign-up",
                                                action: "click",
                                                label: "reset-password-reset-password"
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            4,
                                            dispatch(authResetPasswordAction(values))
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(values) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    apiError: state.apiError,
                    supportEmail: state.config.supportEmail,
                    isSubmitting: state.isSubmitting
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(ModalButton, {
                    onClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "reset-password-wait-remembered"
                        }));
                        dispatch(navigateToLogin());
                    },
                    children: t("components.signup.reset.back", "Wait, I remembered!")
                })
            })
        ]
    });
};

function asyncGeneratorStep$5(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$5(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$5(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$5(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$5(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var getVerifyFormValidationSchema = function(codeLength, translations) {
    var t = translations.t;
    var zCode = z.string({
        required_error: t("components.signup.errors.codeRequired", "Please enter the code we sent you")
    }).length(codeLength, t("components.signup.errors.codeLength", "Code must be {{length}} characters long", {
        length: codeLength
    }));
    return toFormikValidationSchema(z.object({
        code: zCode
    }));
};
var VerifyForm = function(props) {
    var onSubmit = props.onSubmit, onResendCodeClick = props.onResendCodeClick, codeLength = props.codeLength, supportEmail = props.supportEmail, apiError = props.apiError, isSubmitting = props.isSubmitting, isUppercased = props.isUppercased, onKeyDown = props.onKeyDown;
    var translations = useTranslation();
    var t = translations.t;
    var initialValues = {
        code: ""
    };
    var handleSubmit = function() {
        var _ref = _async_to_generator$5(function(values) {
            return _ts_generator$5(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isUppercased) {
                            values.code = values.code.toUpperCase();
                        }
                        return [
                            4,
                            onSubmit(values)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResend = function() {
        var _ref = _async_to_generator$5(function() {
            return _ts_generator$5(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onResendCodeClick()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleResend() {
            return _ref.apply(this, arguments);
        };
    }();
    var validationSchema = getVerifyFormValidationSchema(codeLength, translations);
    return /*#__PURE__*/ jsx(Formik, {
        onSubmit: handleSubmit,
        initialValues: initialValues,
        validationSchema: validationSchema,
        children: /*#__PURE__*/ jsxs(Form, {
            children: [
                /*#__PURE__*/ jsx(FormikFormCodeInput, {
                    name: "code",
                    length: codeLength,
                    containerSx: {
                        marginBottom: "20px"
                    },
                    isUppercased: isUppercased,
                    disabled: isSubmitting,
                    onKeyDown: onKeyDown
                }),
                /*#__PURE__*/ jsx(Typography, {
                    variant: "body2",
                    sx: {
                        textAlign: "center",
                        maxWidth: "300px",
                        margin: "auto"
                    },
                    children: t("components.signup.verify.didntGetCode", "Didn't get the code we sent you?")
                }),
                /*#__PURE__*/ jsx(Typography, {
                    variant: "body2",
                    sx: {
                        textAlign: "center",
                        maxWidth: "300px",
                        margin: "auto",
                        marginBottom: "20px"
                    },
                    children: /*#__PURE__*/ jsx(InternalLink, {
                        onClick: handleResend,
                        children: t("components.signup.verify.sendAgain", "Send again")
                    })
                }),
                /*#__PURE__*/ jsx(FormikFormApiErrorText, {
                    apiError: apiError,
                    supportEmail: supportEmail
                }),
                /*#__PURE__*/ jsx(LoadingButton, {
                    type: "submit",
                    variant: "contained",
                    fullWidth: true,
                    "aria-label": t("components.signup.verify.verify", "Verify"),
                    disabled: isSubmitting,
                    loading: isSubmitting,
                    children: t("components.signup.verify.verify", "Verify")
                })
            ]
        })
    });
};

function asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$4(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$4(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var VerifyModal = function(props) {
    var state = props.state, dispatch = props.dispatch, title = props.title, onTrack = props.onTrack;
    var step = state.step;
    var t = useTranslation().t;
    var verificationCodeLength = 5;
    var handleVerify = function() {
        var _ref = _async_to_generator$4(function(values) {
            return _ts_generator$4(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (step === "login-verification" || step === "verification") {
                            onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                category: "sign-up",
                                action: "click",
                                label: "".concat(step, "-verify")
                            });
                        }
                        return [
                            4,
                            dispatch(signupVerifyAction({
                                email: state.userEmail,
                                verificationCode: values.code
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleVerify(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResend = function() {
        var _ref = _async_to_generator$4(function() {
            return _ts_generator$4(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(step === "login-verification" || step === "verification")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                category: "sign-up",
                                action: "click",
                                label: "".concat(step, "-send-again")
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            dispatch(authResendVerifyCodeAction({
                                email: state.userEmail,
                                isLoginRequest: false
                            }))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleResend() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SignupHeader, {
                title: title,
                subtitle: /*#__PURE__*/ jsxs(Typography, {
                    variant: "h6",
                    children: [
                        t("components.signup.verify.subtitle", {
                            defaultValue: "Please enter the code we sent to {{email}}",
                            replace: {
                                email: state.userEmail
                            }
                        }),
                        /*#__PURE__*/ jsx("br", {}),
                        /*#__PURE__*/ jsx(InternalLink, {
                            sx: {
                                display: "block",
                                textAlign: "center",
                                cursor: "pointer"
                            },
                            onClick: function() {
                                if (step === "login-verification" || step === "verification") {
                                    void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                        category: "sign-up",
                                        action: "click",
                                        label: "".concat(step, "-wrong-email")
                                    }));
                                }
                                return dispatch(navigateToWrongEmail());
                            },
                            children: t("components.signup.verify.wrongEmail", "That's not my email.")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsx(VerifyForm, {
                    codeLength: verificationCodeLength,
                    onSubmit: function() {
                        var _ref = _async_to_generator$4(function(values) {
                            return _ts_generator$4(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            handleVerify(values)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(values) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    onResendCodeClick: /*#__PURE__*/ _async_to_generator$4(function() {
                        return _ts_generator$4(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        handleResend()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    isSubmitting: state.isSubmitting,
                    supportEmail: state.config.supportEmail,
                    apiError: state.apiError,
                    onKeyDown: function(key) {
                        if (step === "login-verification" || step === "verification") {
                            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                category: "sign-up",
                                action: "type",
                                label: "".concat(step, "-code-entered")
                            }));
                        }
                    },
                    isUppercased: true
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(LoginLink, {
                    onClick: function() {
                        if (step === "login-verification" || step === "verification") {
                            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                category: "sign-up",
                                action: "type",
                                label: "".concat(step, "-code-entered")
                            }));
                        }
                        dispatch(navigateToLogin());
                    }
                })
            })
        ]
    });
};

var SignupVerifyStep = function(param) {
    var state = param.state, dispatch = param.dispatch, config = param.config, track = param.onTrack;
    var t = useTranslation().t;
    var title = t("components.signup.verify.title", "Verify your account");
    return /*#__PURE__*/ jsx(VerifyModal, {
        title: title,
        state: state,
        config: config,
        dispatch: dispatch,
        onTrack: track
    });
};

var StyledStack = styled(Stack)({
    border: "1px solid #E5E5E5",
    width: "100%"
});
var SignupLoginStep = function(param) {
    var state = param.state, dispatch = param.dispatch, onTrack = param.onTrack;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SignupHeader, {
                title: t("components.signup.welcome.title", "Welcome to Recast"),
                subtitle: t("components.signup.welcome.subtitle", "The revolutionary microtransaction streaming platform")
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ jsx(StyledStack, {
                            sx: {
                                height: 207
                            },
                            justifyContent: "center",
                            alignItems: "center",
                            children: /*#__PURE__*/ jsx(SuccessCasty, {})
                        }),
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body2",
                            sx: {
                                color: "text.secondary",
                                marginTop: "24px",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ jsx(Fragment, {
                                children: t("components.signup.welcome.body", "You can now use your Recast Wallet to buy digital content across the internet from any seller using Recast. All subscription free!")
                            })
                        }),
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body2",
                            sx: {
                                color: "text.secondary",
                                marginTop: "16px",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ jsx(Fragment, {
                                children: t("components.signup.name.body2", {
                                    defaultValue: "Content is priced in Cast Credits. 1 Cast Credit equates to \xa30.01."
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(ModalButton, {
                    onClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "welcome-next"
                        }));
                        dispatch(success());
                    },
                    children: state.isPurchaseFlow ? t("button.next", "Next") : t("button.close", "Continue")
                })
            })
        ]
    });
};

var SignupResendConfirmStep$1 = function(param) {
    var state = param.state, dispatch = param.dispatch, onTrack = param.onTrack;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SignupHeader, {
                title: t("components.signup.resendConfirmStep.title", "Not to worry!"),
                subtitle: t("components.signup.resendConfirmStep.subtitle", "We just sent you a fresh code")
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsx(ModalTextBox, {
                    title: t("components.signup.resendConfirmStep.subtitle", {
                        defaultValue: "We just sent a fresh code to {{email}}",
                        replace: {
                            email: state.userEmail
                        }
                    }),
                    body: t("components.signup.resendConfirmStep.body", "Please check your email for a new message. It might take a minute or two to arrive.")
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(ModalButton, {
                    onClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "resend-confirm-back"
                        }));
                        dispatch(navigateToVerification());
                    },
                    children: t("common.back", "Back")
                })
            })
        ]
    });
};

var SignupResendConfirmStep = function(param) {
    var dispatch = param.dispatch, onTrack = param.onTrack;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SignupHeader, {
                title: t("components.signup.resetConfirmStep.title", "Done!"),
                subtitle: t("components.signup.resetConfirmStep.subtitle", "We just sent you a reset link")
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsx(ModalTextBox, {
                    title: t("components.signup.resetConfirmStep.confirmation", "If there's an account with that email, you should get a link to reset your password shortly."),
                    body: t("components.signup.resetConfirmStep.extraInfo", "It should only take a minute or two to arrive.")
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(ModalButton, {
                    onClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "reset-password-confirm-back"
                        }));
                        dispatch(navigateToLogin());
                    },
                    children: t("common.Back", "Back")
                })
            })
        ]
    });
};

var SignupWrongEmailStep = function(param) {
    var dispatch = param.dispatch, onTrack = param.onTrack;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SignupHeader, {
                title: t("components.signup.wrongEmailStep.title", "Oops!"),
                subtitle: t("components.signup.wrongEmailStep.subtitle", "Added the wrong email address?")
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsx(ModalTextBox, {
                    title: t("components.signup.wrongEmailStep.dontWorry", "Don't worry about it, it happens to the best of us!"),
                    body: t("components.signup.wrongEmailStep.startAgain", "Just start again with the right email")
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(ModalButton, {
                    onClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "wrong-email-back"
                        }));
                        dispatch(navigateToSelection());
                    },
                    children: t("common.back", "Back")
                })
            })
        ]
    });
};

var SignupUnsupportedRegionStep = function(param) {
    var state = param.state, dispatch = param.dispatch, onTrack = param.onTrack;
    var t = useTranslation().t;
    var supportedRegionsUrl = state.config.supportedRegionsUrl;
    return /*#__PURE__*/ jsx(ModalUnsupportedRegion, {
        subtitle: t("components.signup.errorStep.subtitle", "We've been unable to create an account for you."),
        supportedRegionsUrl: supportedRegionsUrl,
        onSupportedRegionsClick: function() {
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "sign-up",
                action: "click",
                label: "error-unsupported-region-help-email"
            }));
        },
        onBackClick: function() {
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "sign-up",
                action: "click",
                label: "error-unsupported-region-back"
            }));
            dispatch(exit$4());
        }
    });
};

var SignupDeletedAccountErrorStep = function(param) {
    var state = param.state, dispatch = param.dispatch, onTrack = param.onTrack;
    var t = useTranslation().t;
    var supportEmail = state.config.supportEmail;
    var socialSignup = state.socialSignup;
    var modalTitle = socialSignup ? t("components.signup.errorStep.socialEmailPreviouslyUsed", "The email associated with this social account has previously had an account on Recast.") : t("components.signup.errorStep.emailPreviouslyUsed", "The email associated with this account has previously had an account on Recast.");
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SignupHeader, {
                title: t("components.signup.errorStep.title", "Oh no!"),
                subtitle: t("components.signup.errorStep.subtitle", "We've been unable to create an account for you.")
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: /*#__PURE__*/ jsx(ModalTextBox, {
                    title: modalTitle,
                    body: /*#__PURE__*/ jsx(Trans, {
                        i18nKey: "components.signup.errorStep.contactSupport",
                        defaults: "Please contact customer support on <SupportEmailLink>{{supportEmail}}</SupportEmailLink>",
                        values: {
                            supportEmail: supportEmail
                        },
                        components: {
                            SupportEmailLink: /*#__PURE__*/ jsx(ExternalLink, {
                                onClick: function() {
                                    void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                                        category: "sign-up",
                                        action: "click",
                                        label: "error-deleted-account-help-email"
                                    }));
                                },
                                href: "mailto:".concat(supportEmail)
                            })
                        }
                    })
                })
            }),
            /*#__PURE__*/ jsx(ModalActions, {
                children: /*#__PURE__*/ jsx(ModalButton, {
                    onClick: function() {
                        void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                            category: "sign-up",
                            action: "click",
                            label: "error-deleted-account-back"
                        }));
                        dispatch(navigateToSelection());
                    },
                    children: t("common.back", "Back")
                })
            })
        ]
    });
};

var SignupLoginVerifyStep = function(param) {
    var state = param.state, config = param.config, dispatch = param.dispatch, track = param.onTrack;
    var t = useTranslation().t;
    var title = t("components.signup.loginVerify.title", "We couldn't verify your email last time");
    return /*#__PURE__*/ jsx(VerifyModal, {
        title: title,
        state: state,
        dispatch: dispatch,
        config: config,
        onTrack: track
    });
};

var isCountrySupported = function(country) {
    return country.enabled === 1;
};
var isCurrentLocationNotSupported = function(countries, currentLocation) {
    var supportedCountries = countries.filter(isCountrySupported);
    return !supportedCountries.some(function(country) {
        return country.code === currentLocation;
    });
};
var useInitSignupWithLocationCheck = function(props) {
    var state = props.state, dispatch = props.dispatch;
    var countryQuery = mediaApi.useGetCountriesQuery({});
    var locationQuery = mediaApi.useGetLocationQuery({});
    var isUnsupportedRegion = useMemo(function() {
        if (countryQuery.isSuccess && locationQuery.isSuccess && countryQuery.data && locationQuery.data) {
            return isCurrentLocationNotSupported(countryQuery.data, locationQuery.data.location);
        }
        return undefined;
    }, [
        countryQuery,
        locationQuery
    ]);
    useEffect(function() {
        if (isUnsupportedRegion !== undefined && state.step === "start") {
            dispatch(isUnsupportedRegion ? navigateToUnsupportedRegion() : navigateToSelection());
        }
    }, [
        dispatch,
        state.step,
        isUnsupportedRegion
    ]);
};

var SignupVPNBlockedStep = function(param) {
    var state = param.state, dispatch = param.dispatch;
    var t = useTranslation().t;
    var supportedRegionsUrl = state.config.supportedRegionsUrl;
    return /*#__PURE__*/ jsx(ModalAlert, {
        title: t("components.signup.vpnBlocked.title", "Oh no!"),
        subtitle: t("components.signup.vpnBlocked.subtitle", "We've been unable to create an account for you."),
        header: t("components.signup.vpnBlocked.header", "Unfortunately it looks like you’re trying to access Recast with a VPN."),
        body: /*#__PURE__*/ jsx(Trans, {
            i18nKey: "components.signup.vpnBlocked.disableVPN",
            defaults: "Please disable your VPN and try again. Recast is available in 90+ countries and territories and we’re expanding our global coverage all the time. Visit our <Link>website</Link> to find out where Recast is currently available.",
            components: {
                Link: /*#__PURE__*/ jsx(ExternalLink, {
                    href: supportedRegionsUrl
                })
            }
        }),
        onBackClick: function() {
            return dispatch(exit$4());
        }
    });
};

function _define_property$b(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$8(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$b(target, key, source[key]);
        });
    }
    return target;
}
var StepComponentMap = new Map([
    [
        "start",
        undefined
    ],
    [
        "signup-method-selection",
        SignupSelectionStep
    ],
    [
        "user-details",
        SignupUserDetailsStep
    ],
    [
        "verification",
        SignupVerifyStep
    ],
    [
        "wrong-email",
        SignupWrongEmailStep
    ],
    [
        "resend-confirm",
        SignupResendConfirmStep$1
    ],
    [
        "welcome",
        SignupLoginStep
    ],
    [
        "login",
        SignupLoginStep$1
    ],
    [
        "reset-password",
        SignupResetStep
    ],
    [
        "reset-password-confirm",
        SignupResendConfirmStep
    ],
    [
        "login-verification",
        SignupLoginVerifyStep
    ],
    [
        "error-deleted-account",
        SignupDeletedAccountErrorStep
    ],
    [
        "error-unsupported-region",
        SignupUnsupportedRegionStep
    ],
    [
        "error-vpn-blocked",
        SignupVPNBlockedStep
    ]
]);
function Signup(props) {
    var state = props.state, onTrack = props.onTrack;
    useInitSignupWithLocationCheck(props);
    useEffect(function() {
        if (state.step) {
            void (onTrack === null || onTrack === void 0 ? void 0 : onTrack({
                category: "sign-up",
                action: "modal-load",
                label: "".concat(state.step)
            }));
        }
    }, [
        state.step,
        onTrack
    ]);
    if (!state.step) {
        return null;
    }
    var StepComponent = StepComponentMap.get(state.step);
    return /*#__PURE__*/ jsx(Modal, {
        variant: "light",
        sx: {
            minHeight: "640px"
        },
        children: StepComponent && /*#__PURE__*/ jsx(StepComponent, _object_spread$8({}, props))
    });
}

function _define_property$a(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$a(target, key, source[key]);
        });
    }
    return target;
}
var signupActions = _object_spread$7({}, signupSlice.actions);

function _array_like_to_array$8(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$7(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$3(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit$7(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$7() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$7(arr, i) {
    return _array_with_holes$7(arr) || _iterable_to_array_limit$7(arr, i) || _unsupported_iterable_to_array$8(arr, i) || _non_iterable_rest$7();
}
function _unsupported_iterable_to_array$8(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$8(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$8(o, minLen);
}
function _ts_generator$3(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var useCustomActions = function(channel, channelCapabilities) {
    var _useState = _sliced_to_array$7(useState(), 2), customActions = _useState[0], setCustomActions = _useState[1];
    useEffect(function() {
        var banActionHandler = function() {
            var _ref = _async_to_generator$3(function(message) {
                var _message_user;
                return _ts_generator$3(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(((_message_user = message.user) === null || _message_user === void 0 ? void 0 : _message_user.id) && !message.user.banned)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                channel.banUser(message.user.id, {
                                    reason: "Banned by channel mod!"
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function banActionHandler(message) {
                return _ref.apply(this, arguments);
            };
        }();
        var unBanActionHandler = function() {
            var _ref = _async_to_generator$3(function(message) {
                var _message_user;
                return _ts_generator$3(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!((_message_user = message.user) === null || _message_user === void 0 ? void 0 : _message_user.id)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                channel.unbanUser(message.user.id)
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function unBanActionHandler(message) {
                return _ref.apply(this, arguments);
            };
        }();
        var actionRef = channelCapabilities["ban-channel-members"] ? {
            Ban: banActionHandler,
            Unban: unBanActionHandler
        } : undefined;
        setCustomActions(actionRef);
    }, [
        channel,
        channelCapabilities
    ]);
    return {
        customActions: customActions
    };
};

var CustomMessageList = function() {
    var _useChannelStateContext = useChannelStateContext(), channel = _useChannelStateContext.channel, channelCapabilities = _useChannelStateContext.channelCapabilities;
    var customActions = useCustomActions(channel, channelCapabilities).customActions;
    return /*#__PURE__*/ jsx(MessageList, {
        customMessageActions: customActions,
        noGroupByUser: true,
        disableQuotedMessages: true,
        closeReactionSelectorOnClick: true,
        disableDateSeparator: true
    });
};

function _define_property$9(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$9(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$3(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var EmojiPicker = function(props) {
    return /*#__PURE__*/ jsx(NimblePicker, _object_spread_props$3(_object_spread$6({}, props), {
        style: {
            width: undefined
        }
    }));
};
var LiveChat = function(param) {
    var channel = param.channel, client = param.client;
    return client ? /*#__PURE__*/ jsx(Chat, {
        client: client,
        theme: "str-chat__theme-dark",
        children: /*#__PURE__*/ jsx(Channel, {
            channel: channel,
            EmojiPicker: EmojiPicker,
            children: /*#__PURE__*/ jsxs(Window, {
                children: [
                    /*#__PURE__*/ jsx(CustomMessageList, {}),
                    /*#__PURE__*/ jsx(MessageInput, {
                        noFiles: true
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ jsx("div", {
        className: "empty-chat-window"
    });
};

function _array_like_to_array$7(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$6(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit$6(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$6() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$6(arr, i) {
    return _array_with_holes$6(arr) || _iterable_to_array_limit$6(arr, i) || _unsupported_iterable_to_array$7(arr, i) || _non_iterable_rest$6();
}
function _unsupported_iterable_to_array$7(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$7(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$7(o, minLen);
}
function _ts_generator$2(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var useChatChannel = function(param) {
    var client = param.client, channelId = param.channelId, videoId = param.videoId, playToken = param.playToken, addChatMember = param.addChatMember;
    var _useState = _sliced_to_array$6(useState(0), 2), watcherCount = _useState[0], setWatcherCount = _useState[1];
    var _useState1 = _sliced_to_array$6(useState(), 2), channel = _useState1[0], setChannel = _useState1[1];
    useEffect(function() {
        var initChannel = function() {
            var _ref = _async_to_generator$2(function() {
                var addChatMemberResponse, channels, channel;
                return _ts_generator$2(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!client) return [
                                2
                            ];
                            return [
                                4,
                                addChatMember(channelId, videoId, playToken)
                            ];
                        case 1:
                            addChatMemberResponse = _state.sent();
                            return [
                                4,
                                client.queryChannels({
                                    cid: "".concat(addChatMemberResponse.chat.type, ":").concat(addChatMemberResponse.chat.id),
                                    team: channelId
                                })
                            ];
                        case 2:
                            channels = _state.sent();
                            channel = channels[0];
                            setChannel(channel);
                            return [
                                2
                            ];
                    }
                });
            });
            return function initChannel() {
                return _ref.apply(this, arguments);
            };
        }();
        void initChannel();
    }, [
        playToken,
        client,
        channelId,
        videoId,
        addChatMember
    ]);
    useEffect(function() {
        var getWatchersCount = function getWatchersCount() {
            return _getWatchersCount.apply(this, arguments);
        };
        function _getWatchersCount() {
            _getWatchersCount = _async_to_generator$2(function() {
                var result, _result_watcher_count;
                return _ts_generator$2(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!channel) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                channel.query({})
                            ];
                        case 1:
                            result = _state.sent();
                            setWatcherCount((_result_watcher_count = result.watcher_count) !== null && _result_watcher_count !== void 0 ? _result_watcher_count : 0);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            setWatcherCount(0);
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _getWatchersCount.apply(this, arguments);
        }
        void getWatchersCount();
        var intervalId = setInterval(function() {
            void getWatchersCount();
        }, 60000);
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        channel
    ]);
    return {
        channel: channel,
        watcherCount: watcherCount
    };
};

function _array_like_to_array$6(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$5(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$5(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$5() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$5(arr, i) {
    return _array_with_holes$5(arr) || _iterable_to_array_limit$5(arr, i) || _unsupported_iterable_to_array$6(arr, i) || _non_iterable_rest$5();
}
function _unsupported_iterable_to_array$6(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$6(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$6(o, minLen);
}
var useChatClient = function(param) {
    var userName = param.userName, streamChatAPIKey = param.streamChatAPIKey, loggedUserId = param.loggedUserId, chatToken = param.chatToken, captureException = param.captureException;
    var _useState = _sliced_to_array$5(useState(null), 2), client = _useState[0], setClient = _useState[1];
    useEffect(function() {
        if (!chatToken || !userName) return;
        var client = new StreamChat(streamChatAPIKey);
        var didUserConnectInterrupt = false;
        var connectUser = client.connectUser({
            id: loggedUserId,
            name: userName
        }, chatToken).catch(function(e) {
            captureException(e);
        }).then(function() {
            if (!didUserConnectInterrupt) {
                setClient(client);
            }
        });
        return function() {
            didUserConnectInterrupt = true;
            connectUser.then(function() {
                setClient(null);
                client.disconnectUser().catch(function(e) {
                    captureException(e);
                });
            }).catch(function(e) {
                captureException(e);
            });
        };
    }, [
        streamChatAPIKey,
        chatToken,
        loggedUserId,
        userName,
        captureException
    ]);
    return {
        client: client
    };
};

var ChannelPassState;
(function(ChannelPassState) {
    ChannelPassState["AVAILABLE"] = "AVAILABLE";
    ChannelPassState["BOUGHT"] = "BOUGHT";
    ChannelPassState["DISPLAY"] = "DISPLAY";
    ChannelPassState["PROFILE_ACTIVE"] = "PROFILE_ACTIVE";
    ChannelPassState["PROFILE_EXPIRED"] = "PROFILE_EXPIRED";
})(ChannelPassState || (ChannelPassState = {}));

function _define_property$8(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$8(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var defaultPassPillStyles = {
    width: "100%",
    borderRadius: "20px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};
function ChannelPassPill(props) {
    var state = props.state, children = props.children;
    var isActive = state === ChannelPassState.BOUGHT || state === ChannelPassState.PROFILE_ACTIVE;
    var StyledChannelPassPill = styled("div")(function(param) {
        var theme = param.theme;
        return _object_spread_props$2(_object_spread$5({}, defaultPassPillStyles), {
            backgroundColor: isActive ? theme.palette.primary.main : "inherit",
            border: isActive ? 0 : "1px solid ".concat(theme.palette.common.white),
            "& .pillText": {
                color: isActive ? theme.palette.common.black : theme.palette.common.white,
                fontWeight: 400
            }
        });
    });
    var className = isActive ? "channelPassesPillBought" : "channelPassesPillAvailable";
    return /*#__PURE__*/ jsx(StyledChannelPassPill, {
        className: className,
        children: children
    });
}

function _define_property$7(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var AvailableChannelPassFooter = function(props) {
    var state = props.state, example = props.example, price = props.price;
    var t = useTranslation().t;
    var isDisplay = state === ChannelPassState.DISPLAY;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs(Box, {
                sx: {
                    width: "65%",
                    justifyContent: "left",
                    display: "flex",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ jsx(Typography, {
                        sx: {
                            fontSize: "12px",
                            fontWeight: 300
                        },
                        children: t("feature.channelPass.pass.forOnly", "for only")
                    }),
                    /*#__PURE__*/ jsxs(Box, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row"
                        },
                        children: [
                            /*#__PURE__*/ jsx(Typography, {
                                sx: {
                                    fontSize: "24px",
                                    display: "inline-flex",
                                    padding: "10px 5px 10px 0"
                                },
                                children: price
                            }),
                            /*#__PURE__*/ jsx(Icon, {
                                component: CastCredit,
                                sx: {
                                    height: "20px",
                                    width: "20px",
                                    fill: "white"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsxs(Box, {
                sx: {
                    width: "35%",
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "flex-end"
                },
                children: [
                    !isDisplay && /*#__PURE__*/ jsx(ChannelPassPill, {
                        state: state,
                        children: /*#__PURE__*/ jsx(Typography, {
                            className: "pillText",
                            sx: {
                                fontSize: "12px",
                                fontWeight: 400
                            },
                            children: state === ChannelPassState.AVAILABLE ? t("feature.channelPass.pass.firstPurchase", "Buy Now") : t("feature.channelPass.pass.purchaseAgain", "Buy Another")
                        })
                    }),
                    isDisplay && example && /*#__PURE__*/ jsx(Typography, {
                        sx: function(theme) {
                            return _define_property$7({
                                fontWeight: 300,
                                color: "text.secondary",
                                fontSize: "14px"
                            }, theme.breakpoints.down("sm"), {
                                fontSize: "12px"
                            });
                        },
                        children: t("feature.channelPass.pass.exampleText", "example channel pass")
                    })
                ]
            })
        ]
    });
};

dayjs.extend(isToday$1);
dayjs.extend(utc);
var isExpiryDateToday = function(endDate) {
    return dayjs(endDate).isToday();
};
var getMostRecentPurchase = function(purchases) {
    return purchases.reduce(function(a, b) {
        return dayjs(a.created).utc().unix() > dayjs(b.created).utc().unix() ? a : b;
    });
};
var getMostRecentExpiryDate = function(id, userPurchases) {
    var purchases = userPurchases.filter(function(purchase) {
        return purchase.tariff.href === "/api/public/tariffs/".concat(id);
    });
    if (purchases.length) {
        var mostRecentPurchase = getMostRecentPurchase(purchases);
        var _mostRecentPurchase_expires;
        return (_mostRecentPurchase_expires = mostRecentPurchase.expires) !== null && _mostRecentPurchase_expires !== void 0 ? _mostRecentPurchase_expires : "";
    }
    return "";
};
var getEndDate = function(expiryDate) {
    return expiryDate ? dayjs(expiryDate).utc(true).local() : null;
};

var BoughtChannelPassFooter = function(props) {
    var endDate = props.endDate, state = props.state;
    var t = useTranslation().t;
    var getExpiryTime = function(endDate) {
        return endDate.format("HH:mm");
    };
    var daysRemaining = endDate ? daysBetween(endDate.toDate(), Date.now()) : 0;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Box, {
                sx: {
                    width: "35%",
                    justifyContent: "left",
                    display: "flex",
                    flexDirection: "column"
                },
                children: /*#__PURE__*/ jsx(ChannelPassPill, {
                    state: state,
                    children: /*#__PURE__*/ jsx(Typography, {
                        className: "pillText",
                        sx: {
                            fontSize: "12px",
                            fontWeight: 400
                        },
                        children: t("feature.channelPass.pass.active", "Active")
                    })
                })
            }),
            endDate && /*#__PURE__*/ jsx(Box, {
                sx: {
                    width: "65%",
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ jsx(Typography, {
                    sx: {
                        fontWeight: 400
                    },
                    children: isExpiryDateToday(endDate) ? t("feature.channelPass.pass.expiringToday", "Today at {{expiryTime}}", {
                        expiryTime: getExpiryTime(endDate)
                    }) : t("feature.channelPass.pass.expiringFuture", "{{daysRemaining}} {{unit}} remaining", {
                        daysRemaining: daysRemaining,
                        unit: daysRemaining === 1 ? "Day" : "Days"
                    })
                })
            })
        ]
    });
};

dayjs.extend(relativeTime);
var ExpiredChannelPassFooter = function(props) {
    var expiryDate = props.expiryDate, state = props.state, revoked = props.revoked;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(Box, {
        sx: {
            width: "100%",
            display: "flex",
            marginTop: "15px"
        },
        children: [
            expiryDate && /*#__PURE__*/ jsx(Box, {
                sx: {
                    width: "65%",
                    justifyContent: "left",
                    display: "flex",
                    flexDirection: "column",
                    margin: "auto"
                },
                children: revoked ? /*#__PURE__*/ jsx(Typography, {
                    children: t("feature.channelPass.pass.revoked", "Revoked")
                }) : /*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ jsx(Typography, {
                            sx: {
                                fontSize: "12px",
                                fontWeight: 300,
                                color: "#B4B4B4"
                            },
                            children: t("feature.channelPass.pass.expired", "expired")
                        }),
                        /*#__PURE__*/ jsx(Typography, {
                            children: isExpiryDateToday(expiryDate) ? t("feature.channelPass.pass.expiringToday", "Today at {{expiryTime}}", {
                                expiryTime: expiryDate.format("HH:mm")
                            }) : dayjs(expiryDate).fromNow()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                sx: {
                    width: "35%",
                    justifyContent: "right",
                    display: "flex",
                    marginLeft: "auto"
                },
                children: /*#__PURE__*/ jsx(ChannelPassPill, {
                    state: state,
                    children: /*#__PURE__*/ jsx(Typography, {
                        className: "pillText",
                        sx: {
                            fontSize: "12px",
                            fontWeight: 400
                        },
                        children: t("feature.channelPass.pass.visitChannel", "Visit Channel")
                    })
                })
            })
        ]
    });
};

function _define_property$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ChannelPassFooter = function(props) {
    var state = props.state, endDate = props.endDate, price = props.price, example = props.example, revoked = props.revoked;
    var _obj;
    var mapping = (_obj = {}, _define_property$6(_obj, ChannelPassState.AVAILABLE, /*#__PURE__*/ jsx(AvailableChannelPassFooter, {
        state: state,
        price: price,
        example: example
    })), _define_property$6(_obj, ChannelPassState.DISPLAY, /*#__PURE__*/ jsx(AvailableChannelPassFooter, {
        state: state,
        price: price,
        example: example
    })), _define_property$6(_obj, ChannelPassState.BOUGHT, /*#__PURE__*/ jsx(BoughtChannelPassFooter, {
        endDate: endDate,
        state: state
    })), _define_property$6(_obj, ChannelPassState.PROFILE_ACTIVE, /*#__PURE__*/ jsx(BoughtChannelPassFooter, {
        endDate: endDate,
        state: state
    })), _define_property$6(_obj, ChannelPassState.PROFILE_EXPIRED, /*#__PURE__*/ jsx(ExpiredChannelPassFooter, {
        state: state,
        expiryDate: endDate,
        revoked: revoked
    })), _obj);
    return /*#__PURE__*/ jsx(Box, {
        sx: {
            flexDirection: "row",
            display: "flex",
            position: "relative",
            zIndex: 100,
            width: "100%",
            height: "auto",
            marginTop: "auto",
            padding: "0 10px 10px 10px"
        },
        children: mapping[state]
    });
};

function truncateLongText(text, maxLength) {
    var THREE_DOTS_LENGTH = 3;
    return (text === null || text === void 0 ? void 0 : text.length) <= maxLength ? text : (text === null || text === void 0 ? void 0 : text.substr(0, maxLength - THREE_DOTS_LENGTH)) + "...";
}
function getTruncatedChannelName(channelName) {
    var MAX_FULL_CHANNEL_NAME_LENGTH = 20;
    return truncateLongText(channelName, MAX_FULL_CHANNEL_NAME_LENGTH);
}

var LogoImg = styled("img")(function() {
    return {
        borderRadius: "2px"
    };
});
var StyledChannelPassHeader = styled("div")(function() {
    return {
        padding: "10px",
        flexDirection: "row",
        display: "flex",
        position: "relative",
        zIndex: 100
    };
});
var StyledChannelDetails = styled("div")(function() {
    return {
        width: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "left",
        position: "relative",
        zIndex: 100
    };
});
var ChannelPassHeader = function(param) {
    var channelName = param.channelName, channelAvatar = param.channelAvatar;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(StyledChannelPassHeader, {
        children: [
            /*#__PURE__*/ jsxs(StyledChannelDetails, {
                children: [
                    /*#__PURE__*/ jsx(LogoImg, {
                        src: channelAvatar,
                        alt: channelName,
                        height: 20,
                        width: 20
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        sx: {
                            fontSize: "12px",
                            paddingLeft: "5px",
                            fontWeight: 400
                        },
                        children: getTruncatedChannelName(channelName)
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Typography, {
                sx: {
                    fontSize: "12px",
                    width: "50%",
                    display: "flex",
                    justifyContent: "right",
                    fontWeight: 400
                },
                children: t("feature.channelPasses.passDescription", "CHANNEL PASS")
            })
        ]
    });
};

function ProfilePassHeader(param) {
    var channelName = param.channelName;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(StyledChannelPassHeader, {
        children: [
            /*#__PURE__*/ jsxs(StyledChannelDetails, {
                children: [
                    /*#__PURE__*/ jsx(Icon, {
                        component: ChannelPass$1,
                        sx: {
                            color: "white",
                            marginRight: "10px"
                        }
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        sx: {
                            fontWeight: 400
                        },
                        children: t("feature.channelPasses.passDescription", "CHANNEL PASS")
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Typography, {
                sx: {
                    fontSize: "16px",
                    width: "50%",
                    display: "flex",
                    justifyContent: "right",
                    fontWeight: 400,
                    alignItems: "center"
                },
                children: getTruncatedChannelName(channelName)
            })
        ]
    });
}

var StyledProfilePassDetails = styled("div")(function() {
    return {
        flexDirection: "row",
        display: "flex",
        position: "relative",
        zIndex: 100
    };
});
var StyledLogo = styled("div")(function() {
    return {
        width: "100px",
        display: "flex",
        justifyContent: "right",
        marginRight: "10px",
        alignItems: "center"
    };
});
function ProfilePassDetails(param) {
    var channelAvatar = param.channelAvatar, channelName = param.channelName, duration = param.duration;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsxs(StyledProfilePassDetails, {
        children: [
            /*#__PURE__*/ jsxs(Typography, {
                variant: "h1",
                sx: {
                    fontSize: duration > 9 ? "52px" : "60px",
                    fontWeight: "bold",
                    padding: "15px 20px",
                    width: "calc(100% - 110px)",
                    display: "flex",
                    justifyContent: "left"
                },
                children: [
                    duration,
                    " ",
                    duration === 1 ? t("feature.channelPass.pass.day", "day") : t("feature.channelPass.pass.days", "days")
                ]
            }),
            /*#__PURE__*/ jsx(StyledLogo, {
                children: /*#__PURE__*/ jsx(LogoImg, {
                    src: channelAvatar,
                    alt: channelName,
                    sx: {
                        height: 100,
                        width: 100
                    }
                })
            })
        ]
    });
}

var StyledPassDetails = styled("div")(function() {
    return {
        position: "relative",
        zIndex: 100
    };
});
function ChannelPassCard(param) {
    var channelName = param.channelName, channelAvatar = param.channelAvatar, duration = param.duration, price = param.price, state = param.state, onClick = param.onClick, endDate = param.endDate, example = param.example, disabled = param.disabled, revoked = param.revoked;
    var t = useTranslation().t;
    var isProfilePass = state === ChannelPassState.PROFILE_ACTIVE || state === ChannelPassState.PROFILE_EXPIRED;
    var CardContainer = styled("div")(function(param) {
        var theme = param.theme;
        return {
            width: "100%",
            height: "100%",
            margin: "auto",
            borderRadius: " 3px",
            backgroundColor: "#0f0f0f",
            border: "1px solid ".concat(theme.palette.primary.main),
            position: "relative",
            color: "".concat(theme.palette.common.white),
            opacity: disabled ? 0.3 : 1,
            pointerEvents: disabled ? "none" : "auto",
            "&:hover": {
                "& .channelPassesPillAvailable": {
                    backgroundColor: "".concat(theme.palette.common.white),
                    "& .pillText": {
                        color: "".concat(theme.palette.common.black)
                    }
                }
            }
        };
    });
    return /*#__PURE__*/ jsxs(CardContainer, {
        onClick: function(action) {
            return onClick === null || onClick === void 0 ? void 0 : onClick(action, disabled);
        },
        sx: {
            display: "flex",
            flexDirection: "column",
            minHeight: "200px"
        },
        children: [
            /*#__PURE__*/ jsx(Icon, {
                component: ChannelPass$1,
                sx: {
                    position: "absolute",
                    zIndex: 1,
                    opacity: 0.3,
                    right: "10px",
                    height: "100%",
                    width: "50%",
                    color: "primary.main"
                }
            }),
            isProfilePass ? /*#__PURE__*/ jsx(ProfilePassHeader, {
                channelName: channelName
            }) : /*#__PURE__*/ jsx(ChannelPassHeader, {
                channelName: channelName,
                channelAvatar: channelAvatar
            }),
            /*#__PURE__*/ jsx(StyledPassDetails, {
                children: isProfilePass ? /*#__PURE__*/ jsx(ProfilePassDetails, {
                    channelAvatar: channelAvatar,
                    channelName: channelName,
                    duration: duration
                }) : /*#__PURE__*/ jsxs(Typography, {
                    variant: "h1",
                    sx: {
                        fontSize: "60px",
                        fontWeight: "bold",
                        padding: "15px 20px"
                    },
                    children: [
                        duration,
                        " ",
                        duration === 1 ? t("feature.channelPass.pass.day", "day") : t("feature.channelPass.pass.days", "days")
                    ]
                })
            }),
            /*#__PURE__*/ jsx(ChannelPassFooter, {
                state: state,
                price: price,
                endDate: endDate,
                example: example,
                revoked: revoked
            })
        ]
    });
}

var StyledTopRowContainer = styled(Box)(function() {
    return {
        position: "relative",
        width: "100%",
        height: "36px"
    };
});
var StyledTopLeftCorner = styled(Box)(function(param) {
    var theme = param.theme;
    return {
        width: "48px",
        height: "37px",
        position: "absolute",
        top: 0,
        left: "-1px",
        backgroundColor: theme.palette.background.default,
        borderTop: "1px solid ".concat(theme.palette.primary.main),
        borderLeft: "1px solid ".concat(theme.palette.primary.main),
        borderTopLeftRadius: "3px"
    };
});
var StyledTopRightCorner = styled(Box)(function(param) {
    var theme = param.theme;
    return {
        width: "48px",
        height: "37px",
        position: "absolute",
        top: 0,
        right: "-1px",
        backgroundColor: theme.palette.background.default,
        borderTop: "1px solid ".concat(theme.palette.primary.main),
        borderRight: "1px solid ".concat(theme.palette.primary.main),
        borderTopRightRadius: "3px"
    };
});
var StyledCentreIconContainer = styled(Box)(function() {
    return {
        position: "absolute",
        top: 0,
        left: "46px",
        width: "86px",
        height: "37px"
    };
});
var ChannelPassTicketTopRow = function(props) {
    var ticketState = props.ticketState;
    var theme = useTheme();
    var centreInset = useMemo(function() {
        var insetSx = {
            position: "absolute",
            left: 0,
            width: "86px",
            height: "37px"
        };
        if (ticketState === "active" || ticketState === "profile_active") {
            return /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(Icon, {
                        sx: insetSx,
                        component: function() {
                            return /*#__PURE__*/ jsx(ChannelPassEmptyInset, {
                                color: theme.palette.primary.main,
                                cutOutColor: theme.palette.background.default
                            });
                        }
                    }),
                    /*#__PURE__*/ jsx(Icon, {
                        sx: {
                            position: "absolute",
                            color: theme.palette.common.black,
                            width: "18px",
                            height: "18px",
                            left: "34px",
                            top: "5px"
                        },
                        component: ChannelPass$1
                    })
                ]
            });
        }
        return /*#__PURE__*/ jsx(Icon, {
            sx: insetSx,
            component: function() {
                return /*#__PURE__*/ jsx(ChannelPassEmptyInset, {
                    color: "transparent",
                    cutOutColor: theme.palette.background.default
                });
            }
        });
    }, [
        ticketState,
        theme.palette
    ]);
    return /*#__PURE__*/ jsxs(StyledTopRowContainer, {
        children: [
            /*#__PURE__*/ jsx(StyledTopLeftCorner, {}),
            /*#__PURE__*/ jsx(StyledCentreIconContainer, {
                children: centreInset
            }),
            /*#__PURE__*/ jsx(StyledTopRightCorner, {})
        ]
    });
};

var ChannelPassTicketHeaderImage = function(props) {
    var ticketState = props.ticketState, channelAvatar = props.channelAvatar;
    var theme = useTheme();
    var showChannelAvatar = ticketState === "profile_active" || ticketState === "profile_expired" || ticketState === "profile_revoked";
    return /*#__PURE__*/ jsx(Box, {
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            marginBottom: "8px"
        },
        children: showChannelAvatar ? /*#__PURE__*/ jsx("img", {
            style: {
                width: "48px",
                height: "48px",
                borderRadius: "3px"
            },
            src: channelAvatar,
            alt: "channel avatar"
        }) : /*#__PURE__*/ jsx(Box, {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "48px",
                height: "48px"
            },
            children: /*#__PURE__*/ jsx(Icon, {
                sx: {
                    color: theme.palette.primary.main,
                    width: "40px",
                    height: "40px",
                    borderRadius: "3px"
                },
                component: ChannelPass$1
            })
        })
    });
};

var StyledPassButton = styled(Button)(function(param) {
    var theme = param.theme;
    return {
        pointerEvents: "none",
        minWidth: "100px",
        margin: "0 auto",
        // TODO: Add these to the themes properly - will break existing usage
        "&.MuiButton-modalPrimary": {
            color: theme.palette.common.black,
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main
        },
        "&.MuiButton-modalSecondary": {
            color: theme.palette.common.white,
            borderColor: theme.palette.common.white,
            backgroundColor: theme.palette.common.black
        }
    };
});
var ChannelPassTicketButton = function(props) {
    var ticketState = props.ticketState;
    var t = useTranslation().t;
    switch(ticketState){
        case "available":
            return /*#__PURE__*/ jsx(StyledPassButton, {
                variant: "modal",
                color: "secondary",
                children: t("feature.channelPasses.pass.buyNow", "Buy Now")
            });
        case "active":
        case "profile_active":
            return /*#__PURE__*/ jsx(StyledPassButton, {
                variant: "modal",
                color: "primary",
                children: "Active"
            });
        case "profile_expired":
        case "profile_revoked":
            return /*#__PURE__*/ jsx(StyledPassButton, {
                variant: "modal",
                color: "secondary",
                children: t("feature.channelPasses.pass.visitChannel", "Visit Channel")
            });
        case "disabled":
            return /*#__PURE__*/ jsx(StyledPassButton, {
                variant: "modal",
                color: "secondary",
                children: t("feature.channelPasses.pass.unavailable", "Unavailable")
            });
        default:
            return null;
    }
};

var ChannelPassTicketSubtitle = function(props) {
    var ticketState = props.ticketState, price = props.price, endDate = props.endDate;
    var t = useTranslation().t;
    var theme = useTheme();
    var fontFamily = [
        "Recast Sans",
        "Poppins",
        "Helvetica",
        "Arial",
        "sans-serif"
    ].join(",");
    var renderSubtitle = function() {
        switch(ticketState){
            case "profile_expired":
                return t("feature.channelPasses.pass.expired", "Expired");
            case "profile_revoked":
                return t("feature.channelPasses.pass.revoked", "Revoked");
            case "available":
            case "sample":
            case "radio":
                return /*#__PURE__*/ jsx(Trans, {
                    i18nKey: "feature.channelPasses.price",
                    defaults: "for only <PriceSpan>{{price}}</PriceSpan><CastIcon/>",
                    values: {
                        price: price
                    },
                    components: {
                        PriceSpan: /*#__PURE__*/ jsx(Box, {
                            component: "span",
                            sx: {
                                color: theme.palette.common.white
                            }
                        }),
                        CastIcon: /*#__PURE__*/ jsx(Icon, {
                            sx: {
                                verticalAlign: "baseline",
                                color: theme.palette.common.white,
                                width: "10.5px",
                                height: "11px",
                                margin: "0 2px"
                            },
                            component: CastCredit
                        })
                    }
                });
            case "active":
            case "profile_active":
                {
                    var daysRemaining = Math.ceil(dayjs(endDate).diff(dayjs(), "day", true));
                    var isExpiringToday = dayjs(endDate).isToday();
                    var _endDate_format;
                    var expiryTime = (_endDate_format = endDate === null || endDate === void 0 ? void 0 : endDate.format("HH:mm")) !== null && _endDate_format !== void 0 ? _endDate_format : "Unknown";
                    if (isExpiringToday) {
                        return t("feature.channelPasses.pass.expiringToday", "Today at {{expiryTime}}", {
                            expiryTime: expiryTime
                        });
                    } else {
                        return t("feature.channelPasses.pass.daysRemaining", "{{count}} days remaining", {
                            count: daysRemaining
                        });
                    }
                }
            default:
                return /*#__PURE__*/ jsx("span", {
                    children: "\xa0"
                });
        }
    };
    return /*#__PURE__*/ jsx(Typography, {
        sx: {
            color: theme.palette.text.secondary,
            marginBottom: ticketState === "sample" || ticketState === "radio" ? "0" : "24px",
            textAlign: "center",
            fontFamily: fontFamily
        },
        variant: "body1",
        children: renderSubtitle()
    });
};

function _define_property$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$5(target, key, source[key]);
        });
    }
    return target;
}
var StyledPassContainer = styled(Stack)(function(param) {
    var theme = param.theme;
    return {
        minWidth: "180px",
        maxWidth: "180px",
        alignItems: "stretch",
        justifyContent: "flex-start",
        backgroundColor: "transparent",
        borderLeft: "1px solid ".concat(theme.palette.primary.main),
        borderRight: "1px solid ".concat(theme.palette.primary.main),
        borderBottom: "1px solid ".concat(theme.palette.primary.main),
        borderRadius: "3px",
        userSelect: "none"
    };
});
var StyledPassContent = styled(Stack)(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.palette.background.default,
        padding: "12px 5px 24px 5px"
    };
});
var ChannelPassTicket = function(props) {
    var ticketState = props.ticketState, duration = props.duration, channelAvatar = props.channelAvatar, price = props.price, endDate = props.endDate, onClick = props.onClick;
    var theme = useTheme();
    var t = useTranslation().t;
    var isClickable = !!onClick && ticketState !== "disabled" && ticketState !== "sample" && ticketState !== "active";
    var shouldShowButton = ticketState !== "sample" && ticketState !== "radio";
    var buttonHoverStyles = {
        ":hover > * > .MuiButton-modalPrimary": {
            borderColor: Colors.PrimaryBright,
            backgroundColor: Colors.PrimaryBright
        },
        ":hover > * > .MuiButton-modalSecondary": {
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white
        }
    };
    var fontFamily = [
        "Recast Sans",
        "Poppins",
        "Helvetica",
        "Arial",
        "sans-serif"
    ].join(",");
    return /*#__PURE__*/ jsxs(StyledPassContainer, {
        onClick: onClick,
        sx: _object_spread$4({
            opacity: ticketState === "disabled" ? 0.5 : 1,
            pointerEvents: isClickable ? "auto" : "none",
            cursor: isClickable ? "pointer" : "default",
            maskImage: ticketState === "radio" ? "radial-gradient(circle 12px at calc(12px + 8px) calc(12px + 8px), transparent 12px, #000 0);" : "none"
        }, isClickable ? buttonHoverStyles : {}),
        children: [
            /*#__PURE__*/ jsx(ChannelPassTicketTopRow, {
                ticketState: ticketState
            }),
            /*#__PURE__*/ jsxs(StyledPassContent, {
                children: [
                    /*#__PURE__*/ jsx(ChannelPassTicketHeaderImage, {
                        ticketState: ticketState,
                        channelAvatar: channelAvatar
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "body1",
                        sx: {
                            color: theme.palette.primary.main,
                            textAlign: "center",
                            lineHeight: "20px",
                            fontWeight: "400",
                            textTransform: "uppercase",
                            marginBottom: "8px",
                            fontFamily: fontFamily
                        },
                        children: t("feature.channelPasses.pass.description", "CHANNEL PASS")
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "h2",
                        sx: {
                            textAlign: "center",
                            fontWeight: "800",
                            fontSize: "40px",
                            color: theme.palette.common.white,
                            lineHeight: "40px",
                            marginBottom: "12px",
                            fontFamily: fontFamily
                        },
                        children: t("feature.channelPasses.pass.duration", "{{count}} ".concat(duration === 1 ? "day" : "days"), {
                            count: duration
                        })
                    }),
                    /*#__PURE__*/ jsx(ChannelPassTicketSubtitle, {
                        ticketState: ticketState,
                        price: price,
                        endDate: endDate
                    }),
                    shouldShowButton && /*#__PURE__*/ jsx(ChannelPassTicketButton, {
                        ticketState: ticketState
                    })
                ]
            })
        ]
    });
};

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$1(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var socialSignupCallback = createAsyncThunk("social-signup-callback", function() {
    var _ref = _async_to_generator$1(function(payload, param) {
        var dispatch;
        return _ts_generator$1(this, function(_state) {
            dispatch = param.dispatch;
            dispatch(continueSocialSignUp(payload));
            return [
                2
            ];
        });
    //todo: dispatch action to restore purchase state
    });
    return function(payload, _) {
        return _ref.apply(this, arguments);
    };
}());

var GenericErrorContentContainer = styled(Box)(function() {
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        maxWidth: "400px",
        gap: "16px",
        padding: "10px"
    };
});
var GenericError = function(props) {
    var supportEmail = props.supportEmail, content = props.content;
    var t = useTranslation().t;
    var renderContent = function() {
        if (content) {
            return content;
        }
        return /*#__PURE__*/ jsxs(GenericErrorContentContainer, {
            children: [
                /*#__PURE__*/ jsx(Icon, {
                    component: Warning,
                    sx: {
                        fontSize: "65px"
                    }
                }),
                /*#__PURE__*/ jsx(Typography, {
                    variant: "h4",
                    children: t("components.modals.criticalError.title", "Something’s gone wrong!")
                }),
                /*#__PURE__*/ jsx(Typography, {
                    variant: "caption",
                    children: t("components.genericError.unableToShowScreen", "We weren’t able to show you that screen. Please try again.")
                }),
                /*#__PURE__*/ jsx(Typography, {
                    variant: "caption",
                    children: /*#__PURE__*/ jsx(Trans, {
                        i18nKey: "components.genericError.contactAt",
                        defaults: "If you keep getting this message, please contact support at <SupportEmailLink>{{supportEmail}}</SupportEmailLink>.",
                        values: {
                            supportEmail: supportEmail
                        },
                        components: {
                            SupportEmailLink: /*#__PURE__*/ jsx(ExternalLink, {
                                sx: {
                                    color: "inherit",
                                    "&:visited": {
                                        color: "inherit"
                                    }
                                },
                                href: "mailto:".concat(supportEmail)
                            })
                        }
                    })
                }),
                /*#__PURE__*/ jsx(Typography, {
                    variant: "caption",
                    children: t("components.genericError.tellDeviceBrowser", "If you email please let us know what you were trying to do, and what device and browser you are using.")
                })
            ]
        });
    };
    return /*#__PURE__*/ jsx(Box, {
        sx: function(theme) {
            return {
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "3px dashed ".concat(theme.palette.text.secondary)
            };
        },
        children: renderContent()
    });
};

function _define_property$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$4(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ONE_DAY_IN_SECONDS = 86400;
var ChannelPass = function(param) {
    var channelAvatar = param.channelAvatar, pass = param.pass, activePassId = param.activePassId, onClick = param.onClick, purchases = param.purchases;
    var duration = pass.rentalPeriod / ONE_DAY_IN_SECONDS;
    var expiryDate = pass.id === activePassId ? getMostRecentExpiryDate(activePassId, purchases) : "";
    var getTicketState = function() {
        var ticketState = pass.id === activePassId ? "active" : "available";
        if (ticketState === "available" && !!activePassId) {
            ticketState = "disabled";
        }
        return ticketState;
    };
    var handleClick = function() {
        var channelPass = _object_spread_props$1(_object_spread$3({}, pass), {
            type: "CHANNEL_PASS"
        });
        !activePassId && onClick(channelPass);
    };
    return /*#__PURE__*/ jsx(ChannelPassTicket, {
        ticketState: getTicketState(),
        duration: duration,
        channelAvatar: channelAvatar,
        price: pass.priceDetails.price,
        onClick: handleClick,
        endDate: getEndDate(expiryDate)
    });
};

function _array_like_to_array$5(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array$5(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array$5(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array$5(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$5(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$5(o, minLen);
}
var ChannelPassSection = function(param) {
    var channelAvatar = param.channelAvatar, channelUid = param.channelUid, passes = param.passes, onClick = param.onClick, profileChannelPasses = param.profileChannelPasses;
    var activePassId = useRef();
    var isMobile = useMediaQuery(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var existingChannelPass = useMemo(function() {
        if (!profileChannelPasses) return null;
        var getActivePurchaseForChannelByUid = function(channelUid, userTariffs, userPurchases) {
            if (!userTariffs || !userPurchases) return null;
            //TODO add in check for status' removed/suspended
            var existingChannelPasses = userTariffs.filter(function(tariff) {
                return tariff.channel.href === "/partner/channel/".concat(channelUid) && tariff.type === "CHANNEL_PASS";
            });
            var activePass = userPurchases.find(function(purchase) {
                return existingChannelPasses.some(function(pass) {
                    return purchase.expires && purchase.tariff.href === "/api/public/tariffs/".concat(pass.id) && isFuture(new Date(purchase.expires)) && !purchase.revoked;
                });
            });
            return activePass !== null && activePass !== void 0 ? activePass : null;
        };
        var activePurchase = getActivePurchaseForChannelByUid(channelUid, profileChannelPasses.tariffs, profileChannelPasses.purchases);
        if (activePurchase) {
            var _profileChannelPasses_tariffs_find;
            return (_profileChannelPasses_tariffs_find = profileChannelPasses.tariffs.find(function(tariff) {
                return tariff.href === activePurchase.tariff.href;
            })) !== null && _profileChannelPasses_tariffs_find !== void 0 ? _profileChannelPasses_tariffs_find : null;
        }
        return null;
    }, [
        profileChannelPasses,
        channelUid
    ]);
    var sortedChannelPasses = useMemo(function() {
        var purchaseablePasses = passes.filter(function(pass) {
            return pass.statusDetails.status === "PURCHASEABLE";
        });
        var sortChannelPasses = function(a, b) {
            return a.rentalPeriod - b.rentalPeriod;
        };
        if (existingChannelPass) {
            activePassId.current = existingChannelPass.id;
            return [
                existingChannelPass
            ].concat(_to_consumable_array(purchaseablePasses.filter(function(pass) {
                return pass.id !== existingChannelPass.id;
            })));
        }
        return purchaseablePasses.sort(sortChannelPasses);
    }, [
        passes,
        existingChannelPass
    ]);
    return /*#__PURE__*/ jsx(SwipeScroll, {
        momentumVelocity: 0,
        gap: isMobile ? 8 : 16,
        children: sortedChannelPasses.map(function(pass, i) {
            return /*#__PURE__*/ jsx(ChannelPass, {
                channelAvatar: channelAvatar,
                pass: pass,
                activePassId: activePassId.current,
                onClick: onClick,
                purchases: (profileChannelPasses === null || profileChannelPasses === void 0 ? void 0 : profileChannelPasses.purchases) || []
            }, "pass-".concat(i));
        })
    });
};

var getPercentages = function(values, total) {
    var percentages = values.map(function(value) {
        return Math.round(value / total * 100);
    });
    if (percentages.length) {
        percentages[percentages.length - 1] += 100 - percentages.reduce(function(acc, val) {
            return acc + val;
        }, 0);
    }
    return percentages;
};
var getTotalAndPercentages = function(values) {
    var total = values.reduce(function(total, data) {
        return data + total;
    }, 0);
    var percentages = getPercentages(values, total);
    return {
        total: total,
        percentages: percentages
    };
};

function _array_like_to_array$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$4(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$4(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$4() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$4(arr, i) {
    return _array_with_holes$4(arr) || _iterable_to_array_limit$4(arr, i) || _unsupported_iterable_to_array$4(arr, i) || _non_iterable_rest$4();
}
function _unsupported_iterable_to_array$4(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$4(o, minLen);
}
Chart.register(BubbleMapController, BubbleMapChart, GeoFeature, ColorScale, ProjectionScale, SizeScale);
var CHART_MAX_WIDTH = 1000;
var BUBBLE_MAX_RADIUS = 20;
var GeoBubbleChartWrapper = styled(Box)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    height: "100%",
    width: "100%",
    minHeight: "400px"
});
var getCountryData = function(country) {
    return {
        type: "Feature",
        properties: {
            name: country.countryName
        },
        value: country.value,
        latitude: country.latitude,
        longitude: country.longitute
    };
};
var getGeneratedChart = function(ctx, geoData, countries, percentages) {
    var chart = new Chart(ctx, {
        type: "bubbleMap",
        data: {
            labels: geoData.map(function(country) {
                return country.countryName;
            }),
            datasets: [
                {
                    outline: countries,
                    showOutline: true,
                    label: "Countries",
                    data: geoData.map(getCountryData),
                    backgroundColor: "#3233ff",
                    outlineBackgroundColor: "white",
                    radius: function(ctx) {
                        if (ctx.dataset.data.length) {
                            var percentage = percentages[ctx.dataIndex];
                            var canvasWidth = ctx.chart.width;
                            var scaleFactor = canvasWidth / CHART_MAX_WIDTH;
                            var radius = percentage / 100 * BUBBLE_MAX_RADIUS * scaleFactor;
                            return radius;
                        }
                        return 0;
                    }
                }
            ]
        },
        options: {
            plugins: {
                legend: {
                    display: false
                },
                datalabels: {
                    display: false
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                projection: {
                    projection: "equalEarth",
                    axis: "x"
                },
                size: {
                    display: false,
                    axis: "y"
                }
            }
        }
    });
    return chart;
};
var GeoBubbleChart = function(props) {
    var geoData = props.geoData;
    var _useState = _sliced_to_array$4(useState(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var chartRef = useRef(null);
    useEffect(function() {
        var canvas = chartRef.current;
        if (!canvas) return;
        fetch("https://unpkg.com/world-atlas/countries-50m.json").then(function(r) {
            return r.json();
        }).then(function(data) {
            var featureCollection = ChartGeo.topojson.feature(data, data.objects.countries);
            var countries = featureCollection.features;
            var percentages = getTotalAndPercentages(geoData.map(function(data) {
                return data.value;
            })).percentages;
            var ctx = canvas.getContext("2d");
            var geoChart = getGeneratedChart(ctx, geoData, countries, percentages);
            setIsLoading(false);
            return function() {
                geoChart.destroy();
            };
        });
    }, [
        geoData
    ]);
    return /*#__PURE__*/ jsxs(GeoBubbleChartWrapper, {
        children: [
            isLoading && /*#__PURE__*/ jsx(CircularProgress, {}),
            /*#__PURE__*/ jsx("canvas", {
                ref: chartRef,
                id: "canvas",
                style: {
                    height: isLoading ? 0 : "100%",
                    width: isLoading ? 0 : "100%",
                    maxWidth: "".concat(CHART_MAX_WIDTH, "px"),
                    backgroundColor: "#b5ddfc"
                }
            })
        ]
    });
};

function _array_like_to_array$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$3(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$3(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$3(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array$3(arr, i) {
    return _array_with_holes$3(arr) || _iterable_to_array_limit$3(arr, i) || _unsupported_iterable_to_array$3(arr, i) || _non_iterable_rest$3();
}
function _unsupported_iterable_to_array$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$3(o, minLen);
}
var PercentageBarWrapper = styled(Box)({
    width: "75%",
    backgroundColor: "#4E4E4E",
    minHeight: "20px"
});
var PercentageValueWrapper = styled(Box)({
    width: "25%",
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end"
});
var ShowMoreLessWrapper = styled(Box)({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginTop: "30px"
});
var EMPTY_COUNTRY = {
    countryCode: "",
    countryName: "",
    latitude: 0,
    longitute: 0,
    value: 0
};
var FILL_EMPTY_COUNTRIES = 5;
var PercentageBar = function(param) {
    var percentage = param.percentage;
    return /*#__PURE__*/ jsx(PercentageBarWrapper, {
        children: /*#__PURE__*/ jsx(Box, {
            sx: {
                width: "".concat(percentage, "%"),
                height: "100%",
                backgroundColor: "#3233FF"
            }
        })
    });
};
var GeoPercentageChart = function(props) {
    var geoData = props.geoData;
    var t = useTranslation().t;
    var _useState = _sliced_to_array$3(useState(false), 2), showAll = _useState[0], setShowAll = _useState[1];
    var percentages = getTotalAndPercentages(geoData.map(function(data) {
        return data.value;
    })).percentages;
    var dataWithPercentages = geoData.map(function(data, index) {
        return _object_spread_props(_object_spread$2({}, data), {
            percentage: percentages[index]
        });
    });
    var renderGeoData = function(data, index) {
        return /*#__PURE__*/ jsxs(Box, {
            sx: {
                display: "flex",
                flexDirection: "column",
                paddingBottom: data.countryName ? "15px" : "30px"
            },
            children: [
                /*#__PURE__*/ jsx(Typography, {
                    sx: {
                        paddingBottom: "5px",
                        fontSize: "12px"
                    },
                    children: data.countryName
                }),
                /*#__PURE__*/ jsxs(Box, {
                    sx: {
                        display: "flex",
                        flexDirection: "row"
                    },
                    children: [
                        /*#__PURE__*/ jsx(PercentageBar, {
                            percentage: data.percentage
                        }),
                        /*#__PURE__*/ jsx(PercentageValueWrapper, {
                            children: /*#__PURE__*/ jsxs(Typography, {
                                children: [
                                    /*#__PURE__*/ jsx(Typography, {
                                        sx: {
                                            padding: "0 5px",
                                            fontSize: "12px"
                                        },
                                        component: "span",
                                        children: data.value
                                    }),
                                    /*#__PURE__*/ jsx(Typography, {
                                        component: "span",
                                        sx: {
                                            fontSize: "12px"
                                        },
                                        children: "(".concat(data.percentage, "%)")
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }, data.countryCode ? data.countryCode : index);
    };
    return /*#__PURE__*/ jsx(Box, {
        sx: {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column"
        },
        children: dataWithPercentages.length ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsxs(Box, {
                    children: [
                        dataWithPercentages.slice(0, 5).map(renderGeoData),
                        dataWithPercentages.length > 5 && showAll && dataWithPercentages.slice(5).map(renderGeoData)
                    ]
                }),
                dataWithPercentages.length > 5 && /*#__PURE__*/ jsx(ShowMoreLessWrapper, {
                    children: /*#__PURE__*/ jsxs(Box, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer"
                        },
                        onClick: function() {
                            return setShowAll(!showAll);
                        },
                        children: [
                            showAll ? /*#__PURE__*/ jsx(Typography, {
                                sx: {
                                    color: "#9F9F9F",
                                    fontSize: "12px"
                                },
                                children: t("feature.geoPercentageChart.showLess", "Show less")
                            }) : /*#__PURE__*/ jsx(Typography, {
                                sx: {
                                    color: "#9F9F9F",
                                    fontSize: "12px"
                                },
                                children: t("feature.geoPercentageChart.showMore", "Show all (".concat(geoData.length - 5, " more)"), {
                                    numberRemaining: geoData.length - 5
                                })
                            }),
                            showAll ? /*#__PURE__*/ jsx(ExpandLessIcon, {
                                sx: {
                                    color: "#9F9F9F"
                                }
                            }) : /*#__PURE__*/ jsx(ExpandMoreIcon, {
                                sx: {
                                    color: "#9F9F9F"
                                }
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ jsx(Box, {
            children: Array(FILL_EMPTY_COUNTRIES).fill(_object_spread_props(_object_spread$2({}, EMPTY_COUNTRY), {
                percentage: 0
            })).map(function(data, index) {
                return renderGeoData(data, index);
            })
        })
    });
};

var BarChartBorderPlugin = {
    id: "customBorder",
    afterDatasetsDraw: function afterDatasetsDraw(chart) {
        var ctx = chart.ctx, _chart_chartArea = chart.chartArea, top = _chart_chartArea.top, bottom = _chart_chartArea.bottom, left = _chart_chartArea.left, right = _chart_chartArea.right, color = chart.options.color;
        ctx.save();
        ctx.beginPath();
        ctx.lineWidth = 1;
        ctx.strokeStyle = color;
        ctx.moveTo(left, top); //top point
        ctx.lineTo(left + 5, top + 10); //top point + 5
        ctx.moveTo(left, top);
        ctx.lineTo(left - 5, top + 10);
        ctx.moveTo(left, top);
        ctx.lineTo(left, bottom);
        ctx.lineTo(right + 10, bottom);
        ctx.moveTo(right, bottom - 5);
        ctx.lineTo(right + 10, bottom);
        ctx.moveTo(right, bottom + 5);
        ctx.lineTo(right + 10, bottom);
        ctx.stroke();
        ctx.closePath();
    }
};

var getBarChartConfig = function(config) {
    var color = config.color, xLabel = config.xLabel, defaultFont = config.defaultFont, isEmptyGraph = config.isEmptyGraph, formatter = config.formatter, displayYAxisTitle = config.displayYAxisTitle, yLabel = config.yLabel;
    return {
        responsive: true,
        maintainAspectRatio: false,
        color: color,
        layout: {
            padding: {
                right: 15,
                top: 30
            }
        },
        animation: false,
        scales: {
            x: {
                grid: {
                    display: false
                },
                title: {
                    display: !!xLabel,
                    text: xLabel,
                    font: defaultFont,
                    color: color
                },
                ticks: {
                    font: defaultFont,
                    color: color
                },
                border: {
                    display: false
                }
            },
            y: {
                suggestedMax: isEmptyGraph ? 600 : undefined,
                grid: {
                    display: false
                },
                ticks: {
                    font: defaultFont,
                    color: color,
                    precision: 0
                },
                border: {
                    display: false
                },
                title: {
                    text: yLabel,
                    font: defaultFont,
                    color: color,
                    display: !!yLabel && !displayYAxisTitle,
                    padding: 10
                }
            }
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: false
            },
            datalabels: {
                anchor: "end",
                align: "top",
                font: defaultFont,
                color: color,
                formatter: formatter
            }
        }
    };
};

function _array_like_to_array$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$2(arr, i) {
    return _array_with_holes$2(arr) || _iterable_to_array_limit$2(arr, i) || _unsupported_iterable_to_array$2(arr, i) || _non_iterable_rest$2();
}
function _unsupported_iterable_to_array$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$2(o, minLen);
}
Chart$1.register(BarElement, CategoryScale, LinearScale, ChartDataLabels);
var StyledBarGraphContainer = styled(Box)({
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
    minHeight: "330px",
    position: "relative",
    paddingRight: "10px"
});
var StyledYAxisLabel = styled(Typography)({
    fontSize: "12px",
    wordBreak: "break-word",
    wordWrap: "break-word",
    top: "40px",
    paddingRight: "10px",
    position: "relative",
    fontFamily: typography.fontFamily
});
var BarChart = function(props) {
    var xLabel = props.xLabel, yLabel = props.yLabel, data = props.data, chartColor = props.chartColor;
    var color = chartColor !== null && chartColor !== void 0 ? chartColor : "#E0E0E0";
    var chartDataValues = data.map(function(d) {
        return d.value;
    });
    var _getTotalAndPercentages = getTotalAndPercentages(chartDataValues), percentages = _getTotalAndPercentages.percentages, total = _getTotalAndPercentages.total;
    var isEmptyGraph = total === 0;
    var chartRef = useRef(null);
    var _useState = _sliced_to_array$2(useState(0), 2), chartWidth = _useState[0], setChartWidth = _useState[1];
    var defaultFont = {
        family: typography.fontFamily,
        size: 12,
        weight: 400,
        color: color
    };
    var labelFormatter = function(value, ctx) {
        var datasetMeta = ctx.chart.getDatasetMeta(0);
        var barElement = datasetMeta.data[ctx.dataIndex];
        var barWidth = barElement.width;
        var percentage = percentages[ctx.dataIndex];
        return value > 0 || !isEmptyGraph ? "".concat(value).concat(barWidth > 35 ? " (".concat(percentage, "%)") : "") : "";
    };
    var displayYAxisTitle = chartWidth > 600;
    var options = getBarChartConfig({
        color: color,
        xLabel: xLabel !== null && xLabel !== void 0 ? xLabel : "",
        defaultFont: defaultFont,
        formatter: labelFormatter,
        isEmptyGraph: isEmptyGraph,
        displayYAxisTitle: displayYAxisTitle,
        yLabel: yLabel !== null && yLabel !== void 0 ? yLabel : ""
    });
    var labels = data.map(function(d) {
        return d.label;
    });
    var chartData = {
        labels: labels,
        datasets: [
            {
                data: chartDataValues,
                backgroundColor: data.map(function(d) {
                    return d.backgroundColor;
                }),
                maxBarThickness: 50
            }
        ]
    };
    useEffect(function() {
        var observer = new ResizeObserver(function(param) {
            var _param = _sliced_to_array$2(param, 1), entry = _param[0];
            if (entry.target.clientWidth) setChartWidth(entry.target.clientWidth);
        });
        if (chartRef.current) {
            observer.observe(chartRef.current);
        }
        return function() {
            return observer.disconnect();
        };
    }, [
        chartRef
    ]);
    return /*#__PURE__*/ jsxs(StyledBarGraphContainer, {
        ref: chartRef,
        children: [
            displayYAxisTitle && !!yLabel && /*#__PURE__*/ jsx(Box, {
                sx: {
                    maxWidth: "80px",
                    minWidth: "60px"
                },
                children: /*#__PURE__*/ jsx(StyledYAxisLabel, {
                    sx: {
                        color: color
                    },
                    children: yLabel
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                sx: {
                    flexGrow: 1,
                    minWidth: 0,
                    width: "calc(100% - 5px)"
                },
                children: /*#__PURE__*/ jsx(Bar, {
                    options: options,
                    data: chartData,
                    plugins: [
                        BarChartBorderPlugin,
                        ChartDataLabels
                    ]
                })
            })
        ]
    });
};

function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var StyledLabelWrapper = styled(Box)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "row",
        padding: "10px"
    }, _define_property$2(_obj, theme.breakpoints.between(0, "sm"), {
        maxWidth: "100px",
        padding: "10px 5px"
    }), _define_property$2(_obj, theme.breakpoints.between("sm", "md"), {
        maxWidth: "110px"
    }), _define_property$2(_obj, theme.breakpoints.between("md", "lg"), {
        maxWidth: "120px"
    }), _obj;
});
var LabelPill = function(param) {
    var color = param.color;
    return /*#__PURE__*/ jsx(Brightness1Icon, {
        sx: {
            color: color,
            fontSize: "12px",
            lineHeight: "16px",
            padding: "0 4px 0 0",
            position: "relative",
            top: "2px"
        }
    });
};
var DoughnutChartLabel = function(props) {
    var label = props.label, color = props.color, itemCount = props.itemCount, countTotal = props.countTotal, textColor = props.textColor;
    var percentage = countTotal ? Math.round(itemCount / countTotal * 100) : 0;
    return /*#__PURE__*/ jsxs(StyledLabelWrapper, {
        children: [
            /*#__PURE__*/ jsx(LabelPill, {
                color: color
            }),
            /*#__PURE__*/ jsxs(Box, {
                sx: {
                    display: "flex",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ jsx(Typography, {
                        sx: {
                            color: textColor,
                            wordWrap: "break-word",
                            wordBreak: "break-word",
                            fontSize: 12,
                            lineHeight: "16px"
                        },
                        children: label
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        sx: {
                            color: textColor,
                            fontSize: 12,
                            lineHeight: "16px"
                        },
                        children: "".concat(itemCount, " (").concat(percentage, "%)")
                    })
                ]
            })
        ]
    });
};

Chart.register(CategoryScale);
var StyledDoughnutWrapper = styled(Box)({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    alignItems: "center",
    minHeight: "200px"
});
function DoughnutChart(props) {
    var _data_labels, _colors_tooltip, _colors_tooltip1, _colors_tooltip2;
    var data = props.data, colors = props.colors;
    var countTotal = data.dataset.data.reduce(function(acc, val) {
        return acc + val;
    }, 0);
    var hasData = !!countTotal;
    var _colors_emptyGraphColor;
    var chartData = hasData ? {
        datasets: [
            data.dataset
        ],
        labels: data.labels
    } : {
        datasets: [
            {
                data: [
                    100
                ],
                backgroundColor: [
                    (_colors_emptyGraphColor = colors === null || colors === void 0 ? void 0 : colors.emptyGraphColor) !== null && _colors_emptyGraphColor !== void 0 ? _colors_emptyGraphColor : Colors.GrayDark5
                ]
            }
        ],
        labels: []
    };
    var _colors_tooltip_background, _colors_tooltip_text, _colors_tooltip_background1;
    return /*#__PURE__*/ jsxs(StyledDoughnutWrapper, {
        children: [
            /*#__PURE__*/ jsx(Box, {
                sx: {
                    display: "flex",
                    flexDirection: "row",
                    padding: "10px 0",
                    flexWrap: "wrap",
                    justifyContent: "center"
                },
                children: (_data_labels = data.labels) === null || _data_labels === void 0 ? void 0 : _data_labels.map(function(label, index) {
                    var _colors_labelText;
                    return label ? /*#__PURE__*/ jsx(DoughnutChartLabel, {
                        color: data.dataset.backgroundColor[index],
                        countTotal: countTotal,
                        itemCount: data.dataset.data[index],
                        label: label,
                        textColor: (_colors_labelText = colors === null || colors === void 0 ? void 0 : colors.labelText) !== null && _colors_labelText !== void 0 ? _colors_labelText : ""
                    }, index) : null;
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                sx: {
                    height: "100%"
                },
                children: /*#__PURE__*/ jsx(Doughnut, {
                    data: chartData,
                    options: {
                        responsive: true,
                        animation: false,
                        maintainAspectRatio: false,
                        elements: {
                            arc: {
                                borderWidth: 0
                            }
                        },
                        cutout: "65%",
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                enabled: hasData,
                                backgroundColor: (_colors_tooltip_background = colors === null || colors === void 0 ? void 0 : (_colors_tooltip = colors.tooltip) === null || _colors_tooltip === void 0 ? void 0 : _colors_tooltip.background) !== null && _colors_tooltip_background !== void 0 ? _colors_tooltip_background : Colors.BackgroundApp,
                                bodyFont: {
                                    family: typography.fontFamily
                                },
                                titleFont: {
                                    family: typography.fontFamily
                                },
                                titleColor: (_colors_tooltip_text = colors === null || colors === void 0 ? void 0 : (_colors_tooltip1 = colors.tooltip) === null || _colors_tooltip1 === void 0 ? void 0 : _colors_tooltip1.text) !== null && _colors_tooltip_text !== void 0 ? _colors_tooltip_text : "#E0E0E0",
                                callbacks: {
                                    label: function(c) {
                                        var value = c.parsed;
                                        var percentage = Math.round(value / countTotal * 100);
                                        return "  ".concat(value, " (").concat(percentage, "%) ");
                                    },
                                    labelTextColor: function() {
                                        var _colors_tooltip;
                                        var _colors_tooltip_text;
                                        return (_colors_tooltip_text = colors === null || colors === void 0 ? void 0 : (_colors_tooltip = colors.tooltip) === null || _colors_tooltip === void 0 ? void 0 : _colors_tooltip.text) !== null && _colors_tooltip_text !== void 0 ? _colors_tooltip_text : "#E0E0E0";
                                    }
                                },
                                padding: 12,
                                usePointStyle: true,
                                bodySpacing: 8,
                                bodyColor: (_colors_tooltip_background1 = colors === null || colors === void 0 ? void 0 : (_colors_tooltip2 = colors.tooltip) === null || _colors_tooltip2 === void 0 ? void 0 : _colors_tooltip2.background) !== null && _colors_tooltip_background1 !== void 0 ? _colors_tooltip_background1 : Colors.BackgroundApp
                            },
                            datalabels: {
                                display: false
                            }
                        }
                    }
                })
            })
        ]
    });
}

var initialState$1 = {
    step: "",
    reason: "",
    userComment: ""
};
var reportSlice = createSlice({
    name: "report",
    initialState: initialState$1,
    reducers: {
        start: function(state, action) {
            state.step = "choose-reason";
            state.video = action.payload;
        },
        goToAnythingElse: function(state) {
            state.step = "anything-else";
        },
        goToSuccess: function(state) {
            state.step = "success";
        },
        pickReason: function(state, action) {
            state.reason = action.payload;
        },
        addUserComment: function(state, action) {
            state.userComment = action.payload;
        },
        exit: function() {
            return initialState$1;
        }
    }
});
var _reportSlice_actions = reportSlice.actions;
_reportSlice_actions.start; var goToAnythingElse = _reportSlice_actions.goToAnythingElse, goToSuccess = _reportSlice_actions.goToSuccess, exit$1 = _reportSlice_actions.exit, pickReason = _reportSlice_actions.pickReason, addUserComment = _reportSlice_actions.addUserComment;
reportSlice.reducer;

var getSubtitle = function(step, t) {
    switch(step){
        case "choose-reason":
            return t("components.report.header.chooseReason", "Please choose a reason below");
        case "anything-else":
            return t("components.report.header.anythingElse", "Anything else to add?");
        case "success":
            return t("components.report.header.success", "Thanks for adding the information.");
    }
};
var ReportHeader = function(param) {
    var step = param.step;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(ModalHeader, {
        title: "Report this Video",
        subtitle: getSubtitle(step, t),
        icon: /*#__PURE__*/ jsx(Icon, {
            sx: function(theme) {
                return {
                    fontSize: 64,
                    color: theme.palette.common.black
                };
            },
            component: Flag
        })
    });
};

var getActionText = function(step, t) {
    switch(step){
        case "anything-else":
            return t("components.report.bottomAction.cancel", "Cancel");
        case "choose-reason":
            return t("components.report.bottomAction.notNow", "Not now");
        case "success":
            return t("components.report.bottomAction.close", "Close");
    }
};
var ReportBottomAction = function(param) {
    var step = param.step, dispatch = param.dispatch;
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(ModalActions, {
        children: /*#__PURE__*/ jsx(ModalButton, {
            onClick: function() {
                return dispatch(exit$1());
            },
            children: getActionText(step, t)
        })
    });
};

var StyledBox = styled(Box)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "207px",
    marginTop: "62px",
    border: "1px solid ".concat(Colors.SocialButtonBorder)
});
var StyledSubtitle = styled(Typography)({
    fontWeight: 500,
    textAlign: "center",
    marginBottom: "11px",
    width: "340px"
});
var ReportSuccess = function() {
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(StyledBox, {
        children: /*#__PURE__*/ jsx(StyledSubtitle, {
            variant: "subtitle2",
            children: t("components.report.success.thankYou", "We have added this to an email on your device and will review your feedback as soon as you have sent the email to us.")
        })
    });
};

var REASONS = [
    "Copyright",
    "Spam",
    "Inappropriate Content",
    "Other"
];

var ChooseReason = function(param) {
    var dispatch = param.dispatch;
    var t = useTranslation().t;
    var initialValues = {
        reason: ""
    };
    var handleSubmit = function(param) {
        var reason = param.reason;
        dispatch(pickReason(reason));
        dispatch(goToAnythingElse());
    };
    return /*#__PURE__*/ jsx(Formik, {
        initialValues: initialValues,
        onSubmit: handleSubmit,
        children: function(param) {
            var values = param.values, setFieldValue = param.setFieldValue;
            return /*#__PURE__*/ jsx(Form, {
                children: /*#__PURE__*/ jsxs(FormControl, {
                    children: [
                        /*#__PURE__*/ jsx(RadioGroup, {
                            sx: {
                                gap: "4px",
                                margin: "21px 0 14px 0"
                            },
                            name: "reason",
                            onChange: function(event) {
                                return setFieldValue("reason", event.currentTarget.value);
                            },
                            children: REASONS.map(function(reason) {
                                return /*#__PURE__*/ jsx(Radio$1, {
                                    label: reason,
                                    value: reason
                                }, reason);
                            })
                        }),
                        /*#__PURE__*/ jsx(Button$1, {
                            sx: {
                                width: "100%"
                            },
                            type: "submit",
                            disabled: !values.reason.length,
                            children: t("components.report.chooseReason.button", "Next")
                        })
                    ]
                })
            });
        }
    });
};

var AnythingElse = function(param) {
    var state = param.state, supportEmail = param.supportEmail, dispatch = param.dispatch;
    var t = useTranslation().t;
    var initialValues = {
        userComment: ""
    };
    var handleSubmit = function(userComment, state, supportEmail) {
        var _state_video, _state_video1;
        dispatch(addUserComment(userComment));
        dispatch(goToSuccess());
        var subject = "Report of content for ".concat(state.reason);
        var body = "I would like to report the following video: ".concat((_state_video = state.video) === null || _state_video === void 0 ? void 0 : _state_video.title, " (id: ").concat((_state_video1 = state.video) === null || _state_video1 === void 0 ? void 0 : _state_video1.uid, "). ").concat(userComment);
        window.location.href = "mailto:".concat(supportEmail, "?subject=").concat(subject, "&body=").concat(body);
    };
    return /*#__PURE__*/ jsx(Stack, {
        sx: {
            marginTop: "28px",
            width: "100%"
        },
        children: /*#__PURE__*/ jsx(Formik, {
            initialValues: initialValues,
            onSubmit: function(param) {
                var userComment = param.userComment;
                return handleSubmit(userComment, state, supportEmail);
            },
            children: /*#__PURE__*/ jsxs(Form, {
                children: [
                    /*#__PURE__*/ jsx(FormikFormInput, {
                        multiline: true,
                        name: "userComment",
                        label: t("components.report.anythingElse.optional", "Optional"),
                        rows: 7,
                        containerSx: function(theme) {
                            return {
                                "& .MuiFormLabel-root": {
                                    color: theme.palette.text.secondary
                                },
                                "& .MuiInputBase-root": {
                                    padding: "12px 8px 12px 12px",
                                    "& .MuiInputBase-input": {
                                        padding: 0
                                    }
                                }
                            };
                        }
                    }),
                    /*#__PURE__*/ jsx(Button$1, {
                        fullWidth: true,
                        sx: {
                            marginTop: "14px"
                        },
                        type: "submit",
                        children: t("components.report.anythingElse.button", "Submit")
                    })
                ]
            })
        })
    });
};

var Report = function(param) {
    var state = param.state, supportEmail = param.supportEmail, dispatch = param.dispatch;
    var step = state.step;
    if (step === "") {
        return null;
    }
    var getModalContent = function(step, state, dispatch) {
        switch(step){
            case "choose-reason":
                return /*#__PURE__*/ jsx(ChooseReason, {
                    dispatch: dispatch
                });
            case "anything-else":
                return /*#__PURE__*/ jsx(AnythingElse, {
                    dispatch: dispatch,
                    state: state,
                    supportEmail: supportEmail
                });
            case "success":
                return /*#__PURE__*/ jsx(ReportSuccess, {});
        }
    };
    return /*#__PURE__*/ jsxs(Modal, {
        variant: "light",
        sx: {
            minHeight: "640px"
        },
        children: [
            /*#__PURE__*/ jsx(ReportHeader, {
                step: step
            }),
            /*#__PURE__*/ jsx(ModalContent, {
                children: getModalContent(step, state, dispatch)
            }),
            /*#__PURE__*/ jsx(ReportBottomAction, {
                step: step,
                dispatch: dispatch
            })
        ]
    });
};

function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
var reportActions = _object_spread$1({}, reportSlice.actions);

function _array_like_to_array$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$1(arr, i) {
    return _array_with_holes$1(arr) || _iterable_to_array_limit$1(arr, i) || _unsupported_iterable_to_array$1(arr, i) || _non_iterable_rest$1();
}
function _unsupported_iterable_to_array$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$1(o, minLen);
}
var ChangePasswordForm = function(props) {
    var onInputChange = props.onInputChange, withStrengthBar = props.withStrengthBar, minPasswordLength = props.minPasswordLength;
    var t = useTranslation().t;
    var _useState = _sliced_to_array$1(useState(false), 2), isChecked = _useState[0], setIsChecked = _useState[1];
    var _useField = _sliced_to_array$1(useField("logoutAllDevices"), 1), logoutAllDevices = _useField[0];
    var handleChange = function(event, checked) {
        logoutAllDevices.onChange(event);
        setIsChecked(checked);
    };
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(FormikFormPasswordInput, {
                label: t("components.common.password.newPassword", "New Password"),
                id: "password",
                name: "password",
                onChangeCallback: onInputChange,
                withStrengthBar: withStrengthBar,
                minPasswordLength: minPasswordLength
            }),
            /*#__PURE__*/ jsx(FormikFormPasswordInput, {
                label: t("components.common.password.repeatPassword", "Repeat Password"),
                id: "repeatPassword",
                name: "repeatPassword",
                onChangeCallback: onInputChange,
                withStrengthBar: withStrengthBar,
                minPasswordLength: minPasswordLength
            }),
            /*#__PURE__*/ jsx(FormControlLabel, {
                sx: {
                    marginBottom: "36px"
                },
                control: /*#__PURE__*/ jsx(Checkbox$1, {
                    color: "primary",
                    name: "logoutAllDevices",
                    checked: isChecked
                }),
                onChange: handleChange,
                label: t("components.common.logoutAllDevices", "Also log out from all currently logged-in devices")
            })
        ]
    });
};

var initialState = {
    step: "",
    parentUrl: "",
    brands: []
};
var shareSlice = createSlice({
    name: "share",
    initialState: initialState,
    reducers: {
        start: function(state, action) {
            if (action.payload.brands.length) {
                state.brands = action.payload.brands;
                state.parentUrl = action.payload.parentUrl;
                if (action.payload.brands.length === 1) {
                    state.recastReferrer = {
                        id: action.payload.brands[0].id,
                        name: action.payload.brands[0].name
                    };
                    state.step = "share-link";
                } else {
                    state.step = "select-brand";
                }
            }
        },
        exit: function() {
            return initialState;
        },
        goToSelectBrand: function(state) {
            state.recastReferrer = undefined;
            state.step = "select-brand";
        },
        goToShareLink: function(state, action) {
            state.recastReferrer = {
                id: action.payload.id,
                name: action.payload.name
            };
            state.step = "share-link";
        }
    }
});
var _shareSlice_actions = shareSlice.actions;
_shareSlice_actions.start; var exit = _shareSlice_actions.exit, goToSelectBrand = _shareSlice_actions.goToSelectBrand, goToShareLink = _shareSlice_actions.goToShareLink;
shareSlice.reducer;

var ShareHeader = function() {
    var t = useTranslation().t;
    return /*#__PURE__*/ jsx(ModalHeader, {
        title: t("components.share.header.title", "Share & Earn"),
        icon: /*#__PURE__*/ jsx(Icon$1, {
            sx: function(theme) {
                return {
                    fontSize: 64,
                    color: theme.palette.common.black
                };
            },
            component: Share$1
        })
    });
};

var ShareBottomAction = function(param) {
    var step = param.step, dispatch = param.dispatch;
    var t = useTranslation().t;
    var onModalButtonClick = function() {
        switch(step){
            case "select-brand":
                dispatch(exit());
                return;
            case "share-link":
                dispatch(goToSelectBrand());
                return;
        }
    };
    var getButtonText = function() {
        switch(step){
            case "select-brand":
                return t("components.share.bottomAction.notNow", "Not now");
            case "share-link":
                return t("components.share.bottomAction.back", "Back");
        }
    };
    return /*#__PURE__*/ jsx(ModalActions, {
        children: /*#__PURE__*/ jsx(ModalButton, {
            onClick: onModalButtonClick,
            children: getButtonText()
        })
    });
};

var SelectBrand = function(param) {
    var brands = param.brands, dispatch = param.dispatch;
    var t = useTranslation().t;
    var onBrandClick = function(brand) {
        dispatch(goToShareLink(brand));
    };
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                sx: function(theme) {
                    return {
                        textAlign: "center",
                        color: theme.palette.text.secondary
                    };
                },
                children: t("components.share.selectBrand.shareAs", "Share as:")
            }),
            /*#__PURE__*/ jsx(List, {
                sx: {
                    padding: "6px 0 0 0"
                },
                children: brands.map(function(brand) {
                    return /*#__PURE__*/ jsx(ListItem, {
                        sx: function(theme) {
                            return {
                                marginBottom: "4px",
                                padding: "0",
                                border: "1px solid ".concat(theme.palette.grey[200]),
                                borderRadius: "4px",
                                backgroundColor: "transparent",
                                "&:hover": {
                                    backgroundColor: theme.palette.action.hover
                                }
                            };
                        },
                        children: /*#__PURE__*/ jsxs(ListItemButton, {
                            onClick: function() {
                                return onBrandClick(brand);
                            },
                            disableRipple: true,
                            sx: {
                                padding: "16px",
                                "&:hover": {
                                    backgroundColor: "transparent"
                                }
                            },
                            children: [
                                /*#__PURE__*/ jsx(ListItemAvatar, {
                                    children: /*#__PURE__*/ jsx(Avatar$1, {
                                        alt: "".concat(brand.name, " avatar"),
                                        src: brand.avatarImage,
                                        sx: {
                                            height: "48px",
                                            width: "48px",
                                            marginRight: "12px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ jsx(ListItemText, {
                                    sx: {
                                        margin: 0
                                    },
                                    primary: /*#__PURE__*/ jsx(Typography, {
                                        variant: "h6",
                                        children: brand.name
                                    }),
                                    secondary: /*#__PURE__*/ jsx(Typography, {
                                        variant: "caption",
                                        sx: function(theme) {
                                            return {
                                                color: theme.palette.text.secondary
                                            };
                                        },
                                        children: t("components.share.selectBrand.brand", "Brand")
                                    })
                                })
                            ]
                        })
                    }, "brand-".concat(brand.id));
                })
            })
        ]
    });
};

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var ShareLink = function(param) {
    var learnMoreUrl = param.learnMoreUrl, recastReferrer = param.recastReferrer, onCopyClick = param.onCopyClick;
    var t = useTranslation().t;
    var _useState = _sliced_to_array(useState(false), 2), isLinkCopied = _useState[0], setIsLinkCopied = _useState[1];
    var handleCopyClick = function(id) {
        onCopyClick(id);
        setIsLinkCopied(true);
    };
    return /*#__PURE__*/ jsxs(Box, {
        sx: {
            marginTop: "12px"
        },
        children: [
            /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                sx: {
                    textAlign: "center"
                },
                children: recastReferrer === null || recastReferrer === void 0 ? void 0 : recastReferrer.name
            }),
            /*#__PURE__*/ jsx(Typography, {
                variant: "body2",
                sx: {
                    textAlign: "center",
                    margin: "16px 0 4px 0"
                },
                children: /*#__PURE__*/ jsxs(Trans, {
                    children: [
                        "Share this link on your social channels ",
                        /*#__PURE__*/ jsx("br", {}),
                        " and earn a percentage of the first purchase made by anyone who uses it."
                    ]
                }, "components.share.shareLink.earnAPercentage")
            }),
            /*#__PURE__*/ jsxs(Typography, {
                variant: "body2",
                sx: function(theme) {
                    return {
                        color: theme.palette.text.secondary,
                        textAlign: "center"
                    };
                },
                children: [
                    t("components.share.shareLink.setByVendor", "Earnings are based on a percentage of the purchase price set by the vendor."),
                    " ",
                    /*#__PURE__*/ jsx(Link, {
                        href: learnMoreUrl,
                        target: "_blank",
                        rel: "noopener",
                        children: t("components.share.shareLink.learnMore", "Learn more")
                    })
                ]
            }),
            (recastReferrer === null || recastReferrer === void 0 ? void 0 : recastReferrer.id) && /*#__PURE__*/ jsxs(Button$1, {
                variant: "contained",
                sx: function(theme) {
                    return {
                        width: "100%",
                        marginTop: "24px",
                        color: theme.palette.earn.contrastText,
                        backgroundColor: theme.palette.earn.main,
                        "&:hover": {
                            backgroundColor: theme.palette.earn.dark
                        }
                    };
                },
                onClick: function() {
                    return handleCopyClick(recastReferrer.id);
                },
                children: [
                    /*#__PURE__*/ jsx(FileCopy, {
                        sx: function(theme) {
                            return {
                                color: theme.palette.earn.contrastText,
                                fontSize: "14px",
                                marginRight: "8px"
                            };
                        }
                    }),
                    isLinkCopied ? /*#__PURE__*/ jsx(Typography, {
                        variant: "button",
                        sx: {
                            fontWeight: 600
                        },
                        children: t("components.share.shareLink.copied", "Copied")
                    }) : /*#__PURE__*/ jsx(Typography, {
                        variant: "button",
                        sx: {
                            fontWeight: 600
                        },
                        children: t("components.share.shareLink.copyLink", "Copy Link")
                    })
                ]
            })
        ]
    });
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var Share = function(param) {
    var state = param.state, learnMoreUrl = param.learnMoreUrl, dispatch = param.dispatch;
    var step = state.step, brands = state.brands, parentUrl = state.parentUrl, recastReferrer = state.recastReferrer;
    if (step === "") {
        return null;
    }
    var onCopyLinkClick = function() {
        var _ref = _async_to_generator(function(id) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            navigator.clipboard.writeText("".concat(parentUrl.split("?")[0], "?recastReferrer=").concat(id))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onCopyLinkClick(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var getModalContent = function(step, brands, learnMoreUrl, recastReferrer) {
        switch(step){
            case "select-brand":
                return /*#__PURE__*/ jsx(SelectBrand, {
                    brands: brands,
                    dispatch: dispatch
                });
            case "share-link":
                return /*#__PURE__*/ jsx(ShareLink, {
                    learnMoreUrl: learnMoreUrl,
                    recastReferrer: recastReferrer,
                    onCopyClick: onCopyLinkClick
                });
        }
    };
    return /*#__PURE__*/ jsxs(ThemeProvider, {
        theme: accountTheme,
        children: [
            /*#__PURE__*/ jsx(CssBaseline, {
                enableColorScheme: true
            }),
            /*#__PURE__*/ jsxs(Modal, {
                variant: "light",
                sx: {
                    minHeight: "640px"
                },
                children: [
                    /*#__PURE__*/ jsx(ShareHeader, {}),
                    /*#__PURE__*/ jsx(ModalContent, {
                        children: getModalContent(step, brands, learnMoreUrl, recastReferrer)
                    }),
                    /*#__PURE__*/ jsx(ShareBottomAction, {
                        step: step,
                        dispatch: dispatch
                    })
                ]
            })
        ]
    });
};

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var shareActions = _object_spread({}, shareSlice.actions);

export { BarChart, ChangePasswordForm, ChannelPassCard, ChannelPassSection, ChannelPassState, ChannelPassTicket, Comments, DoughnutChart, GenericError, GenericErrorContentContainer, GeoBubbleChart, GeoPercentageChart, LiveChat, Purchase, Report, Share, Signup, TopUp, followActions, followSlice, purchaseActions, purchaseSlice, purchaseStorage, reportActions, reportSlice, shareActions, shareSlice, signupActions, signupApiErrorMiddleware, signupSlice, socialSignupCallback, topUpActions, topUpSlice, useChatChannel, useChatClient };
